import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useContext,
} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import FilterModal from "../../../components/Modal/FilterModal";
import Select from "react-select";
import SalesCard from "../../../components/SalesCard/SalesCard";
import { Closed, Noimage } from "../../../common/imagePath";
import EditTax from "../../../components/Modal/EditTax";

import { Badge } from "react-bootstrap";
import SuspendedConfirmation from "../../../components/Modal/SuspendedConfirmation";
import { uploadAWS } from "../../../common/AWSHelper";
import { AppContext } from "../../../context/AppContext";
import DatePicker from "react-datepicker";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import "react-datepicker/dist/react-datepicker.css";
import { isEqual } from "lodash";
import loadingimage from "../../../assets/img/loading-svg.svg";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_SALES,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE,
} from "../../../common/Constant";
import FileInput from "../../../components/FormControls/FileInput";
import StoreAccountPaymentModal from "../../../components/Modal/StoreAccountPaymentModal";

import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import CancelConfirmation from "../../../components/Modal/CancelConfirmation";
import SalesGiftCard from "../../../components/Modal/SalesGiftCard";
import Moment from "moment";
import SaleCompleteModal from "../../../components/Modal/SaleCompleteModal";
import ItemsDetailsModal from "../../../components/Modal/ItemsDetailsModal";
import { number } from "yup";
import { CListGroup } from "@coreui/react";
import { type } from "jquery";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import moment from "moment";
import { checkUserPermission } from "../../../common/UserPermission";
import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import HistoryModel from "../../../components/Modal/HistoryModel";
import MissingTransaction from "../../../components/Modal/MissingTransaction";
import CurrencySymbols from "../../../common/CurrencySymbol";
import CommonPreviousInvoiceComponent from "../../../components/Account/CommonPreviousInvoiceComponent";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";
import DeleteConfirmation from "../../../components/Modal/DeleteConfirmation";
import CustomerConfirm from "../../../components/Modal/CustomerConfirm";

const ManageSale = () => {
  const paramObject = useParams();
  const {
    missingtransaction,
    missingtransactions,
    isTax,
    SaleQuickPermision,
    AllowQBSync,
    enableAOSForItemAndVariation
  } = useContext(AppContext);

  useEffect(() => {
    if (paramObject.id > 0) {
      let reqob = {
        Module: "sales",
        Id: paramObject.id,
      };
      missingtransaction(reqob);
    }
  }, []);
  let updatedData = [];
  let updatePay = [];
  let originalPass = [];
  let matchedTagOptions;
  let outputMatchedOptions;
  let tagForMatching;
  const qtyInputRef = useRef(null);
  const searchItemInputRef = useRef(null);

  const { CurrencySymbol, FractionDigits } = useContext(AppContext);

  let PERMISSION_DELETE = "sales-batch-delete";
  let PERMISSION_EDIT = "/manage-sales/:id";
  let PERMISSION_ADD = "/manage-sales";
  let PERMISSION_RECEIVEPAYMENT = "/receive-payment";
  let PERMISSION_RECEIPT = "/sales-receipt/:id";
  let PERMISSION_CUSTOMER_CUSTOM_INVOICE = "";
  let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
  let PERMISSION_DELIVERIES = "/deliveries";
  let PERMISSION_BATCHSALES = "/batch-sales";
  let PERMISSION_CUSTOMFIELD = "/custom-field-sales-configuration";
  let PERMISSION_ALLRECEIPT = "/sales-all-receipt";
  let PERMISSION_SALE_CUSTOMREPORT = "/custom_search_report";

  const totalRef = useRef(0);
  const subtotalRef = useRef(0);
  const token = localStorage.getItem("Token") || "";
  const Clone = localStorage.getItem("Clone")
    ? localStorage.getItem("Clone")
    : 0;
  const [isReadOnly, setIsReadOnly] = useState(true);
  // const { mailingAddress, setMailingAddress } = useContext(Appcontext);
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedcustomer, setSelectedCustomer] = useState("");
  const [custoptions, setCustOptions] = useState([]);
  const [deliveryMethodOption, setDeliveryMethodOption] = useState([]);
  const [deliveryMethodId, setDeliveryMethodId] = useState(0);
  const [AmountPaid, setAmountPaid] = useState(0);
   console.log(AmountPaid , "Data74777")
  const [selectedOption, setSelectedOption] = useState("");
  const [statenew, setStateNew] = useState([]);

  console.log(statenew, "check value of statenew")

  const [quickbookid, setQuickBookId] = useState(0);
  const [coustomerid, setcoustomerid] = useState(0);
  console.log(coustomerid, "check coustomerid")
  // const [netAmount,setNetAmount]=useState(0)
  const [entireSaleDiscount, setEntireSaleDiscount] = useState(0);
  const [discountInputValue, setDiscountInputValue] = useState(0);
  const [shippingaddress, setshippingaddress] = useState("");
  const [amountToSubtract, setAmountToSubtract] = useState(0);
  const [modal, setModal] = useState(false);
  const [method, setMethod] = useState(["Cash"]);
  const [dueAmount, setDueAmount] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [payments, setPayments] = useState([]); // to keep track of all the payments made
  const [paymentCurrency, setPaymentCurrency] = useState("USD");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [deletedPaymentIndex, setDeletedPaymentIndex] = useState(-1);
  const [deletedPaymentIndexTax, setDeletedPaymentIndexTax] = useState(-1);
  const [select, setSelect] = useState("Sale");
  const [customFileUrl, setCustomFileUrl] = useState("");
  const [customFields, setCustomFields] = useState([]);
  //const [customFieldSalesValues, setcustomFieldSalesValues] = useState([]);
  const [changeImagename, setChangeImagename] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [selectedCustomFile, setSelectedCustomFile] = useState("");
  const [selectedPayment, setSelectedPayment] = useState({
    id: 1,
    name: "Cash",
  });
  const [selectedLocation, setSelectedLocation] = useState(0);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [customerAddress, setCustomerAddress] = useState();
  const [customerEmail, setCustomerEmail] = useState();
  const [comment, setComment] = useState("");
  const [saletype, setSaletype] = useState([]);
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  const [saleTypeId, setSaleTypeId] = useState(1);
  const [selectedSaleOption, setselectedSaleOption] = useState("Sale");
  const [selectedDropDownValue, setSelectDropDownValue] = useState(1);
  const [taxXml, setTaxXml] = useState([]);
  const [taxdata, settaxdata] = useState([]);
  const [totaltaxs, settotaltaxs] = useState(0);

  const [xmltax, setXmlTax] = useState([]);
  const [reason, setReason] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [clickedValue, setClickedValue] = useState(0);
  const [changeCustomerValueByTerms, setChangeCustomerValueByTerms] =
    useState(null);
  const [customerName, setCustomerName] = useState();
  const [customerId, setcustomerId] = useState("");
  const [paidAmount, setPaidAmount] = useState("");
  const [isStoreAccountPaymentFlag, setIsStoreAccountPaymentFlag] = useState(0);
  const [isStoreAccountPayment, setIsStoreAccountPayment] = useState(false);
  const [runApi, setRunApi] = useState(false);
  const [showHistoryList, setShowHistoryList] = useState(false);

  const [totalQuantity, setTotalQuantity] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [isEcommerce, setIsEcommerce] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryForSearch, setSelectedCategoryForSearch] =
    useState(null);

  const [selectedPriceForSale, setSelectedPriceForSale] = useState(3);

  console.log(selectedOption, "selectedOption");

  const [selectedTirePriceForSale, setSelectedTirePriceForSale] =
    useState(null);
  const [defaultSellingTierPriceList, setDefaultSellingTierPriceList] =
    useState([]);
  const [tireObject, setTireObject] = useState([]);
  // console.log(tireObject, "1542kjjj");
  const [custtierId, setCusttierId] = useState(0);
  // console.log(custtierId, "custtier123");

  const [commonDiscount, setCommonDiscount] = useState(0);
  const [discountPrice, setDiscountPrice] = useState(0);
  const [itemsDiscountPrice, setItemsDiscountPrice] = useState(0);
  const [itemTotal, setItemTotal] = useState(0);
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);
  const [accountSaleData, setAccountSaleData] = useState({
    TermsID: 1,
    InvoiceMessage: "",
    InvoiceNumber: "",
    InvoiceStatement: "",
    DueDate: moment().format("YYYY-MM-DD"),
    Attachment: "",
    InvoiceDate: moment().format("YYYY-MM-DD"),
  });
  console.log(accountSaleData, "fdjhsb check");
  console.log(shippingaddress, "shippingaddresserofgdofdk");

  console.log(typeof commonDiscount, "commonDiscount");
  console.log(typeof commonDiscount, "commonDiscount");
  const [tagsValue, setTagsValue] = useState([]);
  const [selectedtags, setSelectedtags] = useState("");
  const [term, setTerm] = useState([0]);
  console.log(term[0], "termterm");
  const [tag, setTag] = useState([]);
  const [todayDate, setTodayDate] = useState(moment().format("YYYY-MM-DD"));
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [changeFileName, setChangeFileName] = useState(false);
  const [FileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [checkboxes, setCheckboxes] = useState(0);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [salesDeliveryData, setSalesDeliveryData] = useState({});
  const [selectedSalesDeliveryData, setSelectedSalesDeliveryData] = useState();

  const [deliveryFees, setDeliveryFees] = useState(0);
  const [netAmountValue, setNetAmountValue] = useState(0);
  const [isChangedData, setIsChangedData] = useState(false);

  const [showEditStatement, setShowEditStatement] = useState(false);
  const [showEditInvoice, setShowEditInvoice] = useState(false);
  const [salequickbookid, setSaleQuickbookId] = useState(0);
  const [saleIsVoid, setSaleIsVoid] = useState(0);
  console.log(defaultSellingTierPriceList.ID, "15426532");
  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const [isAccordionOpenOne, setAccordionOpenOne] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };
  const [restirctedit, setRestrictEdit] = useState(0);

  const toggleAccordionOne = () => {
    setAccordionOpenOne(!isAccordionOpenOne);
  };
  console.log(selectedSalesDeliveryData, "selectedSalesDeliveryData");
  console.log(salesDeliveryData, "salesDeliveryData");

  console.log(startDate, "startDate123");
  //////

  const [newPriceToAll, setNewPriceToAll] = useState("");
  const [newQtyToAll, setNewQtyToAll] = useState("");

  //LocalStorage
  // const[localValues,setLocalValues] = useState();
  const [localValues, setLocalValues] = useState({});
  const [amount, setAmount] = useState(0);
  const [scrollPosition, setPosition] = useState(0);
  // const [netAmountVal,setNetAmountVal] = useState("0.00")
  const [discountType, setDiscountType] = useState("percent"); // 'amount' or 'percent'
  const [itemsdiscountType, setItemsDiscountType] = useState("percent"); // 'amount' or 'percent'
  const [totalDiscountAppliedForItems, setTotalDiscountAppliedForItems] =
    useState(0); // 'amount' or 'percent'

  console.log(accountSaleData, "invoice statemont");
  console.log(FileUrl, fileName, "FileUrl");
  console.log(statenew, "taxXml==>");

  // console.log("Clone-->", Clone);
  // const [accountSaleData, setAccountSaleData] = useState();
  // Terms Group DropDown
  let termOptions = [];
  const termDropDown = term.map((u, i) => {
    termOptions[i] = {
      label: u.Name,
      value: u.ID,
      actualValue: u.Value,
      QuickBookID: u.QuickBookID,
    };
  });

  console.log(statenew, "statenew selected data");
  // Tax Group DropDown
  let tagOptions = [];
  const tagDropDown = tag.map((u, i) => {
    tagOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  //LSTotalAmount
  let LStotalAmt;

  if (paramObject.id === undefined) {
    LStotalAmt = JSON.parse(localStorage.getItem("saleDraft"));
    LStotalAmt = LStotalAmt?.inputDropdown?.reduce((acc, cur) => {
      acc += +cur.Total;
      return acc;
    }, 0);
  }
  console.log(LStotalAmt, typeof LStotalAmt, "LStotalAmt196");
  let LSTQty;
  if (paramObject.id === undefined) {
    LSTQty = JSON.parse(localStorage.getItem("saleDraft"));
    LSTQty = LSTQty?.inputDropdown?.reduce((acc, cur) => {
      acc += +cur.itemquantity;
      return acc;
    }, 0);
    console.log("LSTQty", LSTQty);
  }

  console.log(LSTQty, "LSTQty123");

  // Calculate the total tax amount
  let totalTaxAmount = 0;
  //let totaltaxs = 0

  console.log(typeof deliveryFees, "deliveryFees");
  console.log(taxXml, "taxXml186");
  console.log(totaltaxs, "totalTaxAmount");

  function calculateItemTax(total, taxPercent, stateLength) {
    return (total * taxPercent) / 100 / stateLength;
  }
  const [uniqueTaxItemCount, setUniqueTaxItemCount] = useState([]);
  function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
    var a = (total * parseInt(taxPercent)) / 100;
    console.log(
      total,
      taxPercent,
      a / (1 + parseInt(uniqueTaxItemCount)),
      1 + parseInt(uniqueTaxItemCount),
      "tax194"
    );
    return (
      // (total * parseInt(taxPercent)) / 100 / (1 + parseInt(uniqueTaxItemCount))
      (total * parseInt(taxPercent)) / 100
    );
  }
  function calculateDeliveryTax(total, taxPercent) {
    console.log(total, taxPercent, "tax194");
    return (total * parseInt(taxPercent)) / 100;
  }
  useEffect(() => {
    const uniqueTaxItemIds = [
      ...new Set(
        taxXml
          ?.filter((item) => item?.TaxItemID !== null && item?.TaxItemID !== "")
          .map((item) => item.TaxItemID)
      ),
    ];
    console.log(uniqueTaxItemIds, "uniqueTaxItemIds");
    const uniqueTaxItemCount = uniqueTaxItemIds.length;
    setUniqueTaxItemCount(uniqueTaxItemCount);
    calculateItemTax();
    calculateOtherTax();
    calculateDeliveryTax();
  }, [statenew, taxXml, totalRef]);
  console.log(taxXml, "tax194");
  console.log(totalRef.current, "totalRef.current");

   const handleFetchCustAOC = (CustomerID, ItemID, VarID) => {
    if (CustomerID > 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/customerAvgAoc?CustomerID=${CustomerID}&ItemID=${ItemID}&VarID=${VarID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const responseItem = res.data.ResponseData?.[0];
          if (responseItem) {
            setStateNew((prev) => {
              return prev.map((cartItem) => {
                if (
                  cartItem.ItemId === responseItem.ItemID &&
                  cartItem.VariationId === responseItem.ItemVariationID
                ) {
                  return {
                    ...cartItem,
                    AvgUnitPrice: responseItem.AvgUnitPrice,
                    AvgQuantity: responseItem.AvgQuantity,
                  };
                }
                return cartItem;
              });
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching Avg AOC:", err);
        });
    }
  };

  // Track AOS panel open/close state by unique key (ItemId + VariationId)
const [aosOpenByItem, setAosOpenByItem] = useState({});
const [priceOpenByItem, setPriceOpenByItem] = useState({});

const itemKey = (item) => `${item.ItemId}_${item.VariationId}`;

const openAosFor = (cat) => {
  const key = itemKey(cat);
  // Call API to fetch AOS if not already loaded
  handleFetchCustAOC(customerId, cat.ItemId, cat.VariationId);
  setAosOpenByItem((prev) => ({ ...prev, [key]: true }));
};

const togglePriceFor = (cat) => {
  const key = itemKey(cat);
  setPriceOpenByItem((prev) => ({
    ...prev,
    [key]: !prev[key],
  }));
};


  useEffect(() => {
    console.log(typeof isTax, isTax == "true", "setIsTax", isTax);
    if (isTax == "true") {
      let result = [];
      let sum = 0;

      console.log(typeof isTax, isTax == true, "setIsTax1212", isTax);

      statenew.forEach((item) => {
        let calculatedTax = 0;
        let total = parseFloat(item.Total);

        if (item.taxes > 0) {
          if (item.GroupCumulative === 1) {
            for (let i = 1; i <= item.taxes; i++) {
              const taxVal = parseFloat(item[`TaxGroup${i}Value`]);
              if (taxVal) {
                calculatedTax += (total * taxVal) / 100;
                total += (total * taxVal) / 100;
              }
            }
          } else {
            const taxSummation = [];
            for (let i = 1; i <= item.taxes; i++) {
              const taxVal = item[`TaxGroup${i}Value`];
              if (taxVal) {
                taxSummation.push(parseFloat(taxVal));
              }
            }

            console.log(taxSummation, "41014", item);
            const totalTax = taxSummation.reduce(
              (acc, taxVal) => acc + taxVal,
              0
            );
            calculatedTax = (item.Total * totalTax) / 100;
          }
          sum += calculatedTax;
          item.finaltax = item.Total + calculatedTax;
          item.LineTax = calculatedTax;

          // Capture TaxName and TaxVal for reporting
          for (let i = 1; i <= item.taxes; i++) {
            const taxName = item[`TaxGroup${i}`];
            const taxprice = item[`TaxGroup${i}Value`];
            const taxVal = (item.Total * taxprice) / 100;
            if (taxName && taxVal) {
              result.push({
                TaxName: taxName,
                TaxVal: taxVal,
              });
            }
          }
        } else {
          // Additional tax calculation for TaxVal1 to TaxVal5
          if (item.Cummalative === 1) {
            for (let i = 1; i <= 5; i++) {
              const taxVal = parseFloat(item[`TaxVal${i}`]);
              if (taxVal) {
                calculatedTax += (total * taxVal) / 100;
                total += (total * taxVal) / 100;
              }
            }
          } else {
            const taxSummation = [
              item.TaxVal1,
              item.TaxVal2,
              item.TaxVal3,
              item.TaxVal4,
              item.TaxVal5,
            ]
              .filter((taxVal) => taxVal !== null && taxVal !== undefined)
              .map((taxVal) => parseFloat(taxVal));

            const totalTax = taxSummation.reduce(
              (acc, taxVal) => acc + taxVal,
              0
            );
            calculatedTax = (item.Total * totalTax) / 100;
          }

          sum += calculatedTax;
          item.finaltax = item.Total + calculatedTax;
          item.LineTax = calculatedTax;

          // Capture TaxName and TaxVal for reporting
          for (let i = 1; i <= 5; i++) {
            const taxName = item[`TaxName${i}`];
            const taxprice = item[`TaxVal${i}`];
            const taxVal = (item.Total * taxprice) / 100;
            if (taxName && taxVal) {
              result.push({
                TaxName: taxName,
                TaxVal: taxVal,
              });
            }
          }
        }
      });

      // Set the total tax value
      settotaltaxs(sum);

      //console.log(taxdata,result, "8585847");

      const results = result.reduce((acc, current) => {
        const existingTax = acc.find(
          (item) => item.TaxName === current.TaxName
        );

        if (existingTax) {
          existingTax.TaxVal += current.TaxVal;
        } else {
          acc.push({ TaxName: current.TaxName, TaxVal: current.TaxVal });
        }

        return acc;
      }, []);

      settaxdata(results);
    }

    const totalDiscountAmount = statenew.reduce((acc, item) => {
      const {
        Price: UnitPrice,
        itemquantity,
        itemdiscount,
        DiscountType,
      } = item;

      const parsedDiscount = parseFloat(itemdiscount) || 0;
      let discount = 0;

      if (DiscountType === "amount") {
        discount = parsedDiscount;
      } else {
        const itemTotal = UnitPrice * itemquantity;
        discount = itemTotal * (parsedDiscount / 100); // This is the correct discount amount
      }

      return acc + discount;
    }, 0);

    setTotalDiscountAppliedForItems(totalDiscountAmount);
  }, [statenew]);




  

  taxXml?.forEach((tax) => {
    if (tax.type === "globalTax") {
      totalTaxAmount += calculateOtherTax(
        // totalRef.current,
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent,
        statenew.length,
        taxXml
      );
      console.log(totalTaxAmount, LStotalAmt, "totalTaxAmount237");
    } else if (tax.type === "itemTax") {
      totalTaxAmount += calculateItemTax(
        // totalRef.current,
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent,
        statenew.length
      );
    } else if (tax.type === "deliveryTax") {
      totalTaxAmount += calculateDeliveryTax(
        // totalRef.current
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent
      );
    }
  });
  console.log(deliveryFees,isNaN(deliveryFees),"deliveryFeescheck");

  let netAmount = (
    paramObject.id !== undefined
      ? //parseFloat(isNaN(totalRef.current) ? 0 : totalRef.current) +
        parseFloat(isNaN(subtotalRef.current) ? 0 : subtotalRef.current) +
        parseFloat(isNaN(totaltaxs) ? 0 : totaltaxs) +
        parseFloat(isNaN(deliveryFees) ? 0 : deliveryFees == '' ? 0 : deliveryFees) -
        (discountType === "percent" ? discountPrice : commonDiscount)
      : parseFloat(
          isNaN(LStotalAmt - commonDiscount)
            ? 0
            : LStotalAmt -
                (discountType === "percent" ? discountPrice : commonDiscount)
        ) +
        parseFloat(isNaN(totaltaxs) ? 0 : totaltaxs) +
        parseFloat(isNaN(deliveryFees) ? 0 : deliveryFees)
  ).toFixed(2);

  let netSubAmount = (
    paramObject.id === undefined
      ? parseFloat(isNaN(LStotalAmt) ? 0 : LStotalAmt)
      : parseFloat(isNaN(subtotalRef.current) ? 0 : subtotalRef.current)
  )
    //  + parseFloat(isNaN(totalTaxAmount) ? 0 : totalTaxAmount)
    .toFixed(2);

  console.log(totalTaxAmount, "totalTaxAmount");
  console.log(
    paramObject.id > 0 && netAmount < Number(AmountPaid),
    "netAmount",
    AmountPaid
  );
  console.log(netSubAmount, "netSubAmount");
  console.log(totalRef.current, "totalRef.current");
  console.log(LStotalAmt, "LStotalAmt");
  console.log(deliveryFees, "deliveryFeesAmt");
  console.log(totaltaxs, taxdata, "8585");
  // useEffect(()=>{

  //   const savedData = localStorage.getItem("saleDraft") || "";
  //   if (savedData && paramObject.id==undefined) {

  //     const parsedData = JSON.parse(savedData);
  //     console.log(parsedData?.subTotal, "parsedData?.subTotal")
  //     netSubAmount = parsedData?.subTotal
  //   }

  //   const x = { ...localValues, subTotal: netSubAmount,  Total: netAmount};
  //   setLocalValues(x);
  //   localStorage.setItem("saleDraft", JSON.stringify(x))

  // },[netSubAmount])

  console.log(deliveryFees, totalTaxAmount, totalRef.current, "456");
  const paymentTypeMap = {};
  paymentTypeDropdown.forEach((paymentType) => {
    paymentTypeMap[paymentType.ID] = paymentType.Paymenttypename;
  });

  // if(paramObject.id === undefined){
  //   console.log(paramObject, "setdata and get data paramObject")
  // } else{
  //   console.log(paramObject, "no set/Get paramObject")
  // }
  let navigate = useNavigate();
  const Id = localStorage.getItem("ID") || "";
  const loginUserId = localStorage.getItem("ID") || "";
  const Location = localStorage.getItem("Location") || "";

  const callback = (payloads) => {
    // console.log("callback allData => ", payload);

    let payload = payloads.map((item) => {
      let matchingTaxes = item?.taxes?.filter(
        (tax) => tax.Itemid === item.ItemId
      );

      matchingTaxes?.forEach((tax, index) => {
        item[`TaxGroup${index + 1}`] = tax.Name;
        item[`TaxGroup${index + 1}Value`] = tax.Percent;
        item.taxes = matchingTaxes.length;
        item.GroupCumulative = tax.Cumulative;
      });

      return item;
    });

    const mappedReceivingItems = payload.map((item) => {
      const mappedItem = {
        TaxID: item.TaxId,
        TaxName: item.TaxName,
        TaxPercent: item.TaxPercent,
        type: item.TaxType,
        DiscountType: "percent",
        // TaxItemID: parseInt(item.TaxItemID),
        // TaxVariationID: parseInt(item.TaxVariationID),
      };
      return mappedItem;
    });

    //     let result = [];
    // let sum = 0;

    // for (let i = 1; i <= 5; i++) {
    //     let newobj = {
    //         [`TaxName${i}`]: payload[0][`TaxName${i}`]
    //     };
    //     sum += payload[0][`TaxVal${i}`] !== null ? Number(payload[0][`TaxVal${i}`]) : 0;
    //     result.push(newobj);
    // }

    // console.log(result, sum);
    // settaxdata(result)

    // setTaxData(mappedReceivingItems);
    const filteredMappedItems = mappedReceivingItems.filter(
      (item) => item.TaxID !== undefined
    );

    // setTaxData(mappedReceivingItems);
    setTaxXml(filteredMappedItems);
    //setTaxXml(mappedReceivingItems);
    if (payload != undefined && payload.length > 0) {
      const newItem = {
        ...payload[0],
        itemquantity: 1,
        SaleItemQuickbookId: 0,
        Total: 0,
        mainIndex: statenew?.length + 1,
      };
      // console.log(statenew,"statenew===>")
      // console.log(newItem,"newItem===>")
      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.ItemId === newItem.ItemId &&
          item.VariationId === newItem.VariationId
      );
      // console.log(existingItemIndex, "itemindex");
      if (existingItemIndex != -1) {
        const existingItem = statenew[existingItemIndex];

        existingItem.itemquantity = Number(existingItem.itemquantity) + 1;
        // existingItem.Price =
        //   selectedPriceForSale == undefined
        //     ? existingItem.UnitPrice
        //     : selectedPriceForSale === 1
        //     ? existingItem.UnitPrice
        //     : selectedPriceForSale === 3
        //     ? existingItem.RecallPrice
        //     : tireObject == "Tier1"
        //     ? existingItem.Tier1
        //     : tireObject == "Tier2"
        //     ? existingItem.Tier2
        //     : tireObject == "Tier3"
        //     ? existingItem.Tier3
        //     : tireObject == "Tier4"
        //     ? existingItem.Tier4
        //     : tireObject == "Tier5"
        //     ? existingItem.Tier5
        //     : 0;

        existingItem.Total = calculateTotal(
          // selectedPriceForSale == undefined
          //   ? existingItem.UnitPrice
          //   : selectedPriceForSale === 1
          //   ? existingItem.UnitPrice
          //   : selectedPriceForSale === 3
          //   ? existingItem.RecallPrice
          //   : tireObject == "Tier1"
          //   ? existingItem.Tier1
          //   : tireObject == "Tier2"
          //   ? existingItem.Tier2
          //   : tireObject == "Tier3"
          //   ? existingItem.Tier3
          //   : tireObject == "Tier4"
          //   ? existingItem.Tier4
          //   : tireObject == "Tier5"
          //   ? existingItem.Tier5
          //   : 0,
          // existingItem.UnitPrice, extra
          existingItem.Price,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );
        console.log(
          existingItem.UnitPrice,
          "existingItem.UnitPrice getItem total"
        );
        console.log(
          existingItem.RecallPrice,
          "existingItem.RecallPrice getItem total"
        );
        console.log(existingItem.Total, "existingItem.Total getItem total");

        const updatedDataNew = [...statenew];
        updatedDataNew.splice(existingItemIndex, 1); // remove existing object 0104

        // updatedDataNew[existingItemIndex] = existingItem;  // 0104
        // console.log(updatedDataNew, "0520 1");
        console.log([existingItem, ...updatedDataNew], "0520 2");
        // setStateNew(updatedDataNew);
        setStateNew([existingItem, ...updatedDataNew]);
        console.log("updatedData in callback=>", updatedDataNew);
        setTimeout(() => {
          if (qtyInputRef.current) {
            qtyInputRef.current.focus();
            qtyInputRef.current.select();
          }
        }, 0);
        // updatedData = updatedDataNew;
        updatedData = [existingItem, ...updatedDataNew];
        // console.log("newItem = in callback=>", existingItem);   // 0104
      } else {
        newItem.Price =
          selectedPriceForSale == undefined
            ? newItem.UnitPrice
            : selectedPriceForSale === 1
            ? newItem.UnitPrice
            : selectedPriceForSale === 3
            ? newItem.RecallPrice
            : tireObject == "Tier1"
            ? newItem.Tier1
            : tireObject == "Tier2"
            ? newItem.Tier2
            : tireObject == "Tier3"
            ? newItem.Tier3
            : tireObject == "Tier4"
            ? newItem.Tier4
            : tireObject == "Tier5"
            ? newItem.Tier5
            : 0;
        newItem.Total = newItem.Price;

        console.log([newItem, ...statenew], "0520 2");
        setStateNew([newItem, ...statenew]);
        updatedData = statenew.concat(newItem); // add the new item to updatedData
        // console.log("newItem", newItem);
        setTimeout(() => {
          if (qtyInputRef.current) {
            qtyInputRef.current.focus();
            qtyInputRef.current.select();
          }
        }, 0);

//  handleFetchCustAOC(customerId, newItem.ItemId, newItem.VariationId);

  updatedData = statenew.concat(newItem);
      }
      console.log("newItem ==>", newItem);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    }

    payload = "";
    console.log("allData12", statenew);
  };

  const callbackaccount = (payload) => {
    console.log(payload, "payloads");
    // payload[0] = { ...payload[0], Amount: 0 };
    const existingItemIndex = statenew.findIndex(
      (item) => item?.ItemId == payload[0].ItemId
    );

    console.log(existingItemIndex, "indexing");

    if (existingItemIndex == -1) {
      setStateNew([...statenew, payload[0]]);
    }
  };

  // const callbackItemGrid = (payload) => {
  //   console.log("payload=>", payload); // Loop over each item in the payload array
  //   payload.forEach((newItem) => {
  //     const existingItemIndex = statenew.findIndex(
  //       (item) =>
  //         item.VariationId === newItem.VariationId &&
  //         item.ItemId === newItem.ItemId
  //     );

  //     if (existingItemIndex != -1) {
  //       const existingItem = statenew[existingItemIndex];
  //       existingItem.itemquantity =
  //         Number(existingItem.itemquantity) + newItem.newQty;
  //       existingItem.Price =
  //         selectedPriceForSale == undefined
  //           ? existingItem.UnitPrice
  //           : selectedPriceForSale === 1
  //           ? existingItem.UnitPrice
  //           : selectedPriceForSale === 3
  //           ? existingItem.RecallPrice
  //           : tireObject == "Tier1"
  //           ? existingItem.Tier1
  //           : tireObject == "Tier2"
  //           ? existingItem.Tier2
  //           : tireObject == "Tier3"
  //           ? existingItem.Tier3
  //           : tireObject == "Tier4"
  //           ? existingItem.Tier4
  //           : tireObject == "Tier5"
  //           ? existingItem.Tier5
  //           : 0;

  //       existingItem.Total = calculateTotal(
  //         selectedPriceForSale == undefined
  //           ? existingItem.UnitPrice
  //           : selectedPriceForSale === 1
  //           ? existingItem.UnitPrice
  //           : selectedPriceForSale === 3
  //           ? existingItem.RecallPrice
  //           : tireObject == "Tier1"
  //           ? existingItem.Tier1
  //           : tireObject == "Tier2"
  //           ? existingItem.Tier2
  //           : tireObject == "Tier3"
  //           ? existingItem.Tier3
  //           : tireObject == "Tier4"
  //           ? existingItem.Tier4
  //           : tireObject == "Tier5"
  //           ? existingItem.Tier5
  //           : 0,
  //         // existingItem.UnitPrice,
  //         existingItem.itemquantity,
  //         existingItem.itemdiscount
  //       );

  //       const updatedDataNew = [...statenew];
  //       updatedDataNew[existingItemIndex] = existingItem;
  //       setStateNew(updatedDataNew);
  //       console.log("updatedData in callback=>", updatedDataNew);
  //       updatedData = updatedDataNew;
  //       // console.log("newItem = in callback=>", existingItem);
  //     } else {
  //       newItem.itemdiscount = 0;
  //       newItem.DiscountType = "percent";
  //       newItem.ItemCurrentQuantity =
  //         newItem?.VariationId || newItem?.VariationId < 0
  //           ? newItem?.VariationQuantity
  //           : newItem?.Itemquantity;
  //       newItem.Price =
  //         selectedPriceForSale == undefined
  //           ? newItem.UnitPrice
  //           : selectedPriceForSale === 1
  //           ? newItem.UnitPrice
  //           : selectedPriceForSale === 3
  //           ? newItem.RecallPrice
  //           : tireObject == "Tier1"
  //           ? newItem.Tier1
  //           : tireObject == "Tier2"
  //           ? newItem.Tier2
  //           : tireObject == "Tier3"
  //           ? newItem.Tier3
  //           : tireObject == "Tier4"
  //           ? newItem.Tier4
  //           : tireObject == "Tier5"
  //           ? newItem.Tier5
  //           : 0;

  //       statenew.unshift({
  //         ...newItem,
  //         itemquantity: newItem.newQty,
  //         mainIndex: statenew?.length + 1,
  //         Total: calculateTotal(
  //           selectedPriceForSale == undefined
  //             ? newItem.UnitPrice
  //             : selectedPriceForSale === 1
  //             ? newItem.UnitPrice
  //             : selectedPriceForSale === 3
  //             ? newItem.RecallPrice
  //             : tireObject == "Tier1"
  //             ? newItem.Tier1
  //             : tireObject == "Tier2"
  //             ? newItem.Tier2
  //             : tireObject == "Tier3"
  //             ? newItem.Tier3
  //             : tireObject == "Tier4"
  //             ? newItem.Tier4
  //             : tireObject == "Tier5"
  //             ? newItem.Tier5
  //             : 0,
  //           newItem.newQty,
  //           0
  //         ),
  //       });

  //       updatedData = statenew.concat({
  //         ...newItem,
  //         itemquantity: newItem.newQty,
  //         Total: calculateTotal(newItem.Price, 1, 0),
  //         mainIndex: statenew?.length + 1,
  //       });

  //       // setStateNew([...statenew, newItem]);
  //       // updatedData = statenew.concat(newItem); // add the new item to updatedData
  //       // console.log("newItem", newItem);
  //     }
  //     console.log("newItem ==>", newItem);
  //     updateTotal(updatedData); // pass updatedData to updateTotal()
  //   });

  //   // setStateNew(updatedData);
  //   setStateNew([...statenew]);
  //   updateTotal(statenew);
  // };


  const callbackItemGrid = async (payload) => {
  console.log("payload=>", payload); // Loop over each item in the payload array
  payload.forEach((newItem) => {
    const existingItemIndex = statenew.findIndex(
      (item) =>
        item.VariationId === newItem.VariationId &&
        item.ItemId === newItem.ItemId
    );

    if (existingItemIndex != -1) {
      const existingItem = statenew[existingItemIndex];
      existingItem.itemquantity =
        Number(existingItem.itemquantity) + newItem.newQty;
      existingItem.Price =
        selectedPriceForSale == undefined
          ? existingItem.UnitPrice
          : selectedPriceForSale === 1
          ? existingItem.UnitPrice
          : selectedPriceForSale === 3
          ? existingItem.RecallPrice
          : tireObject == "Tier1"
          ? existingItem.Tier1
          : tireObject == "Tier2"
          ? existingItem.Tier2
          : tireObject == "Tier3"
          ? existingItem.Tier3
          : tireObject == "Tier4"
          ? existingItem.Tier4
          : tireObject == "Tier5"
          ? existingItem.Tier5
          : 0;

      existingItem.Total = calculateTotal(
        selectedPriceForSale == undefined
          ? existingItem.UnitPrice
          : selectedPriceForSale === 1
          ? existingItem.UnitPrice
          : selectedPriceForSale === 3
          ? existingItem.RecallPrice
          : tireObject == "Tier1"
          ? existingItem.Tier1
          : tireObject == "Tier2"
          ? existingItem.Tier2
          : tireObject == "Tier3"
          ? existingItem.Tier3
          : tireObject == "Tier4"
          ? existingItem.Tier4
          : tireObject == "Tier5"
          ? existingItem.Tier5
          : 0,
        // existingItem.UnitPrice,
        existingItem.itemquantity,
        existingItem.itemdiscount
      );

      const updatedDataNew = [...statenew];
      updatedDataNew[existingItemIndex] = existingItem;
      setStateNew(updatedDataNew);
      console.log("updatedData in callback=>", updatedDataNew);
      updatedData = updatedDataNew;
      // console.log("newItem = in callback=>", existingItem);
    } else {
      newItem.itemdiscount = 0;
      newItem.DiscountType = "percent";
      newItem.ItemCurrentQuantity =
        newItem?.VariationId || newItem?.VariationId < 0
          ? newItem?.VariationQuantity
          : newItem?.Itemquantity;
      newItem.Price =
        selectedPriceForSale == undefined
          ? newItem.UnitPrice
          : selectedPriceForSale === 1
          ? newItem.UnitPrice
          : selectedPriceForSale === 3
          ? newItem.RecallPrice
          : tireObject == "Tier1"
          ? newItem.Tier1
          : tireObject == "Tier2"
          ? newItem.Tier2
          : tireObject == "Tier3"
          ? newItem.Tier3
          : tireObject == "Tier4"
          ? newItem.Tier4
          : tireObject == "Tier5"
          ? newItem.Tier5
          : 0;

      statenew.unshift({
        ...newItem,
        itemquantity: newItem.newQty,
        mainIndex: statenew?.length + 1,
        Total: calculateTotal(
          selectedPriceForSale == undefined
            ? newItem.UnitPrice
            : selectedPriceForSale === 1
            ? newItem.UnitPrice
            : selectedPriceForSale === 3
            ? newItem.RecallPrice
            : tireObject == "Tier1"
            ? newItem.Tier1
            : tireObject == "Tier2"
            ? newItem.Tier2
            : tireObject == "Tier3"
            ? newItem.Tier3
            : tireObject == "Tier4"
            ? newItem.Tier4
            : tireObject == "Tier5"
            ? newItem.Tier5
            : 0,
          newItem.newQty,
          0
        ),
      });

      updatedData = statenew.concat({
        ...newItem,
        itemquantity: newItem.newQty,
        Total: calculateTotal(newItem.Price, 1, 0),
        mainIndex: statenew?.length + 1,
      });

      // setStateNew([...statenew, newItem]);
      // updatedData = statenew.concat(newItem); // add the new item to updatedData
      // console.log("newItem", newItem);
    }
    console.log("newItem ==>", newItem);
    updateTotal(updatedData); // pass updatedData to updateTotal()
  });

  // setStateNew(updatedData);
  setStateNew([...statenew]);
  updateTotal(statenew);

  // --- New: fetch and apply AOC for each payload item ---
  // for (const newItem of payload) {
  //   const aoc = await handleFetchCustAOC(customerId, newItem.ItemId, newItem.VariationId);
  //   if (aoc) {
  //     // Merge AOC into state (matching by ItemId / VariationId)
  //     setStateNew((prev) => {
  //       const cloned = [...prev];
  //       const idx = cloned.findIndex(
  //         (item) =>
  //           item.ItemId === aoc.ItemID &&
  //           item.VariationId === aoc.ItemVariationID
  //       );
  //       if (idx !== -1) {
  //         const updatedEntry = {
  //           ...cloned[idx],
  //           AvgUnitPrice: aoc.AvgUnitPrice,
  //           AvgQuantity: aoc.AvgQuantity,
  //         };
  //         cloned[idx] = updatedEntry;
  //       }
  //       updateTotal(cloned);
  //       return cloned;
  //     });
  //   }
  // }
};

  // For tax Calculationnn
  const [taxData, setTaxData] = useState([]);
  const [globalTaxData, setGlobalTaxData] = useState([]);

  const callbackHandleEditTax = (payload, index) => {
    console.log("tax function run  1122");

    if (paramObject.id === undefined) {
      const x = { ...localValues, taxArray: payload };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    } else {
    }
    setTaxData([...payload]);
    if (payload.some((item) => item.type === "globalTax")) {
      setGlobalTaxData(payload);
    }
  };
  const [filteredTaxData, setFilteredTaxData] = useState([]);
  console.log("taxData::>>", taxData);
  console.log("accountSaleData-->", accountSaleData);

  useEffect(() => {
    if (paramObject.id > 0 && globalTaxData.length == 0) {
      const filteredGlobalTaxData = taxData.filter(
        (el) => el.type === "globalTax"
      );
      setGlobalTaxData(filteredGlobalTaxData);
      console.log("filteredGlobalTaxData", filteredGlobalTaxData);
    }
    // filterTaxData();
    const areIDsEqual = statenew.every((item) =>
      taxData.some(
        (tax) =>
          item.ItemId === tax.TaxItemID &&
          item.VariationId === tax.TaxVariationID
      )
    );
    if (areIDsEqual) {
      if (taxData !== "") {
        const filteredTaxData = taxData.filter(
          (item) => item.type !== "globalTax"
        );
        setTaxXml(filteredTaxData);
      }
    } else {
      if (taxData !== "") {
        const hasGlobalTax = taxXml.some((item) => item.type === "globalTax");
        if (hasGlobalTax) {
          setTaxXml(taxData);
        } else {
          if (taxXml != "") {
            setTaxXml([...taxXml, ...globalTaxData]);
          } else {
            setTaxXml([...taxXml, ...taxData]);
          }
        }
      }
    }
  }, [taxData, statenew]);

  console.log("globalTaxData::>>", globalTaxData);

  const callback4 = (payload) => {
    setStateNew([...statenew, payload]);
    const giftcardvalue = payload.UnitPrice;
    totalRef.current = giftcardvalue;

    if (isNaN(giftcardvalue)) {
      giftcardvalue = 0;
    }

    Compairamount = giftcardvalue;
    setDueAmount(Compairamount);
  };
  console.log("taxXml", taxXml);

  const callbackaddress = (payload, mappedItem) => {
    console.log(payload, "payload465");
    setshippingaddress(payload);
  };

  console.log(selectedcustomer, "selectederfgddcustomer");
  // from delivery data common component
  const callbackDelivery = (payload, mappedItem) => {
    console.log(payload, "545454");
    const deliveryTaxAvailable = taxData.some(
      (item) => item.type === "deliveryTax"
    );

    const deliveryTaxXmlTaxAvailable = taxXml.some(
      (item) => item.type === "deliveryTax"
    );
    // console.log("deliveryTaxAvailable", deliveryTaxAvailable);
    if (deliveryTaxAvailable && deliveryTaxXmlTaxAvailable) {
      const updatedTaxData = taxData.filter(
        (item) => item.type !== "deliveryTax"
      );

      const updatedTaxXmldata = taxXml.filter(
        (item) => item.type != "deliveryTax"
      );
      // console.log("updatedTaxData::>>", updatedTaxData);
      setTaxData([...updatedTaxData, ...mappedItem]);
      setTaxXml([...updatedTaxXmldata, ...mappedItem]);
    } else {
      setTaxData([...taxData, ...mappedItem]);
      setTaxXml([...taxXml, ...mappedItem]);
    }
    if (payload == "CancelDelivery") {
      setSalesDeliveryData({});
      setDeliveryFees(0);

      setIsChangedData(true);
    } else {
      setDeliveryFees(payload.DeliveryFees);
      setSalesDeliveryData(payload);
      setDeliveryMethodId(payload.deliveryMethodId);
      console.log(payload, "payload");

      // netAmount = (
      //   parseFloat(totalRef.current) +
      //   parseFloat(totalTaxAmount) +
      //   parseFloat(payload.DeliveryFees ? payload.DeliveryFees : 0)
      // ).toFixed(2);

      let netAmount = (
        parseFloat(isNaN(totalRef.current) ? 0 : totalRef.current) +
        parseFloat(isNaN(totaltaxs) ? 0 : totaltaxs) +
        parseFloat(isNaN(payload.DeliveryFees) ? 0 : payload.DeliveryFees)
      ).toFixed(2);

      setNetAmountValue(netAmount);
      setIsChangedData(false);
    }
  };

  console.log(taxData, taxXml, "taxData554");

  function calculateTotal(
    UnitPrice,
    itemquantity,
    itemdiscount,
    DiscountType,
    IsLineEntryDisc = 0
  ) {
    console.log(
      UnitPrice,
      itemquantity,
      isNaN(itemdiscount),
      "UnitPrice, itemquantity, itemdiscount"
    );
    if (isNaN(UnitPrice)) {
      UnitPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    if (isNaN(IsLineEntryDisc)) {
      IsLineEntryDisc = 0;
      DiscountType = "";
    }

    // if(itemsdiscountType == 'amount' || DiscountType == 'amount'){
    if (
      IsLineEntryDisc == 1
        ? DiscountType == "amount"
        : itemsdiscountType == "amount"
    ) {
      const totalPrice = UnitPrice * itemquantity - itemdiscount;
      console.log(totalPrice, "totalprice123v");

      return totalPrice;
    } else {
      const totalPrice = UnitPrice * itemquantity * (1 - itemdiscount / 100);
      console.log(totalPrice, "totalprice123");

      return totalPrice;
    }
  }

  //dropdown
  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };
  console.log(termOptions.value, "selectedcustomerTerms");
  useEffect(() => {
    if (selectedcustomer) {
      let dueDate = new Date(startDate);
      dueDate.setDate(dueDate.getDate() + selectedcustomer?.TermDay);
      const newDueDate =
        selectedcustomer?.TermDay == 1
          ? moment() // current date
          : moment(startDate).add(selectedcustomer?.TermDay, "days");
      // const newDueDate = moment(startDate).add(
      //   selectedcustomer?.TermDay,
      //   "days"
      // );

      console.log(moment(newDueDate).format("YYYY-MM-DD"), "newDueDate");

      setAccountSaleData((prevValues) => ({
        ...prevValues,
        TermsID: changeCustomerValueByTerms
          ? changeCustomerValueByTerms
          : selectedcustomer.Terms == 0 || selectedcustomer.Terms == null
          ? 1
          : selectedcustomer.Terms,

        DueDate: moment(newDueDate).format("YYYY-MM-DD"),
      }));
    }
  }, [selectedcustomer]);

  const options = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    // +
    // "(" +
    // (option.FirstName + " " + option.LastName) +
    // ")"
    address: option.Address1,
    address2: option.Address2,
    City: option.City,
    StateProvince: option.StateProvince,
    Country: option.Country,
    email: option.Email,
    customerquickbookId: option.QuickbookID,
    PhoneNumber: option.PhoneNumber,
  }));

  const handleSelectChange = (event) => {
    console.log(event, "536");
    if (event != undefined) {
      if (paramObject.id === undefined) {
        let x = { ...localValues, dropdownCustomers: event };
        setLocalValues(x);
        localStorage.setItem("saleDraft", JSON.stringify(x));
      }
    }
    setCustomerEmail(event?.email);
    setSelectedOption(event);
    setcustomerId(event?.value);
    setChangeCustomerValueByTerms(null);
    setLoading(true);
    axios
      .get(`${config.customersBaseUrl}/customers/findbyid?id=${event?.value}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        if (
          response.data.ResponseData?.CustomerDetails[0] != undefined &&
          response.data.ResponseData?.CustomerDetails[0] != null
        ) {
          let customerData = response?.data?.ResponseData?.CustomerDetails[0];
          setSelectedCustomer(customerData);
          setcoustomerid(customerData.QuickbookID);
          setAccountSaleData((prevValues) => ({
            ...prevValues,
            ["InvoiceMessage"]: customerData.InternalNotes,
          }));
          console.log(customerData, "customerData123456");
          // let customerAddress =
          //   customerData.Address1 +
          //   " " +
          //   customerData.Address2 +
          //   ",\r\n" +
          //   customerData.City +
          //   ",\r\n" +
          //   customerData?.StateProvince +
          //   " " +
          //    customerData.Zip+
          //   ",\r\n" +
          //   customerData.Country ;
          let customerAddress = [
            customerData.Address1,
            customerData.Address2,
            customerData.City,
            customerData.StateProvince
              ? `${customerData.StateProvince} ${customerData.Zip}`
              : customerData.Zip,
            customerData.Country,
          ]
            .filter(Boolean)
            .join(",\r\n");

          setCustomerAddress(customerAddress);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // const handleCustomerDropdownChange = (cId) => {
  //   axios
  //     .get(
  //       `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${cId}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (
  //         response.data.ResponseData[0] != undefined &&
  //         response.data.ResponseData[0] != null
  //       ) {
  //         let customerData = response.data.ResponseData[0];
  //         setSelectedCustomer(customerData);
  //         console.log(customerData, "customerData1234");
  //         let customerAddress =
  //           customerData.Address1 +
  //           " " +
  //           customerData.Address2 +
  //           ",\r\n" +
  //           customerData.City +
  //           ",\r\n" +
  //           customerData.StateProvince +
  //           " " +
  //           customerData.Zip +
  //           ",\r\n" +
  //           customerData.Country;
  //         console.log(customerAddress, "customerAddress");
  //         setCustomerAddress(customerAddress);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // };

  //Persisting the data in the UI using LocalStorage

  let salesTypeDropdownOption = [];
  const RolesDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const BindPageDropdown = () => {
    //  sale type
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      }); // PaymentType Dropdown List

    // Accounting Terms Drop Down Axios Call
    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // setLoading(true);
        console.log(res.data.ResponseData, "res.data.ResponseData");
        setTerm(res.data.ResponseData);
        // setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        //  setLoading(false);
      });

    // Accounting Tags Drop Down Axios Call
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        //setLoading(true);
        setTag(res.data.ResponseData);
        // setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        // setLoading(false);
      });

    // custom field getall
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/customfieldgetall?saleid=${loginUserId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;
        if (responseData.length !== 0) {
          setCustomFields(responseData);
        }

        /// setLoading(false);
      })
      .catch((err) => {
        ///  setLoading(false);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // payment dropdown
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err); // setLoading(false);
      });

    // categories
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedCategory(res.data.ResponseData);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "=====dataget>");
      })
      .catch((error) => {
        console.log(error);
      });

    // Delivery Method drop down
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/deliverymethodlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const deliveryData = response.data.ResponseData?.map((el) => {
          return { label: el.Name, value: el.ID };
        });
        setDeliveryMethodOption(deliveryData);
        console.log(response.data.ResponseData, "=====deliverymethodlist");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const BindInvoiceDropdown = (pSaleTypeID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/autogenerateinvoicenumber?typeid=${
          pSaleTypeID > 0 ? pSaleTypeID : selectedDropDownValue
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let invoiceNumber = res.data.ResponseData[0].InvoiceNumber;
        // setAccountSaleData((prevValues) => ({
        //   ...prevValues,
        //   ["InvoiceNumber"]: invoiceNumber,
        // }));
      });
    // }
  };

  const handleClick = () => {
    setShowEditStatement(true);
  };

  const handleClickEdit = () => {
    setShowEditInvoice(true);
  };

  const AddMessageStatement = (e) => {
    // console.log("eeeearrrrrrr", e);
    e.preventDefault();
    // console.log(e.target[0].value, "eeeeeeeeeeeeeeeeeeeeeee");

    handleChangeAccountSalesData(e.target[0].value, "InvoiceStatement");

    setShowEditStatement(false);

    // callback(valueOfInput);
  };

  const AddMessageInvoice = (e) => {
    console.log("eeeearrrrrrr", e.target[0].value);
    e.preventDefault();
    // console.log(e.target[0].value, "eeeeeeeeeeeeeeeeeeeeeee");
    handleChangeAccountSalesData(e.target[0].value, "InvoiceMessage");

    setShowEditInvoice(false);

    // callback(valueOfInput);
  };

  const cancelEdit = () => {
    setShowEditStatement(false);
  };

  console.log(deliveryFees, "deliveryFees874");

  const BindSalesDetails = () => {
    // setLoading(true);

    if (paramObject.id > 0 || Clone > 0) {
      let paramid = paramObject.id > 0 ? paramObject.id : Clone;
      // Find By ID for sales
      localStorage.removeItem("Clone");
      setLoading(true);
      axios
        .get(`${config.salesconfigBaseUrl}/sales/findbyid?id=${paramid}`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((res) => {
          setIsReadOnly(false);
          console.log("Console From Sales ==>: ", res.data.ResponseData);
          const SuspendedData = res.data.ResponseData.unSuspendData[0];
          setQuickBookId(SuspendedData.QuickBookId);
          console.log(
            moment(SuspendedData.Saletime)
              .tz("Asia/Kolkata")
              .format(
                "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(India Standard Time)]"
              ),
            "salesDeliveryDataJSON456==>"
          );
          const saleTime = moment(SuspendedData.Saletime)
            .tz("Asia/Kolkata")
            .toDate();
          setStartDate(Clone > 0 ? startDate : SuspendedData.Saletime);
          setDeliveryMethodId(SuspendedData.DeliveryMethodId);
          setAmountPaid(SuspendedData?.AmountPaid == '0.00'? 0 : SuspendedData?.AmountPaid );
          setshippingaddress(
            SuspendedData.shippingaddress
              ? Number(SuspendedData?.shippingaddress)
              : 0
          );
          const PaymentData = res.data.ResponseData.paymentData;
          const TaxData = res.data.ResponseData.TaxData;
          const SalesItem = res.data.ResponseData.SalesItems;
          console.log(SalesItem, "salesitem");
          const CustomerDetails = res.data.ResponseData.CustomerDetails[0];
          setcoustomerid(CustomerDetails.QuickbookID);
          console.log(CustomerDetails, "CustomerDetails");
          const SalesCustomFiledData =
            res.data.ResponseData.SalesCustomFiledData;
          const SalesDeliveryDetails =
            res.data.ResponseData.SalesDeliveryDetails[0];

          console.log(SalesDeliveryDetails, "SalesDeliveryDetails");

          Clone > 0
            ? setAccountSaleData({
                ...SuspendedData,
                DueDate: moment(startDate)
                  .add(SuspendedData?.TermsValue || 0, "days")
                  .toDate(),
                InvoiceDate: startDate,
              })
            : setAccountSaleData(SuspendedData);

          setChangeCustomerValueByTerms(SuspendedData?.TermsID);
          console.log("accountSaleData-->", accountSaleData);
          setselectedSaleOption(SuspendedData.SalesType);
          setPaymentAmount(SuspendedData.total);
          setSelectDropDownValue(SuspendedData.Type);
          setRestrictEdit(Clone > 0 ? 0 : SuspendedData.RestrictEdit);
          setSaleTypeId(SuspendedData.Type);
          setSaleQuickbookId(SuspendedData.Type);
          setSaleIsVoid(SuspendedData.IsVoid);
          setSelectedLocation(SuspendedData.Locationid);
          setCustomFields(SalesCustomFiledData);
          setSelectedSalesDeliveryData({
            ...SalesDeliveryDetails,
            deliveryMethodId: SuspendedData?.DeliveryMethodId || 0,
          });
          setSalesDeliveryData({
            ...SalesDeliveryDetails,
            deliveryMethodId: SuspendedData?.DeliveryMethodId || 0,
          });
          setIsEcommerce(SuspendedData?.IsEcommerce);
          setCusttierId(
            SuspendedData?.CusttierId ? SuspendedData?.CusttierId : 0
          );

          console.log(SalesDeliveryDetails, "SalesDeliveryDetails----->");

          setDeliveryFees(SalesDeliveryDetails?.DeliveryFees);

          const paymentAmounts = PaymentData.map((payment) =>
            parseFloat(payment.Paymentamount)
          );
          const totalPaidAmount = paymentAmounts?.reduce(
            (acc, curr) => acc + curr,
            0
          );
          setPaidAmount(totalPaidAmount.toFixed(2));

          const mappedSaleItems = SalesItem.map((item, index) => {
            const matchingTaxes = item.taxes?.filter(
              (tax) => tax.Itemid === item.ItemId
            );

            const mappedItem = {
              SaleItemID: Clone > 0 ? 0 : item.SaleItemID,
              ItemId: item.ItemId,
              SaleId: Clone > 0 ? 0 : item.SaleId,
              UnitPrice: parseFloat(item.UnitPrice),
              Price: parseFloat(item.Price),
              RecallPrice: parseFloat(item.RecallPrice),
              ItemName: item.Items,
              itemquantity: parseFloat(item.itemquantity),
              itemdiscount: parseFloat(item.itemdiscount),
              CostPrice: parseFloat(item.CostPrice),
              Ischecked: item.Ischecked,
              Total: parseFloat(item.Total),
              Module: item.Module,
              Itemkitid: item.ItemKitId,
              VariationName: item.VariationName,
              // locationid: selectedLocation,
              locationid: Location,
              ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
              VariationQuantity: parseFloat(item.VariationQuantity),
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              Itemnumber: item.Itemnumber,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
              QuickbookId: item.QuickbookID,
              SaleItemQuickbookId: item.SaleItemQuickbookId,
              Isdefault: item.Isdefault,
              Tax1: item.Tax1,
              Tax2: item.Tax2,
              Tax3: item.Tax3,
              Tax4: item.Tax4,
              Tax5: item.Tax5,

              TaxCum1: item.TaxCum1,
              TaxCum2: item.TaxCum2,
              TaxCum3: item.TaxCum3,
              TaxCum4: item.TaxCum4,
              TaxCum5: item.TaxCum5,

              TaxName1: item.TaxName1,
              TaxName2: item.TaxName2,
              TaxName3: item.TaxName3,
              TaxName4: item.TaxName4,
              TaxName5: item.TaxName5,

              TaxType1: item.TaxType1,
              TaxType2: item.TaxType2,
              TaxType3: item.TaxType3,
              TaxType4: item.TaxType4,
              TaxType5: item.TaxType5,

              TaxVal1: item.TaxVal1,
              TaxVal2: item.TaxVal2,
              TaxVal3: item.TaxVal3,
              TaxVal4: item.TaxVal4,
              TaxVal5: item.TaxVal5,
              Cummalative: item.Cummalative,

              mainIndex: index + 1,
              isReCallPrice: item.isReCallPrice,
              DiscountType: item.DiscountType,
            };

            matchingTaxes?.forEach((tax, taxIndex) => {
              mappedItem[`TaxGroup${taxIndex + 1}`] = tax.Name;
              mappedItem[`TaxGroup${taxIndex + 1}Value`] = tax.Percent;
              mappedItem.taxes = matchingTaxes.length;
            });
            return mappedItem;
          });
          setStateNew(mappedSaleItems);
          console.log(SalesItem, "SalesItem");
          console.log(deliveryFees, "deliveryFees");
          console.log(mappedSaleItems, "mappedSaleItems 258");

          const totalItemQuantity = mappedSaleItems.reduce(
            (a, v) => (a = a + v.itemquantity),
            0
          );
          setTotalQuantity(totalItemQuantity);

          setCommonDiscount(SuspendedData.Discountentiresale);
          setDiscountType(SuspendedData.DiscountMethod);
          setReason(SuspendedData.Discountreason);
          const subtotalValue = parseFloat(SuspendedData.Subtotal);
          const totalValue = parseFloat(SuspendedData.total);
          totalRef.current = parseFloat(totalValue).toFixed(2);
          subtotalRef.current = parseFloat(subtotalValue).toFixed(2);

          // Setting the Amount Due
          const Compairamount = SuspendedData.AmountDue;
          setDueAmount(parseInt(Compairamount).toFixed(2));

          // Setting the Comment
          const commentValue = SuspendedData.Comments;
          setComment(commentValue || "");

          // setting the Suppliers Id
          setCustomerAddress(SuspendedData.BillingAddress);
          setCustomerEmail(SuspendedData?.EmailAddress);
          setcustomerId(SuspendedData.Customer);
          setSelectedOption(SuspendedData.Customer);
          setCustomerName(SuspendedData.Name);
          setSelectedCustomer(CustomerDetails ? CustomerDetails : []);
          setcoustomerid(
            CustomerDetails.QuickbookID ? CustomerDetails.QuickbookID : []
          );
          console.log(CustomerDetails, "dtatacheck===>");
          const TaxTypeMap = [];
          TaxData.forEach((taxXml) => {
            TaxTypeMap[taxXml.ID] = taxXml.Name;
          });
          // setTaxXml(TaxData);
          console.log(customerEmail, "customerEmail");

          const mappedReceivingItems = TaxData.map((item) => {
            const mappedItem = {
              TaxID: item.ID,
              TaxName: item.TaxName,
              TaxPercent: item.TaxPercent,
              type: item.type,
              TaxItemID: parseInt(item.TaxItemID),
              TaxVariationID: parseInt(item.TaxVariationID),
            };
            return mappedItem;
          });
          setTaxData(mappedReceivingItems);
          setTaxXml(mappedReceivingItems);
          // setTaxData(TaxData);
          // (TaxData);

          let totalTaxAmountEdit = 0;
          TaxData.forEach((tax) => {
            totalTaxAmountEdit +=
              (parseFloat(totalValue).toFixed(2) * tax.TaxPercent) / 100;
          });

          let fees =
            SalesDeliveryDetails?.DeliveryFees > 0
              ? SalesDeliveryDetails?.DeliveryFees
              : 0;
          // netAmount = (
          //   parseFloat(totalValue) +
          //   parseFloat(totalTaxAmountEdit) +
          //   parseFloat(fees)
          // ).toFixed(2);

          let netAmount = (
            parseFloat(isNaN(totalValue) ? 0 : totalValue) +
            parseFloat(isNaN(totalTaxAmountEdit) ? 0 : totalTaxAmountEdit) +
            parseFloat(isNaN(fees) ? 0 : fees)
          ).toFixed(2);

          setNetAmountValue(netAmount);

          // setSelectedOption(customersName);
          const paymentTypeMap = {};
          PaymentData.forEach((payment) => {
            paymentTypeMap[payment.ID] = payment.Paymenttypename;
          });

          setPayments(PaymentData);
          setSelectedPayment(PaymentData.Paymenttypename);
          setPaymentTypeDropdown(PaymentData);

          // for bind the tags values
          let selecttags = SuspendedData.TagId;
          console.log("SuspendedData", SuspendedData);

          if (selecttags.length > 0) {
            axios
              .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: token,
                },
              })
              .then((res) => {
                // console.log("::>>>", res);
                tagOptions = res.data.ResponseData;

                if (selecttags.length > 0) {
                  tagOptions.map((selectManufacturer) => {
                    const splitSelectedTags = selecttags.split(",");
                    var splitSelectedTagsnumbers = splitSelectedTags.map(
                      function (str) {
                        return parseInt(str);
                      }
                    );

                    setSelectedtags(splitSelectedTagsnumbers);
                  });
                }
              });
          }

          outputMatchedOptions = matchedTagOptions.map(({ ID, Name }) => ({
            label: Name,
            value: ID,
          }));

          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  // console.log("Selected Customer:",selectedcustomer)

  useEffect(() => {
    // Bind all dropdown for loading page
    BindPageDropdown();

    // Bind Sales Details
    BindSalesDetails();
  }, []);

  // useEffect(() => {
  //   if (
  //     selectedDropDownValue != 4 &&
  //     (paramObject.id == undefined || paramObject.id == 0)
  //   ) {
  //     BindInvoiceDropdown();
  //   }
  // }, [selectedDropDownValue]);

  // For the Price change
  const handlePriceChange = (index, value) => {
    updatedData = [...statenew];
    // updatedData[index] = { ...updatedData[index], UnitPrice: Number(value), Price: Number(value) };
    updatedData[index] = {
      ...updatedData[index],
      Price: value,
      // == 0 ? "" : value,
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 ? (updatedData[index].UnitPrice) :
      //   selectedPriceForSale === 3 ? (updatedData[index].RecallPrice) :

      //     tireObject == "Tier1" ? updatedData[index].Tier1 :
      //       tireObject == "Tier2" ? updatedData[index].Tier2 :
      //         tireObject == "Tier3" ? updatedData[index].Tier3 :
      //           tireObject == "Tier4" ? updatedData[index].Tier4 :
      //             tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      //updatedData[index].UnitPrice,
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    // updatedData[index] = { ...updatedData[index], Total: Number(total) };
    updatedData[index] = {
      ...updatedData[index],
      Total: parseFloat(total).toFixed(2),
    };

    console.log("updatedData ===>", updatedData);
    setStateNew(updatedData);

    updateTotal(
      updatedData?.map((el) => {
        return { ...el, Price: el.Price ? el.Price : 0 };
      })
    );
  };
  const handlePriceChange1 = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      Price: value == 0 ? "" : value,
    };

    let total = calculateTotal(
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    console.log("updatedData ===>", updatedData);
    setStateNew(updatedData);

    updateTotal(
      updatedData?.map((el) => {
        return { ...el, Price: el.Price ? el.Price : 0 };
      })
    );
  };

  const [validationErrors, setValidationErrors] = useState([]);
  // For handling the Quantity Change
  const handleQuantityChange = (index, value) => {
    updatedData = [...statenew];

    // Verify current qty is less then or not
    let itemCurrentQuantity = updatedData[index].ItemCurrentQuantity;
    // if (value === "" || Number(value) <= itemCurrentQuantity) {

    // remove error message from the use state
    const newValidationErrors = [...validationErrors];
    newValidationErrors[index] = "";
    setValidationErrors(newValidationErrors);

    // Update quantity from the use state
    updatedData[index] = {
      ...updatedData[index],
      itemquantity: value,
      // == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 && (updatedData[index].UnitPrice),
      //   selectedPriceForSale === 3 && (updatedData[index].RecallPrice),

      //   tireObject == "Tier1" ? updatedData[index].Tier1 :
      //     tireObject == "Tier2" ? updatedData[index].Tier2 :
      //       tireObject == "Tier3" ? updatedData[index].Tier3 :
      //         tireObject == "Tier4" ? updatedData[index].Tier4 :
      //           tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      // updatedData[index].UnitPrice,
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    // updatedData[index] = { ...updatedData[index], Total: Number(total) };
    updatedData[index] = {
      ...updatedData[index],
      Total: parseFloat(total).toFixed(2),
    };

    setStateNew(updatedData);
    updateTotal(
      updatedData?.map((el) => {
        return { ...el, itemquantity: el.itemquantity ? el.itemquantity : 0 };
      })
    );

    //    } else {
    //   // add error message from the use state
    //   const newValidationErrors = [...validationErrors];
    //   newValidationErrors[index] =
    //     "Value must not exceed " + itemCurrentQuantity;
    //   setValidationErrors(newValidationErrors);
    // }
  };

  const handleQtyKeyDown = (event) => {
    if (event.key === "Enter" && searchItemInputRef.current) {
      searchItemInputRef.current.focus();
      searchItemInputRef.current.select(); // Optional: Select the Discount input value
    }
  };

  // For Handling the discount Change
  const handleDiscountChange = (index, value) => {
    console.log(Number(value), index, "value==233");
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      itemdiscount: value ? Number(value) : value,
      // itemdiscount: value == 0 ? 0 : Number(value),
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 && (updatedData[index].UnitPrice),
      //   selectedPriceForSale === 3 && (updatedData[index].RecallPrice),

      //   tireObject == "Tier1" ? updatedData[index].Tier1 :
      //     tireObject == "Tier2" ? updatedData[index].Tier2 :
      //       tireObject == "Tier3" ? updatedData[index].Tier3 :
      //         tireObject == "Tier4" ? updatedData[index].Tier4 :
      //           tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      // updatedData[index].UnitPrice,

      updatedData[index].Price,
      updatedData[index].itemquantity,
      Number(updatedData[index].itemdiscount),
      updatedData[index].DiscountType,
      1
    );

    console.log(total, "totaltotal");

    // updatedData[index] = { ...updatedData[index], Total: Number(total) };
    updatedData[index] = {
      ...updatedData[index],
      Total: parseFloat(total).toFixed(2),
    };

    setStateNew(updatedData);
    updateTotal(updatedData);
    // setDiscountInputValue(value);
  };

  const handleToggleDiscountType = (index) => {
    const updatedData = [...statenew];
    updatedData[index].DiscountType =
      updatedData[index].DiscountType === "amount" ? "percent" : "amount";
    // setStateNew(updatedState);

    let total = calculateTotal(
      updatedData[index].Price,
      updatedData[index].itemquantity,
      Number(updatedData[index].itemdiscount),
      updatedData[index].DiscountType,
      1
    );

    console.log(total, updatedData, "totaltotal");

    updatedData[index] = {
      ...updatedData[index],
      Total: parseFloat(total).toFixed(2),
    };

    console.log(updatedData, "checkupdatedData");

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const handleTotalChange = (index, value) => {
    updatedData = [...statenew];
    let totalvalue = value;
    let itemquantity = updatedData[index].itemquantity;
    let itemdiscount = updatedData[index].itemdiscount;
    if (itemdiscount == undefined || itemdiscount == "") {
      itemdiscount = 0;
    }

    // Calculate the subtotal after applying the discount
    let subtotal = totalvalue / (1 - itemdiscount / 100);

    // Calculate the price per quantity
    let price = subtotal / itemquantity;

    updatedData[index] = { ...updatedData[index], Total: value };
    // updatedData[index] = { ...updatedData[index], UnitPrice: price, Price: price };
    // updatedData[index] = { ...updatedData[index], Price: price };

    updatedData[index] = {
      ...updatedData[index],
      Price: Number(price).toFixed(FractionDigits) || Number(price).toFixed(2),
    };
    console.log(updatedData, "handelchange 445");
    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const handleItemsDelete = (index) => {
    const newImageUrls = statenew.filter((_, i) => i !== index);
    setStateNew(newImageUrls);
    updatedData = newImageUrls;
    updateTotal(updatedData);
    const updatedErrors = [...validationErrors];
    updatedErrors.splice(index, 1);
    setValidationErrors(updatedErrors);
  };

  function updateTotal(updatedData) {
    console.log(updatedData, "==> updatedData 445");
    setIsChangedData(true);
    let newTotalQuantity = 0;
    updatedData.forEach((item) => {
      newTotalQuantity += Number(item.itemquantity);
    });
    setTotalQuantity(newTotalQuantity);
    console.log(newTotalQuantity, "==> newTotalQuantity  work 445");

    let newTotal = 0;
    updatedData.forEach((item, index) => {
      let totalPrice = 0;
      // let UnitPrice = item.UnitPrice;
      // if (isNaN(item.UnitPrice)) {
      //   UnitPrice = 0;
      // }

      let UnitPrice = item.Price;
      if (isNaN(item.Price)) {
        UnitPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount) || item.itemdiscount === "") {
        itemdiscount = 0;
      }
      // if (!isNaN(item.UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = item.UnitPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      // // }
      // if (!isNaN(UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = parseFloat(UnitPrice)  * parseFloat(item.itemquantity) * (1 - parseFloat(itemdiscount) / 100);
      // }

      console.log(selectedPriceForSale, "selectedPriceForSale 445");
      // totalPrice = item.UnitPrice * item.itemquantity * (1 - itemdiscount / 100);
      totalPrice =
        item.DiscountType == "amount"
          ? parseFloat(UnitPrice) * parseFloat(item.itemquantity) -
            parseFloat(itemdiscount)
          : parseFloat(UnitPrice) *
            parseFloat(item.itemquantity) *
            (1 - parseFloat(itemdiscount) / 100);

      console.log(totalPrice, "==> totalPrice  work 445");
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });
    subtotalRef.current = newTotal;
    if (discountType === "amount") {
      newTotal = parseFloat(newTotal) - Number(commonDiscount);
    } else {
      const percentDiscountAmount =
        newTotal * (parseFloat(commonDiscount) / 100);
      newTotal = parseFloat(newTotal) - Number(percentDiscountAmount);
    }
    // newTotal = parseFloat(newTotal) - (discountType === 'amount' ? Number(commonDiscount) : newTotal*(1 - parseFloat(commonDiscount) / 100));
    console.log(newTotal, "==> newTotal work 445");

    totalRef.current = newTotal;

    let paymentTotal = newTotal - parseFloat(paidAmount);
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    console.log(paymentTotal, "<== paymentTotal  work 445");
    setDueAmount(paymentTotal);
  }

  const handleEntireSaleDiscountChange = (event, discountType) => {
    const newDiscountValue = Number(event);

    //settingUp data in LS

    if (paramObject.id === undefined) {
      const x = { ...localValues, DiscountChange: newDiscountValue };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    setEntireSaleDiscount(
      isNaN(newDiscountValue) || newDiscountValue == 0 || newDiscountValue < 0
        ? ""
        : newDiscountValue
    );

    const updatedDataDiscount = statenew.map((item) => {
      let total = calculateTotal(
        item.Price,
        item.itemquantity,
        newDiscountValue,
        discountType,
        1
      );
      return {
        ...item,
        itemdiscount: newDiscountValue,
        Total: Number(total),
        DiscountType: discountType,
      };
    });

    setStateNew(updatedDataDiscount);
    updatedData = updatedDataDiscount;
    updateTotal(updatedData);
  };

  console.log(entireSaleDiscount, "entireSaleDiscount");

  const handleCommonDiscountChange = (value, edType) => {
    let newDiscountValue = value;
    console.log(newDiscountValue, edType, "newDiscountValue");

    //setting up the data in LS
    if (paramObject.id === undefined) {
      const x = {
        ...localValues,
        EntireSale: newDiscountValue,
        discountType: edType,
      };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    // setCommonDiscount(newDiscountValue == 0 ? "" : newDiscountValue);
    setCommonDiscount(newDiscountValue);

    let newTotal = 0;
    statenew.forEach((item, index) => {
      let totalPrice = 0;
      // let UnitPrice = item.UnitPrice;
      // if (isNaN(item.UnitPrice)) {
      //   UnitPrice = 0;
      // }
      let UnitPrice = item.Price;
      if (isNaN(item.Price)) {
        UnitPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      // if (!isNaN(item.UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice =
      //     item.UnitPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      // }

      if (!isNaN(item.Price) && !isNaN(item.itemdiscount)) {
        // totalPrice =
        //   item.Price * item.itemquantity * (1 - item.itemdiscount / 100);
        if (item?.DiscountType === "amount") {
          totalPrice = UnitPrice * item.itemquantity - itemdiscount;
        } else {
          totalPrice = UnitPrice * item.itemquantity * (1 - itemdiscount / 100);
        }
      }

      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    let totalAmount = 0;
    if (edType == "percent") {
      const percentValue = isNaN(newDiscountValue) ? 0 : newDiscountValue;
      let discountAmount = parseFloat(newTotal) * (percentValue / 100);
      newDiscountValue = discountAmount;
      setDiscountPrice(discountAmount);
      totalAmount = Number(newTotal) - discountAmount;
    } else {
      totalAmount = Number(newTotal) - newDiscountValue;
    }

    console.log(totalAmount, "totalAmount dhgvdgd");

    totalRef.current = totalAmount;

    let paymentTotal = totalAmount - paidAmount;
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  };

  // useEffect(() => {
  //   if (commonDiscount != 0) {
  //     handleCommonDiscountChange({
  //        target: { value: commonDiscount }, // Pass the numeric value to the handler
  //     });
  //   }
  // },[discountType]);

  const handleCancelClick = () => {
    setSelectedOption(null);
    setCustomerEmail(null);
    setCustomerAddress(null);
    setSelectedCustomer([]);
    setSalesDeliveryData(null);
    setDeliveryFees(0);
  };

  const handleDeletePayment = (index) => {
    setDeletedPaymentIndex(index);
    let prevDueAmount =
      parseFloat(dueAmount) + parseFloat(payments[index].Paymentamount);
    setDueAmount(prevDueAmount);
    setPayments(payments.filter((payment, i) => i !== index)); // Remove the deleted payment from the payments array
    setDeletedPaymentIndex(-1); // Reset the deletedPaymentIndex state
  };

  const handleChangeCupon = (e) => {
    // console.log(e.target.value);
    setCouponCode(e.target.value);
  };

  const handleDeleteTax = (e, tax, index) => {
    e.preventDefault();
    const filteredData = taxXml.filter(
      (el, currentIndex) => currentIndex !== index
    );

    setTaxXml(filteredData);
    setTaxData(filteredData);

    if (paramObject.id === undefined) {
      const x = { ...localValues, taxArray: filteredData };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };
  console.log(taxXml, "filteredData");

  const handlePayment = (method, id, name) => {
    setMethod(method);
    setSelectedPayment({ id, name });
    // console.log(`Selected payment method: ${method}`);
  };

  const handleAmountChange = (event) => {
    // console.log("Event", event.target.value);
    let amount = parseFloat(event.target.value);
    if (Number.isNaN(amount)) {
      amount = 0;
    }
    setAmountToSubtract(amount);
  };

  const handleOptionSelect = (e, label, value) => {
    console.log(e, label, value, "1341");
    if (restirctedit == 1 && paramObject.id > 0) {
      setModal(true);
      return;
    }
    toastWarn(`You are Changing to ${label}`);

    // netamount=0
    // setStateNew([]);

    // totalRef.current = 0;
    // setTotalQuantity(0);
    // setReason("");
    // setCommonDiscount(0);
    // setEntireSaleDiscount(0);
    // setComment("");
    // setSelectedtags("")

    //SettingUp Data in Local Storage
    if (paramObject.id === undefined) {
      const x = { ...localValues, saleDropdown: [value, label] };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    setSelectDropDownValue(value);
    let eve = e.target;
    const dataItemId = eve.getAttribute("value");
    const saleType = dataItemId;
    setSaleTypeId(value);
    setSelect(label);
    setIsStoreAccountPayment(label === "Customer Account");
    const selectedOption = salesTypeDropdownOption.find(
      (option) => option.value == saleType
    );

    let o = selectedOption.label;

    setselectedSaleOption(o);

    BindInvoiceDropdown(value);
  };

  // console.log(saleTypeId,"saleTypeId")

  const handleSuspendClick = (e, optiondata) => {
    setSelectDropDownValue(optiondata.value);

    setSaleTypeId(optiondata.value);
    setSelect(optiondata.label);
    setIsStoreAccountPayment(optiondata.label === "Customer Account");
    const selectedOption = salesTypeDropdownOption.find(
      (option) => option.value == optiondata.value
    );

    let o = selectedOption.label;

    setselectedSaleOption(o);
    BindInvoiceDropdown(optiondata.value);
  };

  const handleCancelPopup = (pID) => {
    setStateNew([]);
    updateTotal([]);
    setEntireSaleDiscount([]);
    setSelectedOption(null);
    setPayments([]);
  };

  const handleCheckboxChange = (e, index) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      IsChecked: e.target.checked == true ? 1 : 0,
    };
    setStateNew(updatedData);
    setCheckboxes(e.target.checked == true ? 1 : 0);
  };

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
      if (data) {
        if (type === "SelectImage") setImageUrl(data);
        else {
          setCustomFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const handleChangeComments = (e) => {
    setComment(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, finalComment: e.target.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleChangeReason = (e) => {
    if (paramObject.id === undefined) {
      const x = { ...localValues, Reason: e.target.value };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
    setReason(e.target.value);
  };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };

  function handleChange(event) {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const vaidation = (name, value) => {
    switch (name) {
      case "Receipt":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
      if (data) {
        if (type === "Receipt") {
          setFileUrl(data);
          setFileName(file.name);
          setAccountSaleData((prevValues) => ({
            ...prevValues,
            ["Attachment"]: data,
          }));
          // console.log(file, "FileUrl")
          if (paramObject.id === undefined) {
            let x = { ...localValues, Attachments: data };
            setLocalValues(x);
            localStorage.setItem("saleDraft", JSON.stringify(x));
          }
          setLoading(false);
        }
      }
    });
  };

  const handleFileChange = (event, index) => {
    setChangeFileName(true);

    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    console.log(files, "files[i]");
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  const handleChangeInvoiceDate = (event, fieldName) => {
    console.log(event, "eventdata");
    // const settime = moment(event).format("YYYY-MM-DDT00:00:00.000") + "Z";
    // const time = moment(settime).format("YYYY-MM-DD");
    setStartDate(event);
    setAccountSaleData((item) => ({
      ...item,
      ["InvoiceDate"]: event,
    }));
    if (paramObject.id === undefined) {
      let x = {
        ...localValues,
        [fieldName]: event,
      };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleDueDate = (event) => {
    if (event && event.length > 0) {
      let x = {
        ...localValues,
        ["DueDate"]: event,
      };
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        ["DueDate"]: event,
      }));
      if (paramObject.id === undefined) {
        setLocalValues(x);
        localStorage.setItem("saleDraft", JSON.stringify(x));
      }
    }
  };

  const handleChangeAccountSalesData = (event, fieldName) => {
    // console.log(event, fieldName, " => coming from input");
    let x;
    console.log(fieldName, event, "newdata1610");
    if (fieldName === "InvoiceStatement") {
      x = { ...localValues, [fieldName]: event };
      // let dueDate = new Date(todayDate);
      // dueDate.setDate(dueDate.getDate() + event.actualValue);

      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event,
      }));
    } else if (fieldName === "InvoiceMessage") {
      // console.log(fieldName, event, "new data");
      x = { ...localValues, [fieldName]: event };
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event,
      }));
    } else if (fieldName === "DueDate") {
      const settime = moment(event).format("YYYY-MM-DDT00:00:00.000") + "Z";
      const time = moment(settime).format("YYYY-MM-DD");
      x = {
        ...localValues,
        [fieldName]: time,
      };
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: time,
      }));
    } else if (fieldName === "TermsID") {
      const dueDate = moment(accountSaleData?.InvoiceDate)
        .add(event.actualValue, "days")
        .format("YYYY-MM-DD");
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
        QuickBookID: event.QuickBookID,
        DueDate: dueDate,
      }));
      x = {
        ...localValues,
        [fieldName]: event?.value,
        ["DueDate"]: dueDate,
      };
    } else if (fieldName == "Tags") {
      x = { ...localValues, [fieldName]: event.map((x) => x.value) };
      setSelectedtags(Array.isArray(event) ? event.map((x) => x.value) : []);
    } else if (fieldName === "InvoiceNumber") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      const { name, value } = event.target;

      setAccountSaleData((prevValues) => ({ ...prevValues, [name]: value }));
    } else if (fieldName === "BillingAddress") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setCustomerAddress(event.target.value);
    } else if (fieldName === "Email") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setCustomerEmail(event.target.value);
    } else {
      const { name, value } = event.target;
      // console.log(name, value, "new data");

      setAccountSaleData((prevValues) => ({ ...prevValues, [name]: value }));
    }
    if (paramObject.id === undefined) {
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  console.log(selectedtags, "selected");
  const handleCompleteSale = (salestatus) => {
    const amount = parseFloat(amountToSubtract);
    // console.log("Handle Submit");

    if (salestatus === "complete") {
      if (!amountToSubtract) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (isNaN(amount) || amount <= 0) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (amount > Compairamount) {
        // display error message
        toast.error("The amount entered is greater than the due amount");
        return;
      }
    }

    if (Compairamount > 0 || salestatus === "suspend") {
      let payment = {
        PayId: 0,
        PaymentId: selectedPayment.id,
        Paymentamount: amount,
      };
      let updatedPayments = [...payments];
      if (amount > 0) {
        updatedPayments.push(payment);
      }
      setPayments(updatedPayments);
      originalPass = updatedPayments;
      setDueAmount((prevDueAmount) => prevDueAmount - amount);
      setAmountToSubtract("");
    }
  };

  // console.log("Stateneww", statenew);

  // useEffect(() => {
  //   const updatedStateNew = statenew.map((item) => {
  //     const taxItems = taxXml.filter((tax) => tax.TaxItemID === item.ItemId);
  //     console.log("taxItems::>>", taxItems);
  //     const totalPercent = taxItems.reduce((sum, tax) => sum + ((parseFloat(tax.TaxPercent)*parseFloat(item.UnitPrice))/100), 0);
  //     console.log("taxTotalPercent::>>>", totalPercent);

  //     return {
  //       ...item,
  //       Tax: parseFloat(totalPercent),
  //     };
  //   });

  //   console.log("updatedStateNew", updatedStateNew);
  //   setStateNew(updatedStateNew);
  // }, [taxXml])
  useEffect(() => {
    const updatedStateNew = statenew.map((item) => {
      const taxItems = taxXml.filter((tax) => tax.TaxItemID === item.ItemId);
      // console.log("taxItems::>>", taxItems);
      const totalPercent = taxItems.reduce(
        (sum, tax) =>
          sum + (parseFloat(tax.TaxPercent) * parseFloat(item.UnitPrice)) / 100,
        0
      );
      // console.log("taxTotalPercent::>>>", totalPercent);

      return {
        ...item,
        Tax: parseFloat(totalPercent),
      };
    });

    // Compare the updatedStateNew with the current state to check for changes
    if (!isEqual(updatedStateNew, statenew)) {
      setStateNew(updatedStateNew);
    }
  }, [taxXml]);

  console.log("accountSaleData", accountSaleData.DueDate);
  const handleSubmit = () => {
    let isValid = true;

    if (isValid) {
      // Submit
      // console.log("Submit");

      if (
        paramObject.id > 0 &&
        (selectedDropDownValue === 4 ? sumamount : netAmount) < AmountPaid
      ) {
        toastError("Total amount Cannot Be less Than Total paid Amount ");
        return;
      }

      const isDueDateAfterInvoiceDate = moment(
        accountSaleData.DueDate
      ).isSameOrAfter(accountSaleData.InvoiceDate);

      console.log(
        accountSaleData.InvoiceDate,
        accountSaleData.DueDate,
        isDueDateAfterInvoiceDate,
        "isDueDateAfterInvoiceDate"
      );
      if (!isDueDateAfterInvoiceDate) {
        toastError(
          "Error: The Due Date cannot be earlier than the Invoice Date."
        );
        return;
      }

      if (selectedcustomer == "" || selectedcustomer.Id == 0) {
        toastError("Please select a customer");
        return;
      }

      if (saleTypeId !== 2) {
        if (deliveryMethodId < 1) {
          toastError("Please select Delivery Method");
          return;
        }
      }

      let taxdata = taxXml.filter(function (rowData) {
        return rowData.TaxName != "";
      });

      // let customFielddata = customFieldSalesValues.filter(function (rowData) {
      //   return (
      //     rowData.CustomFieldLabelID !== null &&
      //     rowData.CustomFieldValue !== null
      //   );
      // });

      let Itemdata = statenew.map((el) => ({
        ...el,
        ItemName: "",
        VariationName: "",
        // DiscountType: itemsdiscountType
      }));

      // let paymentMethodData = originalPass.filter(function (paymentData) {
      //   // console.log(paymentData);
      //   return paymentData.PaymentId != "";
      // });

      const Itemobj = {};
      let customValuesData = {};
      let taxValuesData = {};
      let paymentData = {};
      let salesDeliveryDataJSON = {};

      Itemobj.saleitemsXML = Itemdata;
      let itemjsonstring = JSON.stringify(Itemobj);

      console.log(Itemobj.saleitemsXML, "Itemsssss");
      let itemTotalSum =
        Itemobj.saleitemsXML.reduce(
          (sum, item) => sum + Number(item.Total || 0),
          0
        ) - commonDiscount;
      console.log(
        itemTotalSum,
        selectedDropDownValue,
        selectedDropDownValue === 4,
        sumamount,
        netAmount,
        selectedDropDownValue === 4 ? sumamount : netAmount,
        itemTotalSum != (selectedDropDownValue === 4 ? sumamount : netAmount),
        "itemTotalSum"
      );
      // if (itemTotalSum != (selectedDropDownValue === 4 ? sumamount : netAmount)){
      //     toast.error("Something went wrong please check Sale");
      //     return;
      //   }

      // if (Itemdata.filter(item => item.Total <= 0 )?.length > 0) {
      //   toast.error("Item's Total price is 0 please recheck");
      //   return;
      // }

      // customValuesData.customValueXML = customFielddata;
      // let customvaluejsonstring = JSON.stringify(customValuesData);

      // paymentData.paymentValueXML = paymentMethodData;
      // let paymentvaluejsonstring = JSON.stringify(paymentData);

      taxValuesData.itemTaxXML = taxdata;
      let taxjsonstring = JSON.stringify(taxValuesData);

      salesDeliveryDataJSON.salesDeliveryDataXML =
        salesDeliveryData == undefined ? {} : salesDeliveryData;
      // console.log(salesDeliveryData, "salesDeliveryDataJSON")
      let salesDeliveryDataString = JSON.stringify(salesDeliveryDataJSON);
      //salesDeliveryXMLData
      console.log(startDate, "44salesDeliveryDataJSON456==>");
      let SalesData = {
        saletime: startDate,
        xmlsalesitems: itemjsonstring,
        // xmlcustomfieldvalue: customvaluejsonstring,
        //xmlitemspayment: paymentvaluejsonstring,
        // xmlsalesitemtax: taxjsonstring,
        xmlsalesdeliverydata: salesDeliveryDataString,
        id: Clone > 0 ? 0 : paramObject.id || 0,
        customerid: customerId, // selectedOption.value,
        comment: comment,
        // locationid: selectedLocation == 0 ? Location : selectedLocation,
        locationid: Location,
        saletypeid: saleTypeId,
        suspended: clickedValue,
        storeaccountpayment: isStoreAccountPaymentFlag,
        totalquantitypurchased: totalQuantity,
        totalquantityreceived: 0,
        subtotal:
          paramObject.id === undefined
            ? selectedDropDownValue === 4
              ? sumamount
              : LStotalAmt // - commonDiscount
            : paramObject.id !== undefined && selectedDropDownValue === 4
            ? sumamount
            : subtotalRef.current,
        // total: totalRef.current,
        total: selectedDropDownValue === 4 ? sumamount : netAmount,
        showcommentonreceipt: isChecked === true ? 1 : 0,
        estimate: clickedValue,
        layaway: clickedValue,
        // emailreceipt:
        discountreason: reason,
        discountentiresale: commonDiscount,
        paymentcurrency: paymentCurrency,
        addcoupons: couponCode,
        invoiceno: accountSaleData.InvoiceNumber,
        invoicemessage: accountSaleData?.InvoiceMessage,
        invoicestatement: accountSaleData.InvoiceStatement,

        duedate:
          selectedDropDownValue === 4
            ? ""
            : accountSaleData?.DueDate == undefined
            ? Moment().format("YYYY-MM-DD")
            : accountSaleData?.DueDate,
        termsid:
          accountSaleData.TermsID == undefined ? "" : accountSaleData.TermsID,
        termidquickbook:
          accountSaleData.QuickBookID || accountSaleData.TermsQuickBookID,
        receipt: FileUrl,
        status: 1,
        tagids: selectedtags?.toString(),
        billingaddress: customerAddress,
        emailaddress: customerEmail,
        loginuserid: Id,
        quickbookid: quickbookid || 0,
        customerquickbookid: coustomerid,
        customername: selectedcustomer.CompanyName,
        shippingaddress: shippingaddress,
        salequickbookid: salequickbookid,
        custtierId: custtierId,
        deliveryMethodId: deliveryMethodId,
        deliveryFees: deliveryFees,
        SalesgenerateType: "Portal",
        entireSaleDiscountType: discountType,
        SaleQuickPermision: SaleQuickPermision,
      };

      // console.log(SalesData.xmlsalesdeliverydata , "5558469987")

      console.log("handle Suspend 1", SalesData);
      // return;
      setLoading(true);

      axios
        .post(`${config.salesconfigBaseUrl}/sales/upsert`, SalesData, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((res) => {
          console.log("check 778899");
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            localStorage.removeItem("Clone");
            toastSuccess(SUCCESS_MESSAGE);
            localStorage.setItem(
              "isCustomerChange",
              JSON.stringify(res.data.ResponseData[0].IsCustomerUpdate)
            );
            setLoading(false);
            if (paramObject.id == undefined) {
              localStorage.removeItem("saleDraft");
              localStorage.removeItem("dataAfterDelivery");
              localStorage.removeItem("DeliveryDraft");
              localStorage.removeItem("EditTaxDraft");
            }
            navigate(`/sales-receipt/${res.data.ResponseID}`);
            // navigate(`/sales-receipt/${res.data.ResponseID}`);
          } else if (res.data.ResponseCode === "ERROR") {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      // Show error
      // console.log("Error: Quantity exceeds current quantity");
      toastError("Quantity exceeds current quantity");
    }
  };

  // const handleSuspend = (event) => {
  //   let taxdata = xmltax.filter(function (rowData) {
  //     return rowData.TaxName != "";
  //   });

  //   let customFielddata = customFieldSalesValues.filter(function (rowData) {
  //     return (
  //       rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
  //     );
  //   });

  //   let Itemdata = statenew.filter(function (salesItem) {
  //     return salesItem.itemsid != "";
  //   });

  //   let p = payments;
  //   originalPass = p;

  //   let paymentMethodData = originalPass.filter(function (paymentData) {
  //     return paymentData.PaymentId != "";
  //   });

  //   const Itemobj = {};
  //   let customValuesData = {};
  //   let taxValuesData = {};
  //   let paymentData = {};

  //   Itemobj.saleitemsXML = Itemdata;
  //   let itemjsonstring = JSON.stringify(Itemobj);

  //   customValuesData.customValueXML = customFielddata;
  //   let customvaluejsonstring = JSON.stringify(customValuesData);

  //   paymentData.paymentValueXML = paymentMethodData;
  //   let paymentvaluejsonstring = JSON.stringify(paymentData);

  //   taxValuesData.itemTaxXML = taxdata;
  //   let taxjsonstring = JSON.stringify(taxValuesData);

  //   // Create the form data object
  //   const formValuesDataToSend = {
  //     xmlsalesitems: itemjsonstring,
  //     xmlcustomfieldvalue: customvaluejsonstring,
  //     xmlitemspayment: paymentvaluejsonstring,
  //     xmlsalesitemtax: taxjsonstring,
  //     id: paramObject.id || 0,
  //     customerid: customerId, // selectedOption.value,
  //     comment: comment,
  //     saletypeid: saleTypeId,
  //     suspended: 1,
  //     // locationid: selectedLocation, // Location,
  //     locationid: Location,
  //     storeaccountpayment: isStoreAccountPaymentFlag,
  //     totalquantitypurchased: totalQuantity,
  //     totalquantityreceived: 0,
  //     subtotal: totalRef.current.toFixed(2),
  //     // total: totalRef.current.toFixed(2),
  //     total: selectedDropDownValue === 4 ? paymentAmount : netAmount,
  //     // total: selectedDropDownValue === 4 ? paymentAmount : netSubAmount,
  //     showcommentonreceipt: isChecked === true ? 1 : 0,
  //     estimate: 0,
  //     layaway: 1,
  //     // emailreceipt:
  //     discountreason: reason,
  //     discountentiresale: commonDiscount || 0,
  //     paymentcurrency: paymentCurrency,
  //     addcoupons: couponCode,
  //     loginuserid: Id,
  //     customerquickbookid: coustomerid || 0,
  //     shippingaddress: shippingaddress,
  //     custtierId: custtierId,
  //     deliveryMethodId: deliveryMethodId,
  //   };

  //   console.log("handle Suspend 2", formValuesDataToSend);
  //   // return;
  //   // Send the form data using axios
  //   axios
  //     .post(`${config.salesconfigBaseUrl}/sales/upsert`, formValuesDataToSend, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         "Access-Control-Allow-Origin": "*",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       // console.log(res);
  //       // setShowModal(true);
  //       // console.log("check 778899")
  //       setLoading(false);
  //       setStateNew([]);
  //       updateTotal([]);
  //       setEntireSaleDiscount([]);
  //       setSelectedPayment([]);
  //       setPayments([]);
  //       setTaxXml([]);
  //       setSelectedOption(null);
  //       setIsChecked([]);
  //       setCouponCode([]);
  //       setPaymentCurrency([]);
  //       setReason("");
  //       setCommonDiscount([]);
  //       localStorage.removeItem("saleDraft");
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });
  // };

  const handelDeliveryMethod = (value) => {
    setDeliveryMethodId(value);
    setSalesDeliveryData((prev) => ({ ...prev, deliveryMethodId: value }));
    if (paramObject.id === undefined) {
      const x = { ...localValues, deliveryMethodId: value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    // Filter the data based on the search value
    const filteredItems = statenew.filter((item) =>
      item.ItemName.replace(" - ", " ")
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setFilteredData(filteredItems);
  };

  const handleForCategorySearch = (event) => {
    if (event && event.value !== null) {
      setSelectedCategoryForSearch(event.value);
    } else {
      setSelectedCategoryForSearch(""); // or null, depending on your needs
    }
  };

  const handleVoid = (saletypeid, id, qbid) => {
    let rowdata = [];

    const obj = {
      quickbookid: qbid,
      type: saletypeid,
    };

    rowdata.push(obj);

    const deleteRequestParam = {
      quickbookarray: rowdata,
      saleids: id,
      locationid: Location,
      loginuserid: loginUserId,
      isSaleVoid: 1,
      salequickbookid: qbid,
    };

    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);

    // axios
    //   .get(
    //     `${config.salesconfigBaseUrl}/sales/voidsalebyid?saleid=${paramObject?.id}&locationid=${Location}&loginuserid=${loginUserId}`,

    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     toastSuccess("Sale void succcessfully done");
    //     navigate("/sales");
    //   })
    //   .catch((error) => {
    //     console.log(error.message);
    //   });
  };

  // For Categories
  let categoryDropdownOption = [];
  const categorytypeDropdown = selectedCategory.map((u, i) => {
    categoryDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  console.log(categoryDropdownOption, "categoryDropdownOption");

  const handleItemsDetailsData = (itemDetails) => {
    // console.log("itemDetails", itemDetails.ItemId);
    // setItemsDetailsData(itemDetails.ItemId);
    setItemsDetailsData(itemDetails);
  };

  // location dropdown Binding.
  let locationDropdownOption = [];
  const locationDropdown = locationdropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  console.log(locationDropdownOption, "locationDropdownOption 121212121");
  // handle Change for the location.

  const handelpaymentAmount = (e) => {
    setPaymentAmount(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, paymentAmount: e.target.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleLocationChange = (e) => {
    if (paramObject.id === undefined) {
      const x = { ...localValues, locationWarehouseDropdown: e.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
    console.log("selectedOption ==>", e.value);
    setSelectedLocation(e.value);
  };
  const [drill, setDrill] = useState(false);
  const handleDrillDown = (e) => {
    // console.log("drill", drill);
    drill ? setDrill(false) : setDrill(true);
  };
  // console.log("salesTypeDropdownOption::>>",salesTypeDropdownOption);

  let Compairamount = (
    parseFloat(dueAmount) + parseFloat(totalTaxAmount)
  ).toFixed(2);
  // console.log("totalTaxAmount", totalTaxAmount);

  const DefaultSellingPrice = [
    // {
    //   label: "Default Selling Price",
    //   value: 1
    // },
    {
      label: "Default Selling Price",
      value: 1,
    },
    {
      label: "Tier Price",
      value: 2,
    },
    {
      label: "Recall Price",
      value: 3,
    },
  ];

  const handleChangePrice = (event, index) => {
    if (event?.value !== null && event?.value !== undefined) {
      setSelectedPriceForSale(event.value);

      if (event?.value !== 2) {
        setTireObject(null);
      }
      if (
        event?.value === 2
        // || event?.value === 3  // recallp rice discount uncomment 30-08-2024
      ) {
        handleEntireSaleDiscountChange(0);
      }
    } else {
      setSelectedPriceForSale(1); // or null, depending on your needs
    }

    const selectedPrice = event?.value;

    let newUpdatedData = statenew.map((e, index) => {
      return {
        ...e,
        Price:
          selectedPrice == undefined
            ? statenew[index].UnitPrice
            : selectedPrice === 1
            ? statenew[index].UnitPrice
            : selectedPrice === 3
            ? statenew[index].RecallPrice
            : tireObject == "Tier1"
            ? statenew[index].Tier1
            : tireObject == "Tier2"
            ? statenew[index].Tier2
            : tireObject == "Tier3"
            ? statenew[index].Tier3
            : tireObject == "Tier4"
            ? statenew[index].Tier4
            : tireObject == "Tier5"
            ? statenew[index].Tier5
            : 0,
        Total: calculateTotal(
          selectedPrice == undefined
            ? statenew[index].UnitPrice
            : selectedPrice === 1
            ? statenew[index].UnitPrice
            : selectedPrice === 3
            ? statenew[index].RecallPrice
            : tireObject == "Tier1"
            ? statenew[index].Tier1
            : tireObject == "Tier2"
            ? statenew[index].Tier2
            : tireObject == "Tier3"
            ? statenew[index].Tier3
            : tireObject == "Tier4"
            ? statenew[index].Tier4
            : tireObject == "Tier5"
            ? statenew[index].Tier5
            : 0,
          e.itemquantity,
          e.itemdiscount
        ),
      };
    });

    updatedData = newUpdatedData;
    setStateNew(newUpdatedData);
    updateTotal(newUpdatedData);
  };

  useLayoutEffect(() => {
    function updatePosition() {
      setPosition(parseFloat(window.pageYOffset).toFixed(2));
    }
    window.addEventListener("scroll", updatePosition);
    // updatePosition();
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);

  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        setDefaultSellingTierPriceList(response.data?.ResponseData);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [selectedPriceForSale]);

  const handleRemoveLocalData = () => {
    localStorage.removeItem("saleDraft");
    localStorage.removeItem("EditTaxDraft");
    localStorage.removeItem("DeliveryDraft");
    localStorage.removeItem("dataAfterDelivery");
    window.location.reload();
  };
  const handleRemoveLocalDataEdit = () => {
    localStorage.removeItem("saleDraft");
    localStorage.removeItem("EditTaxDraft");
    localStorage.removeItem("DeliveryDraft");
    localStorage.removeItem("dataAfterDelivery");
    // window.location.reload();
  };

  const handleChangeTierPrice = (event, index) => {
    setTireObject(event?.value);

    console.log(event, "cfusvgfswdbhasdvbkjuhvbkasjuhcvbjhulw");
    const updateddata = [...statenew];
    updateddata[index] = {
      ...updateddata[index],
      Roletier: event?.id,
    };
    setStateNew(updateddata);

    console.log(statenew, "5555555");

    setCusttierId(event?.id ? event?.id : 0);

    const selectedPrice = event?.value;

    // updatedData = [...statenew];
    const newUpdatedData = statenew.map((e, index) => {
      return {
        ...e,
        // Roletier : custtierId,
        Price:
          selectedPriceForSale === 1
            ? statenew[index].UnitPrice
            : selectedPriceForSale === 3
            ? statenew[index].RecallPrice
            : selectedPrice == "Tier1"
            ? statenew[index].Tier1
            : selectedPrice == "Tier2"
            ? statenew[index].Tier2
            : selectedPrice == "Tier3"
            ? statenew[index].Tier3
            : selectedPrice == "Tier4"
            ? statenew[index].Tier4
            : selectedPrice == "Tier5"
            ? statenew[index].Tier5
            : 0,
        Total: calculateTotal(
          selectedPriceForSale === 1
            ? statenew[index].UnitPrice
            : selectedPriceForSale === 3
            ? statenew[index].RecallPrice
            : selectedPrice == "Tier1"
            ? statenew[index].Tier1
            : selectedPrice == "Tier2"
            ? statenew[index].Tier2
            : selectedPrice == "Tier3"
            ? statenew[index].Tier3
            : selectedPrice == "Tier4"
            ? statenew[index].Tier4
            : selectedPrice == "Tier5"
            ? statenew[index].Tier5
            : 0,
          e.itemquantity,
          e.itemdiscount
        ),
      };
    });

    updatedData = newUpdatedData;
    setStateNew(newUpdatedData);

    updateTotal(newUpdatedData);
  };

  useEffect(() => {
    if (paramObject.id === undefined) {
      //It's for the deliveryFees Draft
      const deliveryData = localStorage.getItem("DeliveryDraft") || "";
      if (deliveryData && paramObject.id === undefined) {
        const parsedDeliveryData = JSON.parse(deliveryData);
        setLocalValues(parsedDeliveryData);
        setDeliveryFees(parsedDeliveryData?.deliveryFees);

        setSalesDeliveryData({
          Id: 0,
          Saleid: 0,
          EmployeId: parsedDeliveryData?.deliveryEmployee,
          Status: parsedDeliveryData?.status,
          CategoryId: parsedDeliveryData?.category,
          Duration: parsedDeliveryData?.duration,
          LocationId: parsedDeliveryData?.location,
          FirstName: parsedDeliveryData?.salesDeliveryDetails?.FirstName,
          LastName: parsedDeliveryData?.salesDeliveryDetails?.LastName,
          Email: parsedDeliveryData?.salesDeliveryDetails?.Email,
          PhoneNumber: parsedDeliveryData?.salesDeliveryDetails?.PhoneNumber,
          ContactPrefrence:
            parsedDeliveryData?.salesDeliveryDetails?.selectedOption,
          Address1: parsedDeliveryData?.salesDeliveryDetails?.Address1,
          Address2: parsedDeliveryData?.salesDeliveryDetails?.Address2,
          City: parsedDeliveryData?.salesDeliveryDetails?.City,
          State: parsedDeliveryData?.salesDeliveryDetails?.StateProvince,
          Zip: parsedDeliveryData?.salesDeliveryDetails?.Zip,
          Country: parsedDeliveryData?.salesDeliveryDetails?.Country,
          TranckingNumber: parsedDeliveryData?.trackingNumber,
          Commesetitemnts: parsedDeliveryData?.deliveryComment,
          EstimatedShippingDate: parsedDeliveryData?.dateTime,
          EstimatedDeliveryDate: parsedDeliveryData?.deliveryDateTime,
          DeliveryFees: parsedDeliveryData?.deliveryFees,
          Shippingzoneid:
            parsedDeliveryData?.Shippingzoneid === undefined
              ? 0
              : parsedDeliveryData?.Shippingzoneid,
          Taxclassid:
            parsedDeliveryData?.taxDropdownValue === undefined
              ? 0
              : parsedDeliveryData?.taxDropdownValue,
          Loginuserid: loginUserId,
          Ispickup:
            parsedDeliveryData?.Ispickup === undefined
              ? 0
              : parsedDeliveryData?.Ispickup,
        });
      }
      //All Draft data for the manage sales
      const savedData = localStorage.getItem("saleDraft") || "";
      if (savedData && paramObject.id == undefined) {
        const parsedData = JSON.parse(savedData);
        setLocalValues(parsedData);
        setSelectedLocation(parsedData.locationWarehouseDropdown);
        if (parsedData?.saleDropdown != undefined) {
          setSelectDropDownValue(parsedData?.saleDropdown[0]);
          setselectedSaleOption(parsedData?.saleDropdown[1]);
        }
        setDeliveryMethodId(parsedData.deliveryMethodId || 0);
        setSelectedtags(parsedData.Tags);
        // setAccountSaleData(parsedData.TermsID);
        setcoustomerid(parsedData?.dropdownCustomers?.customerquickbookId);
        setcustomerId(parsedData?.dropdownCustomers?.value);
        setSelectedOption(parsedData?.dropdownCustomers);
        setStateNew(parsedData?.inputDropdown);
        setReason(parsedData?.Reason);
        setEntireSaleDiscount(parsedData?.DiscountChange);
        setCommonDiscount(
          parsedData?.EntireSale == undefined ? 0 : parsedData?.EntireSale
        );
        // handleCustomerDropdownChange(parsedData?.dropdownCustomers?.value);
        handleSelectChange(parsedData?.dropdownCustomers?.value);
        setAccountSaleData({
          ...accountSaleData,
          TermsID: parsedData?.TermsID == undefined ? 1 : parsedData?.TermsID,
          InvoiceMessage: parsedData?.InvoiceMessage,
          InvoiceStatement: parsedData?.InvoiceStatement,
          DueDate: parsedData?.DueDate || moment().format("YYYY-MM-DD"),
          InvoiceDate: parsedData?.InvoiceDate || moment().format("YYYY-MM-DD"),
          Attachment: parsedData?.Attachments,
        });
        setComment(parsedData?.finalComment);
        setPaymentAmount(parsedData?.paymentAmount);
        const draftTaxData = localStorage.getItem("EditTaxDraft") || "";

        if (parsedData?.taxArray && paramObject.id == undefined) {
          setTaxData(parsedData?.taxArray);
          setGlobalTaxData(parsedData?.taxArray);
        }
        // if (parsedData?.taxArray?.some((item) => item.type === "globalTax")) {
        // }
      }
    }
  }, []);

  const updateLocalValues = (statenew) => {
    if (paramObject.id === undefined) {
      const localValue1 = JSON.parse(localStorage.getItem("saleDraft")) || "";
      const x = { ...localValue1, inputDropdown: statenew };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  useEffect(() => {
    if (paramObject.id === undefined) {
      updateLocalValues(statenew);
    }
  }, [statenew]);

  const sumamount = statenew?.reduce((acc, curr) => {
    acc += Number(curr.Total);
    return acc;
  }, 0);

  const handelpayment = (e, index) => {
    const updateddata = [...statenew];
    updateddata[index] = { ...updateddata[index], Total: e?.target.value };
    setStateNew(updateddata);
  };

  const handleRowDelete = (index) => {
    const updateddata = [...statenew];
    updateddata.splice(index, 1);
    setStateNew(updateddata);
  };

  const handeldescription = (e, index) => {
    const updateddata = [...statenew];
    updateddata[index] = {
      ...updateddata[index],
      Description: e?.target.value,
    };
    setStateNew(updateddata);
  };

  const FilterdRowData = statenew?.filter(
    (item) =>
      item.Module !== "Accounts" &&
      (item.VariationId == 0 ? item.ItemName : item.VariationName)
        ?.toLowerCase()
        ?.includes(searchValue?.toLowerCase()) &&
      (selectedCategoryForSearch
        ? item.CategoryID === selectedCategoryForSearch
        : true)
  );

  const handelApplytoAllNewQty = () => {
    if (!newQtyToAll) {
      toastWarn("please fill New Qty before Apply to all");
      return;
    }

    const mainIndexList = FilterdRowData || [];

    const updateStateNew = [...statenew];
    mainIndexList.map((el) => {
      const filteredIndex = statenew.indexOf(el);
      updateStateNew[filteredIndex].itemquantity = newQtyToAll;

      let total = calculateTotal(
        updateStateNew[filteredIndex].Price,
        updateStateNew[filteredIndex].itemquantity,
        updateStateNew[filteredIndex].itemdiscount
      );
      updateStateNew[filteredIndex].Total = Number(total);
    });

    setStateNew(updateStateNew);
    updateTotal(updateStateNew);
    console.log(FilterdRowData, "qty clicked");
    setNewQtyToAll("");
  };

  const handelApplytoAllNewPrice = () => {
    if (!newPriceToAll) {
      toastWarn("please fill New Price before Apply to all");
      return;
    }
    console.log(FilterdRowData, "Price clicked");
    const mainIndexList = FilterdRowData || [];

    const updateStateNew = [...statenew];
    mainIndexList.map((el) => {
      const filteredIndex = statenew.indexOf(el);
      updateStateNew[filteredIndex].Price = newPriceToAll;

      let total = calculateTotal(
        updateStateNew[filteredIndex].Price,
        updateStateNew[filteredIndex].itemquantity,
        updateStateNew[filteredIndex].itemdiscount
      );
      updateStateNew[filteredIndex].Total = Number(total);
    });

    setStateNew(updateStateNew);
    updateTotal(updateStateNew);
    console.log(FilterdRowData, "qty clicked");
    setNewPriceToAll("");
  };



  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div
          className={`${
            restirctedit == 1 && selectedDropDownValue === 1 ? "" : "content"
          }  container-fluid`}
        >
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h5 className="page-title">Sales</h5> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/sales">Sales List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Sales</li>
              </ul>
            </div>
            {/* {salesTypeDropdownOption.map((option, index) => (
              <div className="col-md-2">
                <button
                  type="button"
                  // className="btn btn-outline-success mt-3 w-100"
                  className={`btn ${option.label === selectedSaleOption
                    ? "btn btn-primary"
                    : "btn-outline-primary"
                    } mt-3 w-100`}
                  value={option.value}
                  onClick={(e) => handleSuspendClick(e, option)}
                >
                  {option.label}
                </button>
              </div>
            ))} */}
          </div>
        </div>

        {restirctedit == 1 && selectedDropDownValue === 1 && (
          <div className="row align-center">
            <div
              style={{
                border: "1px solid",
                padding: "5px 10px",
                borderRadius: "5px",
                width: "fit-content",
                margin: "15px",
              }}
            >
              Payment transaction has been intiated, so you can't change the
              Sale Type
            </div>
          </div>
        )}

        {paramObject.id > 0 && saleIsVoid == 1 && (
          <div className="row align-center">
            <div
              style={{
                border: "1px solid",
                padding: "5px 10px",
                borderRadius: "5px",
                width: "fit-content",
                margin: "15px",
              }}
            >
              You marked this sale as void. Making changes that affect the sale
              total will reopen this sale.
            </div>
          </div>
        )}

        {!SaleQuickPermision && AllowQBSync && (
          <QuickbookSyncMessageComponent type="Sales" />
        )}

        <div className={`row ms-2 me-2`}>
          <div className="d-flex flex-column col-md-8 ">
            {/* <div class=""> */}
            {/* Accounting Sales new modification */}
            {/* <div className="card col-md-12"> */}
            {/* <div className="card-body" style={{ padding: "5px" }}>
                  <div className="d-flex flex-row justify-content-between">
                    <div className="p-2 col-md-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        value={saleTypeId}
                      >
                        <i className="fas fa-shopping-cart me-1"></i>
                        {selectedSaleOption}
                      </button>

                      <ul className="dropdown-menu">
                        {salesTypeDropdownOption.map((option, index) => (
                          <li key={index}>
                            <a
                              value={option.value}
                              className="dropdown-item"
                              onClick={
                                (event) =>
                                  handleOptionSelect(
                                    event,
                                    option.label,
                                    option.value
                                  )
                                // handleOptionSelect(event)
                              }
                            >
                              {option.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>{" "}
                    {(restirctedit == 1 && selectedDropDownValue===1) && (
                      <div
                        style={{
                          border: "1px solid red",
                          padding: "5px 10px",
                          color: "red",
                          borderRadius: "5px",
                        }}
                      >
                        Payment transaction has been intiated, so you can't
                        update the record.
                      </div>
                    )}
                    //  {selectedDropDownValue == 4 || (
                    //   <div className="p-2 col-md-6 ">
                    //     <Select
                    //       placeholder="WareHouse"
                    //       className="w-100"
                    //       options={locationDropdownOption}
                    //       styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    //       onChange={(e) => handleLocationChange(e)}
                    //       value={locationDropdownOption.find(
                    //         (option) => option?.value == selectedLocation
                    //       )}
                    //     />
                    //   </div>
                    // )} 
                    {(selectedDropDownValue === 1 ||
                      selectedDropDownValue === 2 ||
                      selectedDropDownValue === 3) && (
                      <div
                        className="p-2 col-md-4"
                        style={{
                          marginTop: "6px",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "16px",
                        }}
                      >
                        // <div className="p-2 col-md-5"> 
                        <span>
                          {selectedDropDownValue === 1
                            ? "Invoice Number:"
                            : selectedDropDownValue === 2
                            ? "Return Number:"
                            : selectedDropDownValue === 3
                            ? "Estimated Number:"
                            : ""}{" "}
                        </span>
                      
                        <span
                        // style={{
                        //   // "font-size": "20px",
                        //   // "font-weight": "bold",
                        //   // marginTop:"20px"
                        // }}
                        >
                          {accountSaleData?.InvoiceNumber}
                        </span>
                      </div>
                    )}
                  </div>

                  //  {selectedDropDownValue === 5 && (
                  //   <>
                  //     <div className="d-flex flex-row">
                  //       <div className="p-2 col-md-12"></div>
                  //     </div>
                  //     <div className="d-flex flex-row">
                  //       <div className="p-2 col-md-4">
                  //         <span>Sales Receipt Number: </span>
                  //         <input
                  //           type="number"
                  //           id="InvoiceNumber"
                  //           name="InvoiceNumber"
                  //           placeholder="Invoice Number"
                  //           className="form-control"
                  //           min="0"
                  //           onChange={(event) =>
                  //             handleChangeAccountSalesData(
                  //               event,
                  //               "InvoiceNumber"
                  //             )
                  //           }
                  //           value={accountSaleData?.InvoiceNumber}
                  //         />
                  //       </div>
                  //       <div className="p-2 col-md-4">
                  //         Sales Receipt Date:
                  //         <input
                  //           type="date"
                  //           className="form-control"
                  //           id="SaleReceiptDate"
                  //           name="SaleReceiptDate"
                  //           value={todayDate}
                  //         />
                  //       </div>
                  //       <div className="p-2 col-md-4">
                  //         Attachments:
                  //         <input
                  //           type="file"
                  //           className="form-control"
                  //           id="Receipt"
                  //           name="Receipt"
                  //           onChange={handleFileChange}
                  //         />
                  //         {accountSaleData?.Attachment == undefined ? (
                  //           ""
                  //         ) : (
                  //           <Link
                  //             to={accountSaleData?.Attachment}
                  //             target="_blank"
                  //           >
                  //             Attachment Link
                  //           </Link>
                  //         )}
                  //       </div>
                  //     </div>
                  //     <div className="d-flex flex-row">
                  //       <div className="p-2 col-md-6">
                  //         Tags:
                  //         <Select
                  //           onChange={(event) => {
                  //             handleChangeAccountSalesData(event, "Tags");
                  //           }}
                  //           value={tagOptions.filter((obj) =>
                  //             selectedtags.includes(obj.value)
                  //           )}
                  //           options={tagOptions}
                  //           backspaceRemovesValue={false}
                  //           controlShouldRenderValue={true}
                  //           hideSelectedOptions={true}
                  //           isClearable={true}
                  //           isMulti={true}
                  //           styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  //           id="Tags"
                  //           name="Tags"
                  //         />
                  //       </div>
                  //     </div>
                  //     <div className="d-flex flex-row mb-2">
                  //       <div className="p-2 col-md-4">
                  //         Message displayed on sales receipt:
                  //         <textarea
                  //           id="InvoiceMessage"
                  //           name="InvoiceMessage"
                  //           placeholder="Message displayed on sales receipt"
                  //           className="form-control h-100"
                  //           onChange={(event) =>
                  //             handleChangeAccountSalesData(
                  //               event,
                  //               "InvoiceMessage"
                  //             )
                  //           }
                  //           defaultValue={accountSaleData?.InvoiceMessage}
                  //         ></textarea>
                  //       </div>
                  //       <div className="p-2 col-md-4">
                  //         Message displayed on statement
                  //         <textarea
                  //           id="InvoiceStatement"
                  //           name="InvoiceStatement"
                  //           placeholder="Message displayed on statement"
                  //           className="form-control h-100"
                  //           onChange={(event) =>
                  //             handleChangeAccountSalesData(
                  //               event,
                  //               "InvoiceStatement"
                  //             )
                  //           }
                  //           defaultValue={accountSaleData?.InvoiceStatement}
                  //         ></textarea>
                  //       </div>
                  //       <div className="p-2 col-md-4">
                  //         Billing Address:
                  //         <textarea
                  //           id="BillingAddress"
                  //           name="BillingAddress"
                  //           placeholder="Billing Address"
                  //           className="form-control h-100"
                  //           onChange={(event) =>
                  //             handleChangeAccountSalesData(
                  //               event,
                  //               "BillingAddress"
                  //             )
                  //           }
                  //           defaultValue={
                  //             customerAddress == undefined ||
                  //               customerAddress == ""
                  //               ? ""
                  //               : customerAddress
                  //           }
                  //         ></textarea>
                  //       </div>
                  //     </div>
                  //   </>
                  // )} 

                  {(selectedDropDownValue === 1 ||
                    selectedDropDownValue === 2 ||
                    selectedDropDownValue === 4 ||
                    selectedDropDownValue === 3) && (
                    <>
                      <div className="d-flex flex-row">
                        {selectedDropDownValue === 1 && (
                          <div className="p-2 col-md-3">
                            Terms:
                            <Select
                              onChange={(event) => {
                                handleChangeAccountSalesData(event, "TermsID");
                              }}
                              value={termOptions.find(
                                (option) =>
                                  option?.value == accountSaleData?.TermsID
                              )}
                              options={termOptions}
                              backspaceRemovesValue={false}
                              // controlShouldRenderValue={true}
                              // isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="TermsID"
                              name="TermsID"
                              className="custom-search-select"
                              // hideSelectedOptions={true}
                            />
                          </div>
                        )}

                        <div className="p-2 col-md-3">
                          <span>
                            {selectedDropDownValue === 1
                              ? "Invoice Date:"
                              : selectedDropDownValue === 2
                              ? "Return Date:"
                              : selectedDropDownValue === 4
                              ? "Payment Date:"
                              : selectedDropDownValue === 3
                              ? "Estimate Date:"
                              : ""}{" "}
                          </span>
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            id="InvoiceDate"
                            name="InvoiceDate"
                            // value={todayDate}
                            value={
                              accountSaleData?.InvoiceDate == ""
                                ? todayDate
                                : accountSaleData?.InvoiceDate
                            }
                            onChange={(event) =>
                              handleChangeInvoiceDate(event, "InvoiceDate")
                            }
                          />
                        </div>

                        {(selectedDropDownValue === 1 ||
                          selectedDropDownValue === 3) && (
                          <>
                            <div className="p-2 col-md-3">
                              <span>
                                {selectedDropDownValue === 1
                                  ? "Due Date:"
                                  : selectedDropDownValue === 4
                                  ? "Payment Date:"
                                  : selectedDropDownValue === 3
                                  ? "Expiration Date:"
                                  : ""}{" "}
                              </span>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                id="DueDate"
                                name="DueDate"
                                onChange={(event) =>
                                  handleChangeAccountSalesData(event, "DueDate")
                                }
                                value={Moment(
                                  accountSaleData?.DueDate == ""
                                    ? Moment(new Date()).format("yyyy-MM-DD")
                                    : accountSaleData?.DueDate
                                ).format("yyyy-MM-DD")}
                              />
                            </div>
                          </>
                        )}

                        //  <div className="p-2 col-md-6">
                        //     Attachments:
                        //     <input
                        //       type="file"
                        //       className="form-control form-control-sm"
                        //       id="Receipt"
                        //       name="Receipt"
                        //       onChange={handleFileChange}
                        //     />
                        //     {accountSaleData?.Attachment == undefined ||
                        //       accountSaleData?.Attachment == "" ? (
                        //       ""
                        //     ) : (
                        //       <Link
                        //         to={accountSaleData?.Attachment}
                        //         target="_blank"
                        //       >
                        //         Attachment Link
                        //       </Link>
                        //     )}
                        //   </div> 
                      </div>

                      <div className="d-flex flex-row">
                        <div className="p-2 col-md-7">
                          Tags:
                          <Select
                            onChange={(event) => {
                              handleChangeAccountSalesData(event, "Tags");
                            }}
                            // value={outputMatchedOptions}
                            value={tagOptions?.filter((obj) =>
                              selectedtags?.includes(obj.value)
                            )}
                            options={tagOptions}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            isMulti={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            id="Tags"
                            name="Tags"
                            className="custom-search-select"
                          />
                        </div>
                        <div className="p-2 col-md-4">
                          Attachments:
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="Receipt"
                            name="Receipt"
                            onChange={handleFileChange}
                          />
                          {accountSaleData?.Attachment == undefined ||
                          accountSaleData?.Attachment == "" ? (
                            ""
                          ) : (
                            <Link
                              to={accountSaleData?.Attachment}
                              target="_blank"
                            >
                              Attachment Link
                            </Link>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div> */}
            {/* </div>
            </div> */}
            <div class="">
              <div className="card col-md-12">
                <div className="card-body">
                  {/* {selectedDropDownValue != 4 && ( */}
                  <>
                    {selectedDropDownValue != 4 && toggleItemsFilterSection && (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="d-flex flex-row gap-2">
                          {/* Default Selling Price */}
                          <div className="col-md-6">
                            Price Rule
                            <Select
                              options={DefaultSellingPrice}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              onChange={(e, index) =>
                                handleChangePrice(e, index)
                              }
                              value={DefaultSellingPrice?.find(
                                (el) => el.value === selectedPriceForSale
                              )}
                              className="custom-select-search"
                            />
                          </div>
                          {selectedPriceForSale == 2 && (
                            <>
                              <div className="col-md-6">
                                Role Tier
                                <Select
                                  options={defaultSellingTierPriceList.map(
                                    (tire) => ({
                                      label: tire.Name,
                                      value: tire.Code,
                                      id: tire.ID,
                                    })
                                  )}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  onChange={(e, index) =>
                                    handleChangeTierPrice(e, index)
                                  }
                                  className="custom-select-search"
                                />
                              </div>
                            </>
                          )}
                        </div>

                        <div className="d-flex flex-row mt-2 gap-2">
                          {/* Search Invoice Below */}
                          <div className="col-md-6">
                            Search Items Below
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Items"
                              className="form-control"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            ></input>
                          </div>
                          {/* Filter Category */}
                          <div className="col-md-6">
                            Filter Category
                            <Select
                              onChange={(event) => {
                                handleForCategorySearch(event);
                              }}
                              options={categoryDropdownOption}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row mt-2 gap-2">
                          <div
                            className="d-flex col-md-6 gap-3"
                            style={{ borderRight: "black" }}
                          >
                            <div className="">
                              New Qty:
                              <input
                                name="newQtyToAll"
                                type="number"
                                value={newQtyToAll}
                                onChange={(e) => setNewQtyToAll(e.target.value)}
                                className="form-control"
                              ></input>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary mt-4"
                              onClick={() => handelApplytoAllNewQty()}
                            >
                              Apply to All
                            </button>
                          </div>
                          <div className="d-flex col-md-6 gap-3">
                            <div className="">
                              New Price:
                              <input
                                name="newPriceToAll"
                                type="number"
                                value={newPriceToAll}
                                onChange={(e) =>
                                  setNewPriceToAll(e.target.value)
                                }
                                className="form-control"
                              ></input>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary mt-4"
                              onClick={() => handelApplytoAllNewPrice()}
                            >
                              Apply to All
                            </button>
                          </div>
                        </div>
                        {selectedDropDownValue !== 4 && (
                          <div className="d-flex flex-row mt-3">
                            {/* <div className="col-md-12 "> */}
                            <div className="form-check form-switch mb-3 pull-right">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="toggle-button"
                                checked={isContentVisible}
                                onClick={() =>
                                  setIsContentVisible(!isContentVisible)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="toggle-button"
                              >
                                {isContentVisible
                                  ? "Disable Pick List"
                                  : "Enable Pick List"}
                              </label>
                            </div>
                            {/* </div> */}
                          </div>
                        )}
                      </div>
                    )}

                    {selectedDropDownValue == 4 && toggleItemsFilterSection && (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex" }}>
                          {/* Default Selling Price */}

                          {/* Search Invoice Below */}
                          <div className="p-2 col-md-4">
                            Search Items Below
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Items"
                              className="form-control"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            ></input>
                          </div>
                        </div>
                        {/* Filter Category */}
                      </div>
                    )}

                    <div className="d-flex flex-wrap gap-2 mt-2 p-2">
                      <div className="d-flex w-8 ">
                        <div className="custom-fill-available">
                          <React.Fragment>
                            {selectedOption?.value ? (
                              <SearchableDropdown
                                customerID={customerId}
                                callback={callback}
                                options={options}
                                value={selectedDropDownValue}
                                // readonly={isReadOnly}
                                callbackaccount={callbackaccount}
                                searchItemInputRef={searchItemInputRef}
                              />
                            ) : (
                              <SearchableDropdown
                                customerID={customerId}
                                callback={callback}
                                options={options}
                                readonly={
                                  //  isReadOnly
                                  isReadOnly
                                }
                                value={selectedDropDownValue}
                                callbackaccount={callbackaccount}
                                searchItemInputRef={searchItemInputRef}
                              />
                            )}
                          </React.Fragment>
                        </div>
                        <div className="">
                          <button
                            type="button"
                            className="btn btn-sm btn-primary dropdown-toggle border-size"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            value={saleTypeId}
                          >
                            <i className="fas fa-shopping-cart me-1"></i>
                            {selectedSaleOption}
                          </button>

                          <ul className="dropdown-menu col-md-3">
                            {salesTypeDropdownOption.map((option, index) => (
                              <li key={index} className="w-30">
                                <a
                                  value={option.value}
                                  className="dropdown-item"
                                  onClick={(event) =>
                                    handleOptionSelect(
                                      event,
                                      option.label,
                                      option.value
                                    )
                                  }
                                >
                                  {option.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      {/* <div className="d-flex flex-row justify-content-between"> */}

                      {(selectedDropDownValue === 1 ||
                        selectedDropDownValue === 2 ||
                        // selectedDropDownValue === 4 ||
                        selectedDropDownValue === 3) && (
                        <div className="col-md-2 item">
                          <Link
                            // type="button"
                            className="btn btn-secondary w-80"
                            data-bs-target="#exampleModal"
                            data-bs-toggle="modal"
                            onClick={() => {
                              if (selectedcustomer.length == 0) {
                                toastError("Select Customer First");
                              } else {
                                setRunApi(true);
                              }
                            }}
                          >
                            <i className="fa fa-filter me-1"></i> Item Grid
                          </Link>
                        </div>
                      )}

                      <div className="">
                        <Link
                          type="button"
                          className="btn btn-secondary w-20"
                          onClick={() =>
                            setToggleItemsFilterSection(
                              !toggleItemsFilterSection
                            )
                          }
                        >
                          {!toggleItemsFilterSection ? (
                            <>
                              <i className="fa fa-arrow-up me-1"></i>
                              Filter{" "}
                            </>
                          ) : (
                            <>
                              <i className="fa fa-arrow-down me-1"></i>
                              Filter{" "}
                            </>
                          )}
                        </Link>
                      </div>
                    </div>

                    {/* {selectedDropDownValue !== 4 && (
                      <div className="d-flex flex-row mt-3">
                        <div className="col-md-12 ">
                          <div className="form-check form-switch mb-3 pull-right">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="toggle-button"
                              checked={isContentVisible}
                              onClick={() =>
                                setIsContentVisible(!isContentVisible)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="toggle-button"
                            >
                              {isContentVisible
                                ? "Disable Pick List"
                                : "Enable Pick List"}
                            </label>
                          </div>
                        </div>
                      </div>
                    )} */}
                  </>
                  {/* )}  */}

                  <div className="row mt-3 ">
                    <div className="col-md-12 ">
                      <div className="table-responsive">
                        <table className="table custom-table">
                          <thead>
                            <tr>
                              {selectedDropDownValue !== 4 && (
                                <>
                                  {drill ? (
                                    <th
                                      style={{ width: "50px" }}
                                      onClick={(e) => handleDrillDown(e)}
                                    >
                                      <i class="fa fa-minus"></i> No.
                                    </th>
                                  ) : (
                                    <th
                                      style={{ width: "50px" }}
                                      onClick={(e) => handleDrillDown(e)}
                                    >
                                      <i class="fa fa-plus"></i> No.
                                    </th>
                                  )}
                                </>
                              )}

                              {selectedDropDownValue === 4 && (
                                <>
                                  <th>No.</th>
                                  <th>Category</th>
                                  <th>Description</th>
                                  <th>Amount</th>
                                  <th>Delete</th>
                                  <th>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="CheckBox"
                                      id="CheckBox"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  </th>
                                </>
                              )}

                              {selectedDropDownValue != 4 && (
                                <>
                                  <th style={{ width: "150px" }}>Price</th>
                                  <th style={{ width: "120px" }}>Qty</th>
                                  {(selectedPriceForSale == 1 ||
                                    selectedPriceForSale == 3 ||
                                    selectedPriceForSale == "" ||
                                    selectedPriceForSale == null) &&
                                    !SaleQuickPermision && (
                                      <th style={{ width: "120px" }}>
                                        Disc.(%)
                                      </th>
                                    )}
                                  <th style={{ width: "120px" }}>Total</th>
                                  {isTax == "true" ? (
                                    <th style={{ width: "120px" }}>finalTax</th>
                                  ) : (
                                    <> </>
                                  )}
                                  <th
                                    style={{ width: "50px" }}
                                    className="text-center"
                                  ></th>
                                  <th
                                    style={{ width: "50px" }}
                                    className="text-center"
                                  >
                                    {isContentVisible && (
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="CheckBox"
                                        id="CheckBox"
                                        onChange={(e) => {
                                          const checkboxes =
                                            document.querySelectorAll(
                                              'tbody input[type="checkbox"]'
                                            );
                                          checkboxes.forEach((checkbox) => {
                                            checkbox.checked = e.target.checked;
                                          });
                                        }}
                                      />
                                    )}
                                  </th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {selectedDropDownValue === 4 &&
                              statenew?.map((item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{item.ItemName}</td>
                                      <td>
                                        <input
                                          id="Description"
                                          name="Description"
                                          type="text"
                                          className="form-control "
                                          value={item?.Description}
                                          onChange={(e) =>
                                            handeldescription(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          id="paymentamount"
                                          name="paymentamount"
                                          type="number"
                                          className="form-control "
                                          value={item?.Total}
                                          onChange={(e) =>
                                            handelpayment(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <Link
                                          className="confirm-text"
                                          to="#"
                                          title="Delete"
                                          style={{ fontSize: "12px" }}
                                          onClick={() => handleRowDelete(index)}
                                        >
                                          <i
                                            className="fa fa-trash text-red fa-2x"
                                            data-bs-toggle="tooltip"
                                            title="Delete"
                                          ></i>
                                        </Link>
                                      </td>

                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name={`CheckBox${index}`}
                                          id={`CheckBox${index}`}
                                          defaultChecked={item.Ischecked}

                                          // onChange={(e) =>
                                          //   handleCheckboxChange(e, index)
                                          // }
                                        />
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                            {selectedDropDownValue != 4 &&
                              statenew
                                ?.filter(
                                  (item) =>
                                    item.Module !== "Accounts" &&
                                    (item.VariationId == 0
                                      ? item.ItemName
                                      : item.VariationName
                                    )
                                      ?.toLowerCase()
                                      ?.includes(searchValue?.toLowerCase()) &&
                                    (selectedCategoryForSearch
                                      ? item.CategoryID ===
                                        selectedCategoryForSearch
                                      : true)
                                )
                                ?.map((item, index) => {
                                  const filteredIndex = statenew?.indexOf(item);
                                  return (
                                    <>
                                      <tr
                                        key={item.modifyid}
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        <td rowSpan={2}>{item.mainIndex}</td>
                                        {/* <td></td> */}
                                        <td colSpan={7} className="p-1">
                                          <Link
                                            type="button"
                                            onClick={(e) =>
                                              handleItemsDetailsData(item)
                                            }
                                            data-bs-target="#ItemsDetailsModal"
                                            data-bs-toggle="modal"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <p
                                              className="word-break-data"
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                              }}
                                            >
                                              {item.VariationName != "" &&
                                              item.VariationName != null
                                                ? item.VariationName
                                                : item.ItemName}

                                                {/* if you want to show aos right side of items */}


                                                 {/* {item?.AvgUnitPrice && item?.AvgQuantity && enableAOSForItemAndVariation && (
                                                    <span className="custom-text-green fw-bold ml-4">
                                                      [ AOS:  {item.AvgQuantity} |{" "}
                                                      {CurrencySymbols(Number(item.AvgUnitPrice), {
                                                        CurrencySymbol,
                                                      }, FractionDigits)} ]
                                                    </span>
                                                 )} */}
                                            </p>
                                            {/* {item.ItemName} (
                                            {item.VariationName}) */}
                                            {/* ({item.VariationName}) */}
                                          </Link>
                                        </td>
                                      </tr>
                                      <tr
                                        key={item.modifyid}
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Price{" "}
                                            {item.isReCallPrice !== "" &&
                                              selectedPriceForSale == 3 && (
                                                <span
                                                  style={
                                                    item.RecallPrice ===
                                                    item.UnitPrice
                                                      ? {}
                                                      : {
                                                          color:
                                                            "var(--secondary-main-color)",
                                                        }
                                                  }
                                                >
                                                  (Recall Alert)
                                                </span>
                                              )}
                                          </span>
                                          {/* <input
                                            type="text"
                                            min="0.01"
                                            // value={CurrencySymbols(
                                            //   Number(item.Price),
                                            //   { CurrencySymbol },
                                            //   FractionDigits
                                            // )}
                                            value={`${CurrencySymbol} ${item.Price}`}
                                            // value={item.Price}
                                            // className="form-control pricecontrol"
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              const value = Number(e.target.value);
                                              if (value >= 0 &&   Number( e?.target?.value.replace("$", " ").trim()) <= Number(item.Price)) {
                                                handlePriceChange1(
                                                  filteredIndex,
                                                  Number(e.target.value)
                                                );
                                              }
                                            }}
                                          /> */}
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // value={CurrencySymbols(Number(item.Price),{CurrencySymbol},FractionDigits)} // Render value with currency symbol
                                            value={`${CurrencySymbol} ${item.Price}`} // Render value with currency symbol
                                            onChange={(e) => {
                                              const rawValue = e.target.value
                                                .replace(CurrencySymbol, "")
                                                .trim(); // Remove currency symbol
                                              const numericValue = rawValue; // Convert to number

                                              if (
                                                !isNaN(numericValue) &&
                                                numericValue >= 0
                                              ) {
                                                handlePriceChange(
                                                  filteredIndex,
                                                  numericValue
                                                ); // Pass numeric value to the function
                                              }
                                            }}
                                          />
                                        </td>

                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Qty
                                          </span>
                                          <input
                                            ref={
                                              index === 0 ? qtyInputRef : null
                                            }
                                            type="number"
                                            min="0.01"
                                            value={item.itemquantity}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (value >= 0) {
                                                handleQuantityChange(
                                                  filteredIndex,
                                                  value
                                                );
                                              }
                                            }}
                                            onKeyDown={handleQtyKeyDown}
                                          />

                                          {validationErrors[filteredIndex] && (
                                            <p className="text-danger">
                                              {validationErrors[filteredIndex]}
                                            </p>
                                          )}
                                        </td>

                                        {/* value={entireSaleDiscount}
                            onChange={handleEntireSaleDiscountChange} */}
                                        {(selectedPriceForSale == 1 ||
                                          selectedPriceForSale == 3 ||
                                          selectedPriceForSale == "" ||
                                          selectedPriceForSale == null) &&
                                          !SaleQuickPermision && (
                                            <td className="table-control-td">
                                              <span className="table-control-label">
                                                Discount
                                              </span>
                                              <div className="input-group input-group-sm discount-group">
                                                <input
                                                  type="number"
                                                  value={item.itemdiscount}
                                                  className="form-control form-control-sm"
                                                  onChange={(e) =>
                                                    handleDiscountChange(
                                                      filteredIndex,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary"
                                                  onClick={() =>
                                                    handleToggleDiscountType(
                                                      filteredIndex
                                                    )
                                                  }
                                                >
                                                  {item.DiscountType ===
                                                  "amount"
                                                    ? CurrencySymbol
                                                    : "%"}
                                                </button>
                                              </div>
                                            </td>
                                          )}
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Total
                                          </span>
                                          <input
                                            type="text"
                                            value={`${CurrencySymbol} ${item.Total}`}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              // Remove the currency symbol and trim whitespace
                                              const rawValue = e.target.value
                                                .replace(CurrencySymbol, "")
                                                .trim();

                                              // Parse to a valid number
                                              const numericValue = rawValue;

                                              // Proceed only if the value is a valid number
                                              if (!isNaN(numericValue)) {
                                                handleTotalChange(
                                                  filteredIndex,
                                                  numericValue
                                                );
                                              }
                                            }}
                                          />

                                          {/* {calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)} */}
                                        </td>

                                        {/* <td style={{width:"136px"}} className="table-control-td">
                                          <span className="table-control-lable">
                                            AOS
                                          </span>
                                          <input
                                            type="text"
                                            value={`${item.AvgQuantity} | ${CurrencySymbol} ${item.AvgUnitPrice} `}
                                            className="form-control form-control-sm"
                                            disabled
                                           
                                          />
                                        </td> */}

                                        {isTax == "true" ? (
                                          <td className="table-control-td">
                                            <span className="table-control-lable">
                                              finalTax
                                            </span>
                                            <input
                                              type="number"
                                              // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                              value={item?.LineTax}
                                              className="form-control form-control-sm"
                                              // style={{ width: "max-content" }}
                                              onChange={(e) =>
                                                handleTotalChange(
                                                  filteredIndex,
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {/* {calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)} */}
                                          </td>
                                        ) : (
                                          <> </>
                                        )}

                                        {/* <td className="text-center"> */}
                                        <td>
                                          <Link
                                            className="confirm-text"
                                            title="Delete"
                                            style={{ fontSize: "12px" }}
                                            onClick={() =>
                                              handleItemsDelete(filteredIndex)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </Link>
                                        </td>
                                        {/* <td className="text-center"> */}
                                        <td>
                                          {isContentVisible && (
                                            <input
                                              className="form-check-input"
                                              // style={{ width: "1.5em", height: "1.5em", }}
                                              type="checkbox"
                                              name={`CheckBox${filteredIndex}`}
                                              id={`CheckBox${filteredIndex}`}
                                              defaultChecked={item.Ischecked}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  filteredIndex
                                                )
                                              }
                                            />
                                          )}
                                        </td>
                                      </tr>

                                      {drill && (
                                        <tr
                                          className={
                                            "gridrow-" +
                                            (filteredIndex % 2 ? "even" : "odd")
                                          }
                                        >
                                          <td colSpan={8} className="p-0">
                                            <div className="bottom-table">
                                              <table className="custom-table">
                                                <tbody>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Category:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item?.CategoryName}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Stock:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item.ItemCurrentQuantity ==
                                                      undefined
                                                        ? 0
                                                        : item.ItemCurrentQuantity}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      UPC/EAN/ISBN:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item.Itemnumber ==
                                                      undefined
                                                        ? "-"
                                                        : item.Itemnumber}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Selling Price:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item.UnitPrice}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      ReCall Price:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item.RecallPrice +
                                                        `${
                                                          item.isReCallPrice
                                                            ? " (" +
                                                              moment(
                                                                item.isReCallPrice
                                                              ).format(
                                                                "MM/DD/YYYY"
                                                              ) +
                                                              ")"
                                                            : ""
                                                        }`}
                                                    </td>
                                                  </tr>
                                                        <tr className="custom-row">
                                                <td className="custom-cell"></td>
                                                <td className="custom-cell">AOS Price:</td>
                                                <td className="custom-cell-pos nowrap">
                                                  {/* Click Here (only when not opened) */}
                                                  {!aosOpenByItem[itemKey(item)] && (
                                                    <div className="">
                                                      {/* <span>AOS:</span> */}
                                                      <span
                                                        style={{
                                                          fontSize: "12px",
                                                          cursor: "pointer",
                                                          textDecoration: "underline",
                                                        }}
                                                        onClick={() => openAosFor(item)}
                                                      >
                                                        Click Here
                                                      </span>
                                                    </div>
                                                  )}

                                                  {/* AOS summary */}
                                                  {aosOpenByItem[itemKey(item)] && (
                                                    <>
                                                      <span className="custom-text-green ml-1">
                                                        AOS QTY: {item?.AvgQuantity ?? "-"}
                                                      </span>

                                                      {/* Show small + to open price */}
                                                      {!priceOpenByItem[itemKey(item)] && (
                                                        <span
                                                          style={{ cursor: "pointer" }}
                                                          onClick={() => togglePriceFor(item)}
                                                        >
                                                          {" | + "}
                                                        </span>
                                                      )}
                                                    </>
                                                  )}

                                                  {/* AOS Price panel */}
                                                  {priceOpenByItem[itemKey(item)] && (
                                                    <span
                                                      className="custom-text-green"
                                                      style={{ display: "inline-flex" }}
                                                    >
                                                      <span className="ml-1 mr-1"> | </span>
                                                      AOS Price:{" "}
                                                      {item?.AvgUnitPrice
                                                        ? CurrencySymbols(
                                                            Number(item.AvgUnitPrice),
                                                            { CurrencySymbol },
                                                            FractionDigits
                                                          )
                                                        : ""}
                                                      <span
                                                        className="ml-1 mr-1"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => togglePriceFor(item)}
                                                      >
                                                        {" - "}
                                                      </span>
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>


                                                  {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 4272-4301       */}
                                                  {/* <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Tax:
                                                    </td>
                                                    <td className="custom-cell">
                                                      <Link
                                                        type="button"
                                                        // data-bs-target="#EditModal"
                                                        data-bs-target={`#EditModal-${item.VariationId}`}
                                                        data-bs-toggle="modal"
                                                        style={{
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        Edit Taxes
                                                      </Link>
                                                      <EditTax
                                                        callback={
                                                          callbackHandleEditTax
                                                        }
                                                        index={index}
                                                        VariationID={
                                                          item.VariationId
                                                        }
                                                        ItemID={item.ItemId}
                                                      />
                                                    </td>
                                                  </tr> */}
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* <div className="d-flex bottom-table">
                                              <span className="m-2"></span>
                                              <span className="m-2 word-break-data">
                                                Category: {item?.CategoryName}
                                              </span>
                                              <span className="m-2">
                                                Stock:{" "}
                                                {item.ItemCurrentQuantity}
                                              </span>
                                              <span className="m-2">
                                                UPC/EAN/ISBN: {item.Itemnumber}{" "}
                                              </span>
                                              <span className="m-2">Cost: {item.CostPrice}</span>
                                              <span className="m-2">
                                                Selling Price: {item.UnitPrice}
                                              </span>
                                              <span className="m-2">
                                                Tax:{" "}
                                                <Link
                                                  type="button"
                                                  // data-bs-target="#EditModal"
                                                  data-bs-target={`#EditModal-${item.VariationId}`}
                                                  data-bs-toggle="modal"
                                                  style={{
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  Edit Taxes
                                                </Link>
                                              </span>

                                              <EditTax
                                                callback={callbackHandleEditTax}
                                                index={index}
                                                VariationID={item.VariationId}
                                                ItemID={item.ItemId}
                                              />
                                            </div> */}
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  );
                                })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 scroll-position">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between mb-2 pl-2 pr-2">
                  <div className="card-Supplier-Customer">Customer</div>

                  {paramObject.id ? (
                    <p className=" mt-1"> Edit Mode </p>
                  ) : (
                    <> </>
                  )}
                  <div className="d-flex">
                    <button
                      className="btn btn-sm btn-clear-Data mr-2"
                      type="button"
                      data-bs-target="#HistoryModel"
                      data-bs-toggle="modal"
                      onClick={() => setShowHistoryList(true)}
                    >
                      History
                    </button>
                    {restirctedit !== 1 && (
                      <>
                        {paramObject.id == undefined && (
                          <button
                            className="btn btn-sm btn-clear-Data mr-2 edit_btn_space"
                            onClick={handleRemoveLocalData}
                          >
                            Clear Data
                          </button>
                        )}
                        {paramObject.id > 0 &&
                          saleTypeId == 1 &&
                          saleIsVoid == 0 && ( // && isEcommerce === 1
                            <button
                              className="btn btn-sm btn-clear-Data mr-2 edit_btn_space"
                              // data-bs-target="#ConfirmModal"
                              // data-bs-toggle="modal"
                              onClick={() =>
                                handleVoid(
                                  saleTypeId,
                                  paramObject.id,
                                  quickbookid
                                )
                              }
                            >
                              Void
                            </button>
                          )}
                      </>
                    )}
                    <Link
                      onClick={handleRemoveLocalDataEdit}
                      to="/sales"
                      className="btn btn-sm btn-clear-Data mr-2 edit_btn_space"
                    >
                      Cancel Edit
                    </Link>
                    <div className="btn-group btn-group-sm pull-right">
                      {
                        // checkUserPermission(PERMISSION_BATCHSALES) ||
                        checkUserPermission(PERMISSION_LOOKUPRECEIPT) ||
                        //  checkUserPermission(PERMISSION_CUSTOMFIELD) ||
                        checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                          <button
                            type="button"
                            className="btn me-1 btn-clear-Data"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            // style={{fontSize:"6px"}}
                          >
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>{" "}
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>{" "}
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>
                          </button>
                        ) : (
                          " "
                        )
                      }

                      {/* <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                        <i className="fas fa-ellipsis-h me-1 fs-6"></i>
                        </button> */}
                      <ul className="dropdown-menu">
                        {/* {checkUserPermission(PERMISSION_DELIVERIES) ? (
                            <li>
                              <Link
                                to="/deliveries"
                                title="Delivery Orders"
                                className="dropdown-item"
                              >
                                <i className="far fa-list-alt fs-6 me-1 mt-1"></i>{" "}
                                Delivery Orders
                              </Link>
                            </li>
                          ) : (
                            ""
                          )} */}

                        {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                          {checkUserPermission(PERMISSION_BATCHSALES) ? (
                            <li>
                              <Link
                                to="/batch-sales"
                                title="Batch sale"
                                className="dropdown-item"
                              >
                                <i className="fas fa-shopping-bag fs-6 me-1 mt-1"></i>{" "}
                                Batch sale
                              </Link>
                            </li>
                          ) : (
                            ""
                          )} */}

                        {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                          <li>
                            <Link
                              className="dropdown-item"
                              data-bs-target="#LookupReceiptSaleModal"
                              data-bs-toggle="modal"
                            >
                              <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                              Lookup Receipt
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}

                        {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                          <li>
                            <Link
                              to="/sales-receipt/0"
                              title="Show last sale receipt"
                              className="dropdown-item"
                            >
                              <i className="fas fa-receipt fs-6 me-1 mt-1"></i>
                              Show last sale receipt
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                        {/* <li>
                      <Link to="/sales-customer-facing-display" title="Customer Facing Display" className="dropdown-item">
                        <i className="fas fa-desktop fs-6 me-1"></i> Customer Facing Display
                      </Link>
                    </li> */}

                        {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                  {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                    <li>
                      <Link
                        to="/custom-field-sales-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        <i className="fas fa-wrench fs-6 me-1 mt-1"></i> Custom
                        Field Configuration
                      </Link>
                    </li>
                  ) : (
                    ""
                  )} */}

                        {checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                          <li>
                            <Link
                              to="/sales-all-receipt"
                              title="Show all receipts for today"
                              className="dropdown-item"
                            >
                              <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                              Show all receipts for today
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                        {checkUserPermission(PERMISSION_SALE_CUSTOMREPORT) ? (
                          <li>
                            <Link
                              to="/custom_search_report"
                              title="Sales Custom Report"
                              className="dropdown-item"
                            >
                              <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                              Sales Custom Report
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <hr />
                {/* More Button (...)  */}
                {/* <div className="btn-group mb-3"> */}
                {/* {paramObject.id>0 ?<Link
                      to="/sales-customer-facing-display"
                      title="Customer Facing Display"
                      // className="dropdown-item"
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-desktop fs-6 me-1"></i> Customer
                      Facing Display
                    </Link> :""} */}
                {/* <button
                      type="button"
                      className="btn btn-outline-secondary dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fas fa-ellipsis-h me-1 fs-6"></i>
                    </button> */}
                {/* <ul className="dropdown-menu">
                      <li>
                        <Link
                          to="/sales-customer-facing-display"
                          title="Customer Facing Display"
                          className="dropdown-item"
                        >
                          <i className="fas fa-desktop fs-6 me-1"></i> Customer
                          Facing Display
                        </Link>
                      </li>
                    </ul> */}

                {/* <ul className="dropdown-menu">
                      {selectedDropDownValue != 4 && (
                        <>
                          <li>
                            <Link data-bs-target="#saleGiftCard" data-bs-toggle="modal" title="Sell GiftCard" className="dropdown-item" style={{ display: "flex", alignItems: "center", }} >
                              <i className="fas fa-gift fs-6 me-1"></i> Sell GiftCard
                            </Link>
                          </li>
                          <li>
                            <Link to="/suspended-sales" title="Suspended Sales" className="dropdown-item">
                              <i className="far fa-list-alt fs-6 me-1"></i> Suspended Sales
                            </Link>
                          </li>
                          <li>
                            <Link to="/deliveries" title="Delivery Orders" className="dropdown-item">
                              <i className="far fa-list-alt fs-6 me-1"></i> Delivery Orders
                            </Link>
                          </li>
                          <li>
                            <Link to="/search-sales" title="Search Sale" className="dropdown-item" >
                              <i className="fas fa-search fs-6 me-1"></i> Search Sales
                            </Link>
                          </li>
                          <li>
                            <Link to="/batch-sales" title="Batch sale" className="dropdown-item">
                              <i className="fas fa-shopping-bag fs-6 me-1"></i> Batch sale
                            </Link>
                          </li>
                        </>
                      )}

                      <li>
                        <Link className="dropdown-item" data-bs-target="#LookupReceiptSaleModal" data-bs-toggle="modal">
                          <i className="far fa-file-alt fs-6 me-1"></i> Lookup Receipt
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-receipt" title="Show last sale receipt" className="dropdown-item" >
                          <i className="fas fa-receipt fs-6 me-1"></i>Show last sale receipt
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-customer-facing-display" title="Customer Facing Display" className="dropdown-item">
                          <i className="fas fa-desktop fs-6 me-1"></i> Customer Facing Display
                        </Link>
                      </li>
                      <li>
                        <Link to="/custom-field-sales-configuration" title="Custom Field Configuration" className="dropdown-item">
                          <i className="fas fa-wrench fs-6 me-1"></i> Custom Field Configuration
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-all-receipt" title="Show all receipts for today" className="dropdown-item">
                          <i className="far fa-file-alt fs-6 me-1"></i> Show all receipts for today
                        </Link>
                      </li>
                    </ul>
                    <SalesGiftCard callback={callback4} /> */}
                {/* </div> */}

                {/* Suspend & Cancel Button Content */}
                {/* {statenew &&
                  statenew.length > 0 &&
                  selectedDropDownValue == 3 ? (
                    <div className="row mb-2">
                      <div
                        className="col-md-12"
                        // onClick={handleSuspend}
                        // onClick={handleSubmit}
                      >
                        <button
                          className="btn btn-sm btn-outline-primary m-1 mb-2"
                          data-bs-target="#SuspendedModal"
                          data-bs-toggle="modal"
                          // onClick={() => { handleCompleteSale("suspend"); }}
                          // onClick={handleSuspendClick}
                        >
                          <div className="d-inline-flex align-items-center">
                            <i class="fas fa-solid fa-pause me-1"></i> Suspend
                          </div>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary m-1 mb-2"
                          data-bs-toggle="modal"
                          data-bs-target="#CancelModal"
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={Closed}
                              style={{
                                marginRight: "0.5rem",
                                width: "0.9rem",
                                height: "0.9rem",
                              }}
                            />{" "}
                            Cancel
                          </div>
                        </button>
                      </div>

                      <div className="col-md-3"></div>
                      <CancelConfirmation
                        handleCancelPopup={handleCancelPopup}
                      />
                    </div>
                  ) : null} */}

                {/* Customer Details With Card */}
                {!selectedOption ? (
                  <div className="input-group flex-nowrap">
                    <span
                      className="input-group-text  border-size-input"
                      id="addon-wrapping"
                    >
                      <Link to="/manage-customers">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-person-plus"
                          viewBox="0 0 16 16"
                        >
                          <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                          <path
                            fillRule="evenodd"
                            d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                          />
                        </svg>
                      </Link>
                    </span>

                    <Select
                      className="w-100"
                      name="customerid"
                      id="customerid"
                      placeholder="Select Customer"
                      options={options}
                      value={selectedOption}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE}
                      onChange={(e) => {
                        setSelectedOption(e);
                        handleSelectChange(e);
                      }}
                      filterOption={(candidate, input) => {
                        const searchText = input.toLowerCase();
                        const {
                          label,
                          address,
                          PhoneNumber,
                          address2,
                          City,
                          StateProvince,
                          Country,
                        } = candidate.data; // Access additional fields
                        return (
                          label.toLowerCase().includes(searchText) || // Search by name
                          address?.toLowerCase().includes(searchText) || // Search by address
                          PhoneNumber?.toLowerCase().includes(searchText) || // Search by email
                          address2?.toLowerCase().includes(searchText) || // Search by email
                          City?.toLowerCase().includes(searchText) || // Search by email
                          StateProvince?.toLowerCase().includes(searchText) || // Search by email
                          Country?.toLowerCase().includes(searchText) // Search by email
                        );
                      }}
                    />
                  </div>
                ) : (
                  <>
                    {/* <SalesCard
                        customerforcard={customerName}
                        value={selectedOption}
                        onCancel={handleCancelClick}
                        visible={selectedOption === customerId}
                      /> */}
                    <SalesCard
                      callback2={callbackaddress}
                      callback={callbackDelivery}
                      data={selectedcustomer}
                      shippingaddress={shippingaddress}
                      onCancel={handleCancelClick}
              
                      visible={selectedcustomer.Id === customerId}
                      salesdeliverydata={selectedSalesDeliveryData}
                      saleDropdown={selectedDropDownValue}
                      saleDeliveryOtherSection={salesDeliveryData}
                      setSalesDeliveryData={setSalesDeliveryData}
                      setDeliveryFees={setDeliveryFees}
                      setSelectedSalesDeliveryData={
                        setSelectedSalesDeliveryData
                      }
                    />
                  </>
                )}

                {/* This is the code before the accordian */}

                {/* {selectedDropDownValue !== 4 && (
                    <div className="d-flex flex-column">
                      <div className="p-2">
                        <span>
                          {selectedDropDownValue === 1
                            ? "Message on Invoice:"
                            : selectedDropDownValue === 2
                              ? "Message displayed on credit memo:"
                              : selectedDropDownValue === 3
                                ? "Message displayed on estimate:"
                                : ""}{" "}
                        </span>
                        <div>
                          {showEditInvoice ? (
                            <div>
                              <form
                                onSubmit={AddMessageInvoice}
                                className="d-flex"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                              >
                                <input
                                  id="InvoiceMessage"
                                  name="InvoiceMessage"
                                  // placeholder="Invoice Message"
                                  className="form-control w-100"
                                  // onChange={(event) =>
                                  //   handleChangeAccountSalesData(event, "InvoiceMessage")
                                  // }
                                  defaultValue={accountSaleData?.InvoiceMessage}
                                  style={{ border: "none" }}
                                ></input>

                                <button
                                  className="btn btn-outline-primary btn-sm m-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <div
                                  className="btn btn-outline-danger btn-sm m-1"
                                  onClick={() => setShowEditInvoice(false)}
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceMessage == "" ? (
                            <div>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClickEdit}
                              ></i>
                            </div>
                          ) : (
                            <>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceMessage}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClickEdit}
                              ></i>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="p-2">
                        <span>
                          {selectedDropDownValue === 1
                            ? "Message on Statement:"
                            : selectedDropDownValue === 2
                              ? "Message displayed on statement:"
                              : selectedDropDownValue === 3
                                ? "Message displayed on statement:"
                                : ""}{" "}
                        </span>
                        <div>
                          {showEditStatement ? (
                            <div>
                              <form
                                onSubmit={AddMessageStatement}
                                className="d-flex"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "auto",
                                }}
                              >
                                <input
                                  id="InvoiceStatement"
                                  name="InvoiceStatement"
                                  // placeholder="Invoice Statement"
                                  className="form-control"
                                  // onChange={(event) =>
                                  //   handleChangeAccountSalesData(
                                  //     event,
                                  //     "InvoiceStatement"
                                  //     )
                                  //   }
                                  defaultValue={accountSaleData?.InvoiceStatement}
                                  style={{ border: "none" }}
                                ></input>
                                <button
                                  className="btn btn-outline-primary btn-sm m-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <div
                                  className="btn btn-outline-danger btn-sm m-1"
                                  onClick={() => setShowEditStatement(false)}
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceStatement == "" ? (
                            <div>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </div>
                          ) : (
                            <>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceStatement}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )} */}
              </div>

              {/* <div className="card-body text-secondary">
                  <div className="row">
                    <div className="col-md-6">
                      {selectedcustomer.FirstName} {selectedcustomer.LastName}
                    </div>
                    <div className="col-md-6">
                      <div className="pull-right">{selectedcustomer.Email}</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">{selectedcustomer.Address1}</div>
                    <div className="col-md-6">
                      <div className="pull-right">
                        {selectedcustomer.PhoneNumber}
                      </div>
                    </div>
                  </div>
                </div> */}
            </div>

            <div className="card" style={{ padding: "0px 5px" }}>
              <div className="card-body" style={{ padding: "5px" }}>
                {(selectedDropDownValue === 1 ||
                  selectedDropDownValue === 2 ||
                  selectedDropDownValue === 4 ||
                  selectedDropDownValue === 3) && (
                  <>
                    <div className=" flex-row">
                      {selectedDropDownValue === 1 && (
                        <div className="p-2 col-md-12">
                          <label className="col-form-label">Terms:</label>

                          <Select
                            onChange={(event) => {
                              handleChangeAccountSalesData(event, "TermsID");
                            }}
                            value={termOptions.find(
                              (option) =>
                                option?.value == accountSaleData?.TermsID
                            )}
                            options={termOptions}
                            // isClearable={true}
                            backspaceRemovesValue={false}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            id="TermsID"
                            name="TermsID"
                            className="custom-search-select"
                          />
                        </div>
                      )}

                      <div className="row">
                        <div className="p-2 col-md-6">
                          <label className="col-form-label">
                            {selectedDropDownValue === 1
                              ? "Invoice Date:"
                              : selectedDropDownValue === 2
                              ? "Return Date:"
                              : selectedDropDownValue === 4
                              ? "Payment Date:"
                              : selectedDropDownValue === 3
                              ? "Estimate Date:"
                              : ""}{" "}
                          </label>

                          {/* <input
                            type="date"
                            className="form-control form-control-sm"
                            id="InvoiceDate"
                            name="InvoiceDate"
                            value={Moment(
                              todayDate == ""
                                ? Moment(new Date()).format("yyyy-MM-DD")
                                : todayDate
                            ).format("yyyy-MM-DD")}
                            onChange={(event) =>
                              handleChangeInvoiceDate(event, "InvoiceDate")
                            }
                          /> */}

                          {/* <Flatpickr
                            type="date"
                            className="form-control form-control-sm"
                            id="InvoiceDate"
                            name="InvoiceDate"
                            // value={startDate}
                            value={
                              moment(startDate).format(
                                "YYYY-MM-DDT00:00:00.000"
                              ) + "Z"
                            }
                            onChange={(event) =>
                              handleChangeInvoiceDate(event[0], "InvoiceDate")
                            }
                            options={{
                              dateFormat: "m/d/Y",
                              altInput: true,
                              altFormat: "m/d/Y",
                            }}
                          /> */}
                          <CommonDatePicker
                            FinalDate={startDate}
                            handleDateChange={handleChangeInvoiceDate}
                            disabled={
                              !checkUserPermission("enable-for-employee")
                            }
                          />
                        </div>

                        {(selectedDropDownValue === 1 ||
                          selectedDropDownValue === 3) && (
                          <>
                            <div className="p-2 col-md-6">
                              <label className="col-form-label">
                                {selectedDropDownValue === 1
                                  ? "Due Date:"
                                  : selectedDropDownValue === 4
                                  ? "Payment Date:"
                                  : selectedDropDownValue === 3
                                  ? "Expiration Date:"
                                  : ""}{" "}
                              </label>
                              {/* {accountSaleData?.DueDate} */}
                              <CommonDatePicker
                                FinalDate={accountSaleData?.DueDate}
                                handleDateChange={handleDueDate}
                                // showDefaultDate={true}
                              />
                              {/* <input
                                type="date"
                                className="form-control form-control-sm"
                                id="DueDate"
                                name="DueDate"
                                onChange={(event) =>
                                  handleChangeAccountSalesData(event, "DueDate")
                                }
                                value={Moment(
                                  accountSaleData?.DueDate == ""
                                    ? Moment(new Date()).format("yyyy-MM-DD")
                                    : accountSaleData?.DueDate
                                ).format("yyyy-MM-DD")}
                               
                              /> */}
                              {/*
                              {console.log(
                                accountSaleData?.DueDate,
                                "7777777777777777777777"
                              )}
                              <Flatpickr
                                type="date"
                                className="form-control form-control-sm"
                                id="DueDate"
                                name="DueDate"
                                onChange={(event) =>
                                  handleChangeAccountSalesData(
                                    event[0],
                                    "DueDate"
                                  )
                                }
                              
                                value={
                                  moment(accountSaleData?.DueDate).format(
                                    "YYYY-MM-DDT00:00:00.000"
                                  ) + "Z"
                                }
                                options={{
                                  dateFormat: "m/d/Y",
                                  altInput: true,
                                  altFormat: "m/d/Y",
                                }}
                              />
                               */}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                {selectedDropDownValue != 4 && (
                  <>
                    {(selectedPriceForSale == 1 ||
                      selectedPriceForSale == 3 ||
                      selectedPriceForSale == "" ||
                      selectedPriceForSale == null) &&
                      !SaleQuickPermision && (
                        <>
                          <div className="row mt-2">
                            <div className="col-md-6">
                              <label className="form-label col-form-label">
                                Total Discount Applied on Items :
                              </label>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                              <input
                                type="text"
                                id="SubTotal"
                                name="SubTotal"
                                placeholder=""
                                className="form-control form-control-sm"
                                value={CurrencySymbols(
                                  Number(totalDiscountAppliedForItems),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              />
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-6">
                              <label className="form-label col-form-label">
                                Discount all Items by (
                                {itemsdiscountType === "amount"
                                  ? CurrencySymbol
                                  : "%"}
                                ):
                              </label>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                              <div className="btn-group me-2" role="group">
                                <button
                                  type="button"
                                  className={`btn btn-sm ${
                                    itemsdiscountType === "amount"
                                      ? "btn-success"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={() => {
                                    setItemsDiscountType("amount");
                                    handleEntireSaleDiscountChange(
                                      entireSaleDiscount,
                                      "amount"
                                    );
                                  }}
                                >
                                  {CurrencySymbol}
                                </button>
                                <button
                                  type="button"
                                  className={`btn btn-sm ${
                                    itemsdiscountType === "percent"
                                      ? "btn-success"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={() => {
                                    setItemsDiscountType("percent");
                                    handleEntireSaleDiscountChange(
                                      entireSaleDiscount,
                                      "percent"
                                    );
                                  }}
                                >
                                  %
                                </button>
                              </div>

                              <input
                                type="number"
                                id="discount"
                                name="discount"
                                placeholder="Discount"
                                className="form-control form-control-sm"
                                value={entireSaleDiscount}
                                onChange={(e) =>
                                  handleEntireSaleDiscountChange(
                                    e.target.value,
                                    itemsdiscountType
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                        // <div className="row mt-2">
                        //   <div className="col-md-6">
                        //     <label className="form-label col-form-label</div>">
                        //       Discount all Items by Percent (%) :
                        //     </label>
                        //   </div>
                        //   <div className="col-md-6">
                        //     <input
                        //       type="number"
                        //       id="discount"
                        //       name="discount"
                        //       placeholder="Discount"
                        //       className="form-control form-control-sm"
                        //       value={entireSaleDiscount}
                        //       onChange={(e) =>
                        //         handleEntireSaleDiscountChange(e.target.value)
                        //       }
                        //     />
                        //   </div>
                        // </div>
                      )}
                    {/* <div className="row mt-2"> */}
                    {/* <div className="col-md-6">
                        <label className="form-label col-form-label">
                          Discount Entire Sale ($):
                        </label>
                      </div> */}
                    {/* <div className="col-md-6">
                        <input
                          type="text"
                          id="discount"
                          name="discount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={`${CurrencySymbol} ${commonDiscount}`} // Display value with currency symbol
                          onChange={(e) => {
                            // Remove the currency symbol and trim whitespace
                            const rawValue = e.target.value
                              .replace(CurrencySymbol, "")
                              .trim();

                              console.log(rawValue,typeof rawValue,"checkrawValue");
                              

                            // Convert the sanitized value to a valid number
                            const numericValue = rawValue;

                            console.log(numericValue,"numericValue")

                            // Proceed only if the value is valid or empty
                            if (!isNaN(numericValue)) {
                              handleCommonDiscountChange({
                                target: { value: numericValue }, // Pass the numeric value to the handler
                              });
                            }
                          }}
                        />
                      </div> */}
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="form-label col-form-label">
                          Discount Entire Sale (
                          {discountType === "amount" ? CurrencySymbol : "%"}):
                        </label>
                      </div>
                      <div className="col-md-6 d-flex align-items-center">
                        <div className="btn-group me-2" role="group">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              discountType === "amount"
                                ? "btn-success"
                                : "btn-outline-secondary"
                            }`}
                            // onClick={() => setDiscountType('amount')}
                            onClick={() => {
                              setDiscountType("amount");
                              handleCommonDiscountChange(
                                commonDiscount,
                                "amount"
                              );
                            }}
                          >
                            {CurrencySymbol}
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              discountType === "percent"
                                ? "btn-success"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => {
                              setDiscountType("percent");
                              handleCommonDiscountChange(
                                commonDiscount,
                                "percent"
                              );
                            }}
                          >
                            %
                          </button>
                        </div>

                        <input
                          type="text"
                          id="discount"
                          name="discount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={
                            discountType === "amount"
                              ? `${CurrencySymbol} ${commonDiscount}`
                              : `${commonDiscount}%`
                          }
                          onFocus={(event) => event.target.select()}
                          onChange={(e) => {
                            // Remove the currency symbol and trim whitespace
                            const rawValue = e.target.value
                              .replace(CurrencySymbol, "")
                              .replace("%", "")
                              .trim();

                            // Convert the sanitized value to a valid number
                            const numericValue = rawValue;
                            // Proceed only if the value is valid or empty
                            if (!isNaN(numericValue)) {
                              handleCommonDiscountChange(
                                numericValue,
                                discountType
                              );
                            } else {
                              handleCommonDiscountChange(0, discountType);
                            }
                          }}
                        />
                      </div>
                    </div>

                    {/* </div> */}
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="form-label col-form-label">
                          Discount Reason:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          // id="comment"
                          // name="comment"
                          placeholder="Comment"
                          value={reason}
                          className="form-control form-control-sm"
                          onChange={handleChangeReason}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6 d-flex align-items-center">
                        <label className="form-label col-form-label">
                          Sub Total ($):{" "}
                        </label>

                        {/* <Link
                          type="button"
                          data-bs-target="#EditModal"
                          //  data-bs-backdrop="static"
                          data-bs-toggle="modal"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          Edit Taxes
                        </Link>  */}
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="SubTotal"
                          name="SubTotal"
                          placeholder="Sub Total"
                          className="form-control form-control-sm"
                          value={
                            paramObject.id === undefined
                              ? CurrencySymbols(
                                  // Number((LStotalAmt || 0) - commonDiscount),
                                  Number(LStotalAmt || 0),
                                  { CurrencySymbol },
                                  FractionDigits
                                )
                              : CurrencySymbols(
                                  Number(netSubAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="row mt-2">
                      {taxdata.map((taxItem, index) => (
                        <div key={index} className="row mt-2">
                          <div className="col-md-6 d-flex align-items-center">
                            <label className="form-label col-form-label">
                              {taxItem?.TaxName}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <span>$ {taxItem?.TaxVal || "Not Applicable"}</span>
                          </div>
                        </div>
                      ))}
                    </div> */}

                    {deliveryFees > 0 && (
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label className="form-label col-form-label">
                            Delivery Fees ($):
                          </label>
                        </div>
                        <div style={{ marginTop: "9px" }} className="col-md-6">
                          {deliveryFees}
                        </div>
                      </div>
                    )}

                    <div className="row mt-2">
                      <div className="col-md-12">
                        <ul className="list-group tax mt-2">
                          {taxdata.map((taxItem, index) => (
                            <div key={index} className="row mt-2">
                              <div className="col-md-6 d-flex align-items-center">
                                <label className="form-label col-form-label">
                                  {taxItem?.TaxName}
                                </label>
                              </div>
                              <div className="col-md-6">
                                <span>
                                  $ {taxItem?.TaxVal || "Not Applicable"}
                                </span>
                              </div>
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </>
                )}

                <div className="row mt-2">
                  <div className="col-md-6">
                    <div className="amount-box">
                      <div
                        className="amount-box-header text-center"
                        name="total"
                      >
                        Total
                      </div>
                      <div className="amount-box-content">
                        <div
                          className={`amount-box-value ${
                            paramObject.id !== undefined
                              ? netAmount.length < 9
                                ? "p"
                                : netAmount.length < 11
                                ? "p-20"
                                : "p-17"
                              : Number(LStotalAmt) < 999999
                              ? "p"
                              : Number(LStotalAmt) < 99999999
                              ? "p-20"
                              : "p-17"
                          }`}
                          data-speed="1000"
                          // data-currency="$"
                          // data-decimals="2"
                        >
                          {
                            (selectedDropDownValue == 1 ||
                              selectedDropDownValue == 2 ||
                              selectedDropDownValue == 3) &&
                              // (isChangedData ? (
                              //   <>${parseFloat(netAmount).toFixed(2)}</>
                              // ) : (
                              //   <>${parseFloat(netAmountValue).toFixed(2)}</>
                              // ))

                              (paramObject.id !== undefined ? (
                                <>
                                  {/* $
                                  {Number(netAmount).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} */}
                                  {CurrencySymbols(
                                    Number(netAmount),
                                    { CurrencySymbol },
                                    FractionDigits
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* {commonDiscount ==""? 0: commonDiscount} hello */}

                                  {LStotalAmt == undefined
                                    ? 0
                                    : //  (
                                      //     Number(LStotalAmt) -
                                      //     Number(commonDiscount) +
                                      //     Number(
                                      //       isNaN(deliveryFees) ? 0 : deliveryFees
                                      //     ) +
                                      //     (totalTaxAmount ? totalTaxAmount : 0)
                                      //   )}

                                      CurrencySymbols(
                                        Number(
                                          Number(LStotalAmt) -
                                            Number(
                                              discountType === "percent"
                                                ? discountPrice
                                                : commonDiscount
                                            ) +
                                            Number(
                                              isNaN(deliveryFees)
                                                ? 0
                                                : deliveryFees
                                            ) +
                                            (totalTaxAmount
                                              ? totalTaxAmount
                                              : 0)
                                        ),
                                        { CurrencySymbol },
                                        FractionDigits
                                      )}
                                </>
                              ))
                            // <>${Number(netAmount).toFixed(2)}</>
                          }
                          {selectedDropDownValue == 4 && (
                            <>
                              $
                              {isNaN(parseFloat(sumamount))
                                ? "0.00"
                                : parseFloat(sumamount).toFixed(2)}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row mt-3">
                      {(selectedDropDownValue == 1 ||
                        selectedDropDownValue == 2 ||
                        selectedDropDownValue == 3) && (
                        <div>
                          <div className="col-md-12">
                            <label className="form-label col-form-label">
                              Total Item:
                            </label>
                            <span className="ms-5">
                              {CurrencySymbols(
                                Number(
                                  statenew.filter(
                                    (item) => item.Module !== "Accounts"
                                  ).length
                                ),
                                // { CurrencySymbol },
                                "",
                                FractionDigits
                              )}
                            </span>
                          </div>

                          <div className="col-md-12">
                            <label className="form-label col-form-label">
                              Total Quantity:
                            </label>
                            {/* <span className="ms-4">{totalQuantity}</span> */}
                            {paramObject.id === undefined ? (
                              <span className="ms-4">
                                {CurrencySymbols(
                                  Number(LSTQty),
                                  // { CurrencySymbol },
                                  "",
                                  FractionDigits
                                ) == undefined
                                  ? 0
                                  : CurrencySymbols(
                                      Number(LSTQty),
                                      // { CurrencySymbol },
                                      "",
                                      FractionDigits
                                    )}
                              </span>
                            ) : (
                              <span className="ms-4">
                                {CurrencySymbols(
                                  Number(totalQuantity),
                                  // { CurrencySymbol },
                                  "",
                                  FractionDigits
                                )}
                                {/* {Number(totalQuantity).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })} */}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                      <div className="amount-box">
                        <div className="amount-box-header">Amount Due</div>
                        <div className="amount-box-content">
                          <div className="amount-box-value1">
                            {parseFloat(Compairamount).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div> */}
                </div>
                {statenew && statenew.length > 0 ? (
                  <div>
                    {payments.length > 0 ? (
                      <label className="col-form-label">Payments :</label>
                    ) : (
                      ""
                    )}
                    <ul className="list-group payments">
                      {payments.map(
                        (payment, index) =>
                          deletedPaymentIndex !== index && (
                            <li
                              key={index}
                              className="list-group-item d-flex justify-content-between align-items-center"
                            >
                              {/* <Link
                                  type="button"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleDeletePayment(index)}
                                >
                                  <img
                                    src={Closed}
                                    style={{
                                      marginRight: "0.5rem",
                                      width: "0.9rem",
                                      height: "0.9rem",
                                    }}
                                  />
                                </Link> */}
                              <span className="key">
                                <i className="icon ion-android-cancel"></i>
                                {/* for the Insert time */}
                                {paymentTypeMap[payment.PaymentId]}

                                {/* // for the Update Time */}
                                {paymentTypeMap[payment.ID]}
                              </span>

                              <span className="value ms-auto">
                                {Number(payment.Paymentamount).toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </span>
                            </li>
                          )
                      )}
                    </ul>
                    {selectedDropDownValue != 4 && (
                      <>
                        <div className="row mt-2 border-bottom">
                          <div className="col-md-6 mb-2">
                            <label className="form-label col-form-label">
                              Payment Curreny:
                            </label>
                          </div>
                          <div className="col-md-6 mb-2">
                            <Select
                              className="custom-search-select"
                              value={[{ label: "USD", value: "USD" }].find(
                                (el) => el.value === paymentCurrency
                              )}
                              onChange={(event) =>
                                setPaymentCurrency(event?.value)
                              }
                              options={[{ label: "USD", value: "USD" }]}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                          </div>
                        </div>
                        <div className="row mt-2 border-bottom">
                          <div className="col-md-6 mb-2">
                            <label className="form-label col-form-label">
                              Delivery Method:{" "}
                              <span className="text-danger bold">*</span>
                            </label>
                          </div>
                          <div className="col-md-6 mb-2">
                            <Select
                              options={deliveryMethodOption}
                              className="custom-search-select"
                              value={deliveryMethodOption.find(
                                (el) => el.value === deliveryMethodId
                              )}
                              onChange={(event) =>
                                handelDeliveryMethod(event?.value)
                              }
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                          </div>
                        </div>
                        {/* <div className="row mt-2 border-bottom">
                            <label className="form-label">Add Coupon Codes</label>
                            <div className="input-group mb-2">
                              <span className="input-group-text"><i className="fa fa-tag"></i></span>
                              <input className="form-control" id="CouponCode" onChange={handleChangeCupon} />
                            </div>
                          </div> */}
                      </>
                    )}

                    {/* <div className="row mt-2 border-bottom">
                        <label className="form-label" name="paymenttypeid">
                          Add Payment
                        </label>
                        <div className="mb-3">
                          {paymentTypeDropdown &&
                            paymentTypeDropdown.map((option, index) => (
                              <button
                                key={index}
                                type="button"
                                className={`btn btn-outline-primary me-1 mb-1 ${selectedPayment &&
                                  selectedPayment.id === option.ID
                                  ? "active btn-primary"
                                  : ""
                                  }`}
                                onClick={() =>
                                  handlePayment(
                                    option.Paymenttypename,
                                    option.ID,
                                    option.Paymenttypename
                                  )
                                }
                              >
                                {option.Paymenttypename}
                              </button>
                            ))}

                          <div className="input-group mt-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="0.00"
                              value={amountToSubtract}
                              onChange={handleAmountChange}
                            />

                            {Compairamount === parseFloat(amountToSubtract) ? (
                              <span className="input-group-append">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  data-bs-target="#SaleCompleteModal"
                                  data-bs-toggle="modal"
                                // onClick={() => {
                                //   handleCompleteSale("complete");

                                // }}
                                >
                                  Complete Sale
                                </button>

                              </span>
                            ) : (
                              <span className="input-group-append">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    handleCompleteSale("complete");
                                  }}
                                >
                                  Add Payment
                                </button>
                              </span>
                            )}
                          </div>
                        </div>
                      </div> */}

                    {selectedDropDownValue != 4 && (
                      <>
                        <div className="row border-bottom">
                          <div className="col-md-12 mb-2 mt-2 ">
                            {/* {
                            paramObject.id > 0 ? (
                              restirctedit == 1 ? (
                                selectedDropDownValue == 1 ? (
                                  ""
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    data-bs-target="#SaleCompleteModal"
                                    data-bs-toggle="modal"
                                  >
                                    {selectedDropDownValue == 2 && (
                                      <>Complete Return</>
                                    )}
                                    {selectedDropDownValue == 3 && (
                                      <>Generate Estimate</>
                                    )}
                                  </button>
                                )
                              ) : ( */}
                            <button
                              type="button"
                              className="btn btn-primary w-100"
                              data-bs-target="#SaleCompleteModal"
                              data-bs-toggle="modal"
                            >
                              {selectedDropDownValue == 1 && <>Complete Sale</>}
                              {selectedDropDownValue == 2 && (
                                <>Complete Return</>
                              )}
                              {selectedDropDownValue == 3 && (
                                <>Generate Estimate</>
                              )}
                            </button>
                            {/* )
                             ) : (
                              <button
                                type="button"
                                className="btn btn-primary w-100"
                                data-bs-target="#SaleCompleteModal"
                                data-bs-toggle="modal"
                              >
                                {selectedDropDownValue == 1 && (
                                  <>Complete Sale</>
                                )}
                                {selectedDropDownValue == 2 && (
                                  <>Complete Return</>
                                )}
                                {selectedDropDownValue == 3 && (
                                  <>Generate Estimate</>
                                )}
                              </button>
                            // )} */}
                          </div>
                        </div>
                        <div className="form-group mt-2">
                          <textarea
                            className="form-control"
                            id="comment"
                            name="comment"
                            rows="3"
                            placeholder="Note to customer"
                            value={comment} // Set the value to the comment state variable
                            onChange={handleChangeComments}
                            // onChange={handleChangeComments}
                          ></textarea>
                        </div>
                      </>
                    )}

                    <div className="form-group">
                      {/* <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="showcommentonreceipt"
                            name="showcommentonreceipt"
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label">
                            Show comments on receipt
                          </label>
                        </div> */}

                      {/* {selectedDropDownValue != 4 &&
                        customFields.map((data, index) => (
                          <>
                            <div className="row">
                              <label
                                className="col-form-label col-md-4 form-label mb-2"
                                key={index}
                              >
                                {data.Name}
                              </label>

                              <div className="col-md-8">
                                {data.TypeName === "Text" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                    // value={data.Value}
                                  />
                                ) : data.TypeName === "E-Mail" ? (
                                  <input
                                    key={index}
                                    type="email"
                                    className="form-control form-control-sm"
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                    // value={data.Value}
                                  />
                                ) : data.TypeName === "Dropdown" ? (
                                  <>
                                    <Select
                                      key={index}
                                      id={data.TypeName}
                                      name={data.Id}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      onChange={(event) => {
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Id
                                        );
                                        setSelectedCustomField(event, index);
                                      }}
                                      options={data.Optionvalue.split(",").map(
                                        (option) => ({
                                          label: option,
                                          value: option,
                                          selected: option === data.Id,
                                        })
                                      )}
                                      placeholder="Select"
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      defaultValue={
                                        data.Id !== null && data.Id !== ""
                                          ? {
                                              label: [data.Id],
                                              value: [data.Id],
                                            }
                                          : ""
                                      }
                                    />
                                  </>
                                ) : data.TypeName === "Checkbox" ? (
                                  <input
                                    key={index}
                                    className="form-check-input form-control"
                                    style={{
                                      width: "1.5em",
                                      height: "1.5em",
                                    }}
                                    type="checkbox"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                      handleChange(event);
                                    }}
                                    onInput={handleSelectCustomCheckBox}
                                    // checked={data.Value == "on"?true:false}
                                  />
                                ) : data.TypeName === "Website" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                    // value={data.Value}
                                  />
                                ) : data.TypeName === "PhoneNumber" ? (
                                  <input
                                    key={index}
                                    type="number"
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    value={data.Value}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Date" ? (
                                  <input
                                    key={index}
                                    className="form-control form-control-sm"
                                    type="date"
                                    id={data.TypeName}
                                    name={data.Id}
                                    // value={data.Value}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Image" ? (
                                  <>
                                 
                                    <div className="row">
                                      <FileInput
                                        type="file"
                                        key={index}
                                        className="form-control form-control-sm"
                                        id={data.TypeName}
                                        name={data.Id}
                                        value={selectedCustomImage}
                                        accept="image/*"
                                        handleChange={(event) => {
                                          _handleFileChange(event, index);
                                          handleCustomFieldsValues(
                                            event,
                                            data.TypeName,
                                            data.Name
                                          );
                                        }}
                                      />
                                    </div>
                                    <img
                                      src={`${
                                        formValues[data.Id]
                                          ? formValues[data.Id]
                                          : selectedCustomImage
                                      }`}
                                      className="ImagePreviewSize mt-3 mb-3"
                                    />
                                  </>
                                ) : data.TypeName === "File" ? (
                                  <FileInput
                                    type="file"
                                    key={index}
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    value={selectedCustomFile}
                                    handleChange={(event) => {
                                      // _handleFileChange(event, index);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </>
                        ))} */}
                    </div>
                  </div>
                ) : null}

                {selectedDropDownValue !== 4 && (
                  <div className="accordion-item">
                    <hr />
                    <div
                      className="accordion-header"
                      style={{ cursor: "pointer" }}
                      onClick={toggleAccordion}
                    >
                      <button
                        class="accordion-button dropdown-toggle"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        onClick={() => {
                          setShowEditInvoice(true);
                        }}
                      >
                        {selectedDropDownValue === 1
                          ? "Internal customer notes (hidden):"
                          : selectedDropDownValue === 2
                          ? "Message displayed on credit memo:"
                          : selectedDropDownValue === 3
                          ? "Message displayed on estimate:"
                          : ""}{" "}
                      </button>
                    </div>

                    {isAccordionOpen && (
                      <div className="accordian">
                        <div>
                          {showEditInvoice ? (
                           <div>
                              <form
                                onSubmit={AddMessageInvoice}
                                className="d-flex flex-column"
                                style={{
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                              >
                                <textarea
                                  id="InvoiceMessage"
                                  name="InvoiceMessage"
                                  className="form-control"
                                  placeholder={
                                    !selectedcustomer?.IsCustomerHasInternalNote == 0 && !accountSaleData?.InvoiceMessage
                                      ? "This Internal note will not sync into QuickBooks as this this not added from Customer's Internal Note."
                                      : ""
                                  }
                                  defaultValue={accountSaleData?.InvoiceMessage}
                                  style={{ 
                                    border: "none", 
                                    height: "100px",
                                    padding: "10px"
                                  }}
                                ></textarea>

                                <div 
                                  className="d-flex justify-content-end gap-3"
                                  style={{
                                    padding: "10px",
                                    borderTop: "1px solid lightgray",
                                    backgroundColor: "#f8f9fa"
                                  }}
                                >
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    style={{ minWidth: "100px" }}
                                  >
                                    Submit
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => {
                                      setShowEditInvoice(false);
                                      setAccountSaleData((prev) => ({
                                        ...prev,
                                        InvoiceMessage : ""
                                      }))
                                    }}
                                    style={{ minWidth: "100px" }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceMessage == "" ? (
                            <div>
                              {/* <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{
                                  fontSize: "16px",
                                  cursor: "pointer",
                                }}
                                onClick={handleClickEdit}
                              ></i> */}
                            </div>
                          ) : (
                            <>
                              {/* <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceMessage}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{
                                  fontSize: "16px",
                                  cursor: "pointer",
                                }}
                                onClick={handleClickEdit}
                              ></i> */}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {/* </div> */}
                    {/* <div className="p-2">
                     <span>
                       {selectedDropDownValue === 1
                         ? "Message on Statement:"
                         : selectedDropDownValue === 2
                           ? "Message displayed on statement:"
                           : selectedDropDownValue === 3
                             ? "Message displayed on statement:"
                             : ""}{" "}
                     </span>
                     <div>
                       {showEditStatement ? (
                         <div>
                           <form
                             onSubmit={AddMessageStatement}
                             className="d-flex"
                             style={{
                               display: "flex",
                               alignItems: "center",
                               border: "1px solid lightgray",
                               borderRadius: "5px",
                               width: "auto",
                             }}
                           >
                             <input
                               id="InvoiceStatement"
                               name="InvoiceStatement"
                               // placeholder="Invoice Statement"
                               className="form-control"
                               // onChange={(event) =>
                               //   handleChangeAccountSalesData(
                               //     event,
                               //     "InvoiceStatement"
                               //     )
                               //   }
                               defaultValue={accountSaleData?.InvoiceStatement}
                               style={{ border: "none" }}
                             ></input>
                             <button
                               className="btn btn-outline-primary btn-sm m-1"
                               type="submit"
                             >
                               <i
                                 className="fa fa-check"
                                 aria-hidden="true"
                               ></i>
                             </button>
                             <div
                               className="btn btn-outline-danger btn-sm m-1"
                               onClick={() => setShowEditStatement(false)}
                             >
                               <i
                                 className="fa fa-times"
                                 aria-hidden="true"
                               ></i>
                             </div>
                           </form>
                         </div>
                       ) : accountSaleData?.InvoiceStatement == "" ? (
                         <div>
                           <i
                             class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                             aria-hidden="true"
                           ></i>

                           <></>
                           <i
                             className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                             style={{ fontSize: "16px", cursor: "pointer" }}
                             onClick={handleClick}
                           ></i>
                         </div>
                       ) : (
                         <>
                           <i
                             class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                             aria-hidden="true"
                           ></i>
                           {accountSaleData?.InvoiceStatement}
                           <i
                             className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                             style={{ fontSize: "16px", cursor: "pointer" }}
                             onClick={handleClick}
                           ></i>
                         </>
                       )}
                     </div>
                   </div> */}

                    <hr />
                    <div
                      className="accordion-header"
                      style={{ cursor: "pointer" }}
                      onClick={toggleAccordionOne}
                    >
                      <button
                        class="accordion-button dropdown-toggle"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        onClick={() => {
                          setShowEditStatement(true)
                        }}
                      >
                        {selectedDropDownValue === 1 ||
                        selectedDropDownValue === 4
                          ? "Memo on statement (hidden):"
                          : selectedDropDownValue === 2
                          ? "Message displayed on statement:"
                          : selectedDropDownValue === 3
                          ? "Message displayed on statement:"
                          : ""}{" "}
                      </button>
                    </div>
                    {isAccordionOpenOne && (
                      <div className="accordion">
                        {showEditStatement ? (
                     <div>
  <form
    onSubmit={AddMessageStatement}
    className="d-flex flex-column"
    style={{
      border: "1px solid lightgray",
      borderRadius: "5px",
      width: "100%",
    }}
  >
    <textarea
      id="InvoiceStatement"
      name="InvoiceStatement"
      className="form-control"
      defaultValue={accountSaleData?.InvoiceStatement}
      style={{ 
        border: "none", 
        minHeight: "100px",
        padding: "10px"
      }}
    ></textarea>

    <div 
      className="d-flex justify-content-end gap-3"
      style={{
        padding: "10px",
        borderTop: "1px solid lightgray",
        backgroundColor: "#f8f9fa"
      }}
    >
      <button
        className="btn btn-primary"
        type="submit"
        style={{ minWidth: "100px" }}
      >
        Submit
      </button>
      <button
        className="btn btn-primary"
        type="button"
        onClick={() => {
          setShowEditStatement(false);
          setAccountSaleData((prev) => ({
            ...prev,
            InvoiceStatement: ""
          }))
        }}
        style={{ minWidth: "100px" }}
      >
        Cancel
      </button>
    </div>
  </form>
</div>
                        ) : accountSaleData?.InvoiceStatement == "" ? (
                          <div>
                            {/* <i
                              class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                              aria-hidden="true"
                            ></i>

                            <></>
                            <i
                              className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                              style={{
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                              onClick={handleClick}
                            ></i> */}
                          </div>
                        ) : (
                          <>
                            {/* <i
                              class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                              aria-hidden="true"
                            ></i>
                            {accountSaleData?.InvoiceStatement}
                            <i
                              className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                              style={{
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                              onClick={handleClick}
                            ></i> */}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                )}

                <div className="flex-row">
                  <div className="p-2 col-md-12 ">
                    <label className="col-form-label">Tags:</label>
                    <Select
                      onChange={(event) => {
                        handleChangeAccountSalesData(event, "Tags");
                      }}
                      // value={outputMatchedOptions}
                      value={tagOptions?.filter((obj) =>
                        selectedtags?.includes(obj.value)
                      )}
                      options={tagOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      isMulti={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="Tags"
                      name="Tags"
                      className="custom-search-select"
                    />
                  </div>
                  <div className="p-2 col-md-12 ">
                    <label className="col-form-label">Attachments:</label>
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="Receipt"
                      name="Receipt"
                      onChange={handleFileChange}
                    />
                    {accountSaleData?.Attachment == undefined ||
                    accountSaleData?.Attachment == "" ? (
                      ""
                    ) : (
                      <Link to={accountSaleData?.Attachment} target="_blank">
                        Attachment Link
                      </Link>
                    )}
                  </div>
                </div>
                  {paramObject.id > 0 && (
                    <div className="flex-row">
                      <div className="p-2 col-md-12">
                        <CommonPreviousInvoiceComponent
                            moduleType={saleTypeId == 2 ? "Memo" : saleTypeId == 1 ? "Invoice" : ""}
                            moduleId={paramObject.id}
                            invoiceTotal={paymentAmount}
                        />
                      </div>
                    </div>
                  )}


                {statenew.length > 0 && selectedDropDownValue == 4 ? (
                  <div className="row border-bottom">
                    <div className="col-md-12 mb-2 mt-2 ">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        data-bs-target="#SaleCompleteModal"
                        data-bs-toggle="modal"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <BatchSale callback={callback5} /> */}

      <div
        className={`modal ${modal ? "d-block" : ""}`}
        tabIndex="-1"
        style={{ background: "rgba(0,0,0,0.2)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <p className="fs-5">
                    Payment transaction has been intiated, so you can't change
                    the Sale Type
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setModal(false)}
              >
                Ok
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary"
                // onClick={handleCancelDelete}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <FilterModal
        callback={callbackItemGrid}
        runApi={runApi}
        closepopup={() => setRunApi(false)}
        customerId={customerId}
      />

      <EditTax callback={callbackHandleEditTax} VariationID={""} ItemID={""} />
      <MissingTransaction value={missingtransactions} />

      {/* <SuspendedConfirmation handleSuspend={handleSuspend} type="Sales" /> */}
      <SuspendedConfirmation handleSuspend={handleSubmit} type="Sales" />
      <SaleCompleteModal handleSubmit={handleSubmit} />
      {/* <ConfirmModal
        handleSubmit={handleVoid}
        text="Are you sure you want to void this sale?"
      /> */}
      <DeleteConfirmation
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        data11={false}
        isSaleVoid={1}
      />

      {/* temp data comment for testing */}
      {/* <ItemsDetailsModal ItemsDetails={itemsDetailsData} /> */}
      <ItemsDetailsModal
        id={itemsDetailsData ? itemsDetailsData.ItemId : 0}
        setItemsId={() => setItemsDetailsData()}
        saleCustomerId={customerId}
      />
      <LookupReceiptSaleModal />
      <HistoryModel model="sales" id={showHistoryList ? 1 : 0} />
    </>
  );
};

// Item SearchableDropdown
const SearchableDropdown = ({
  customerID,
  callback,
  disabled,
  readonly,
  value,
  callbackaccount,
  searchItemInputRef,
}) => {
  const searchResultRef = useRef(null);
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  //const Clone = localStorage.getItem("Clone");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [itemsearchtype, setItemsearchtype] = useState();
  const [loadingImage, setLoadingImage] = useState(false);
  console.log(suggestions, "suggestions");

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Click outside to hide search results
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      setLoadingImage(true);
      if (value != 4) {
        let itemsearchtype = "";
        if (value == 1) {
          itemsearchtype = "sale";
        }
        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${encodeURIComponent(
              inputValue.trim()
            )}&iscategory=${0}&customerid=${customerID}&supplierid=${0}&locationid=${locationID}&itemsearchtype=${itemsearchtype}&isservice=${1}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              console.log(response.data.ResponseData, "checkData 1");
              if (response != "" && response != null) {
                const data = response.data.ResponseData;

                console.log(data, "checkData 2");

                const itemarray = data[0].Itemnumber.split(",");
                console.log(itemarray, "checkData 3");
                if (data.length === 1 && itemarray.includes(inputValue)) {
                  console.log(data, "checkData 5");
                  handleInputClick(
                    data[0].ItemId,
                    data[0].ItemName,
                    data[0].VariationName,
                    data[0].UnitPrice,
                    data[0].Itemquantity,
                    data[0].Description,
                    data[0].VariationId,
                    data[0].AttributeId,
                    data[0].Module,
                    data[0].CategoryID,
                    data[0].CategoryName,
                    data[0].CostPrice,
                    data[0].Itemnumber,
                    data[0].Allowaltdescription,
                    data[0].IsItemserialnumber,
                    data[0].VariationQuantity,
                    data[0].RecallPrice,
                    data[0].Tier1,
                    data[0].Tier2,
                    data[0].Tier3,
                    data[0].Tier4,
                    data[0].Tier5,
                    data[0].QuickbookId,
                    data[0]?.isReCallPrice,
                    data[0]?.Tax1,
                    data[0]?.Tax2,
                    data[0]?.Tax3,
                    data[0]?.Tax4,
                    data[0]?.Tax5,
                    data[0]?.TaxName1,
                    data[0]?.TaxName2,
                    data[0]?.TaxName3,
                    data[0]?.TaxName4,
                    data[0]?.TaxName5,
                    data[0]?.TaxVal1,
                    data[0]?.TaxVal2,
                    data[0]?.TaxVal3,
                    data[0]?.TaxVal4,
                    data[0]?.TaxVal5,
                    data[0]?.Isdefault,
                    data[0]?.Cummalative,
                    data[0]?.taxes
                  );
                  // setTableData([...tableData,...data])
                } else {
                  console.log(data, "checkData 5");
                  setSuggestions(data);
                  setLoadingImage(false);
                }
              }
            } else {
              toastError("No Item Found");
              setLoadingImage(false);
            }
          })
          .catch((error) => {});
      } else {
        let itemsearchtype = "";
        if (value == 1) {
          itemsearchtype = "sale";
        }

        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${encodeURIComponent(
              inputValue
            )}&iscategory=${1}&customerid=${customerID}&supplierid=${0}&locationid=${locationID}&itemsearchtype=${itemsearchtype}&isservice=${1}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              if (response != "" && response != null) {
                const data = response.data.ResponseData;

                const itemarray = data[0].Itemnumber.split(",");

                if (data.length === 1 && itemarray.includes(inputValue)) {
                  handleInputClick(
                    data[0].ItemId,
                    data[0].ItemName,
                    data[0].VariationName,
                    data[0].UnitPrice,
                    data[0].Itemquantity,
                    data[0].Description,
                    data[0].VariationId,
                    data[0].AttributeId,
                    data[0].Module,
                    data[0].CategoryID,
                    data[0].CategoryName,
                    data[0].CostPrice,
                    data[0].Itemnumber,
                    data[0].Allowaltdescription,
                    data[0].IsItemserialnumber,
                    data[0].VariationQuantity,
                    data[0].RecallPrice,
                    data[0].Tier1,
                    data[0].Tier2,
                    data[0].Tier3,
                    data[0].Tier4,
                    data[0].Tier5,
                    data[0].QuickbookId,
                    data[0].isReCallPrice,
                    data[0]?.Tax1,
                    data[0]?.Tax2,
                    data[0]?.Tax3,
                    data[0]?.Tax4,
                    data[0]?.Tax5,
                    data[0]?.TaxName1,
                    data[0]?.TaxName2,
                    data[0]?.TaxName3,
                    data[0]?.TaxName4,
                    data[0]?.TaxName5,
                    data[0]?.TaxVal1,
                    data[0]?.TaxVal2,
                    data[0]?.TaxVal3,
                    data[0]?.TaxVal4,
                    data[0]?.TaxVal5,
                    data[0]?.Isdefault,
                    data[0]?.Cummalative,
                    data[0]?.taxes
                  );
                  // setTableData([...tableData,...data])
                } else {
                  setSuggestions(data);
                }
              }
            }
          })
          .catch((error) => {});
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true) {
      toastError("Please Select a Customer First");
    }
  };

  //   const handleFetchCustAOC = (CustomerID, ItemID, VarID) => {
  //   if (CustomerID > 0) {
  //     axios
  //       .get(
  //         `${config.salesconfigBaseUrl}/sales/customerAvgAoc?CustomerID=${CustomerID}&ItemID=${ItemID}&VarID=${VarID}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const responseItem = res.data.ResponseData?.[0];
  //         console.log(responseItem, "selmooonnnnnnn");
  
  //         if (responseItem) {
  //           setStateNew((prev) => {
  //             const updatedCart = prev.map((cartItem) => {
  //               if (
  //                 cartItem.id === responseItem.ItemID &&
  //                 cartItem.variationId === responseItem.ItemVariationID
  //               ) {
  //                 return {
  //                   ...cartItem,
  //                   AvgUnitPrice: responseItem.AvgUnitPrice,
  //                   AvgQuantity: responseItem.AvgQuantity,
  //                 };
  //               }
  //               return cartItem;
  //             });
  
  //             return updatedCart;
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error fetching Avg AOC:", err);
  //       });
  //   }
  // };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5,
    pQuickbookId,
    isReCallPrice,
    pTax1,
    pTax2,
    pTax3,
    pTax4,
    pTax5,
    pTaxName1,
    pTaxName2,
    pTaxName3,
    pTaxName4,
    pTaxName5,
    pTaxVal1,
    pTaxVal2,
    pTaxVal3,
    pTaxVal4,
    pTaxVal5,
    pIsdefault,
    pCummalative,
    ptaxes
    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {});

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
              QuickbookId: item.QuickbookId,
              isReCallPrice: item?.isReCallPrice,
              Tax1: item.Tax1,
              Tax2: item.Tax2,
              Tax3: item.Tax3,
              Tax4: item.Tax4,
              Tax5: item.Tax5,
              TaxName1: item.TaxName1,
              TaxName2: item.TaxName2,
              TaxName3: item.TaxName3,
              TaxName4: item.TaxName4,
              TaxName5: item.TaxName5,
              TaxVal1: item.TaxVal1,
              TaxVal2: item.TaxVal2,
              TaxVal3: item.TaxVal3,
              TaxVal4: item.TaxVal4,
              TaxVal5: item.TaxVal5,
              Isdefault: item.Isdefault,
              Cummalative: item.Cummalative,
              taxes: item?.taxes,
            }));

            setTableData([tablesDatas[0]]);
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: value == 4 ? 0 : pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pItemQuantity, //pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: value == 4 ? 0 : pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        QuickbookId: pQuickbookId,
        isReCallPrice: isReCallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        QuickbookId: pQuickbookId,
        // isReCallPrice: item?.isReCallPrice,
        Tax1: pTax1,
        Tax2: pTax2,
        Tax3: pTax3,
        Tax4: pTax4,
        Tax5: pTax5,
        TaxName1: pTaxName1,
        TaxName2: pTaxName2,
        TaxName3: pTaxName3,
        TaxName4: pTaxName4,
        TaxName5: pTaxName5,
        TaxVal1: pTaxVal1,
        TaxVal2: pTaxVal2,
        TaxVal3: pTaxVal3,
        TaxVal4: pTaxVal4,
        TaxVal5: pTaxVal5,
        Isdefault: pIsdefault,
        Cummalative: pCummalative,
        taxes: ptaxes,
        // ItemKitId: pItemId
      };

      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    if (value == 4) {
      callbackaccount(locationItemData);
    } else {
      callback(locationItemData);
    }
  }, [tableData]);

  // function calculateItemTax(total, taxPercent, stateLength) {
  //   return (total * taxPercent) / 100 / stateLength;
  // }

  // function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
  //   const uniqueTaxItemIds = [...new Set(taxXml.map((item) => item.TaxItemId))];
  //   const uniqueTaxItemCount = uniqueTaxItemIds.length;
  //   return (total * taxPercent) / 100 / (stateLength - uniqueTaxItemCount);
  // }

  // function calculateTax{
  //   let taxAmount = 0;

  //   // if (tax.type === "itemTax") {
  //   //   taxAmount = (totalRef.current * tax.TaxPercent) / 100 / statenew.length;
  //   // } else {
  //   //   const uniqueTaxItemIds = [
  //   //     ...new Set(taxXml.map((item) => item.TaxItemId)),
  //   //   ];
  //   //   const nonDuplicateStatesCount = statenew.length - uniqueTaxItemIds.length;
  //   //   taxAmount =
  //   //     (totalRef.current * tax.TaxPercent) / 100 / nonDuplicateStatesCount;
  //   // }

  //   return taxAmount;
  // };

  const [cursor, setcursor] = useState(0);
  // const [result, setresult] = useState([]);
  const handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.key === "Enter") {
      const item = suggestions[cursor];
      handleInputClick(
        item.ItemId,
        item.ItemName,
        item.VariationName,
        item.UnitPrice,
        item.Itemquantity,
        item.Description,
        item.VariationId,
        item.AttributeId,
        item.Module,
        item.CategoryID,
        item.CategoryName,
        item.CostPrice,
        item.Itemnumber,
        item.Allowaltdescription,
        item.IsItemserialnumber,
        item.VariationQuantity,
        item.RecallPrice,
        item.Tier1,
        item.Tier2,
        item.Tier3,
        item.Tier4,
        item.Tier5,
        item.QuickbookId,
        item?.isReCallPrice,
        item?.Tax1,
        item?.Tax2,
        item?.Tax3,
        item?.Tax4,
        item?.Tax5,
        item?.TaxName1,
        item?.TaxName2,
        item?.TaxName3,
        item?.TaxName4,
        item?.TaxName5,
        item?.TaxVal1,
        item?.TaxVal2,
        item?.TaxVal3,
        item?.TaxVal4,
        item?.TaxVal5,
        item?.Isdefault,
        item?.Cummalative,
        item.taxes
      );
    } else if (e.keyCode === 38 && cursor > 0) {
      setcursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      setcursor(cursor + 1);
    }
  };

  return (
    <div className="">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                ref={searchItemInputRef}
                type="text"
                className="form-control form-control-sm border-size-input"
                placeholder={
                  value == 4
                    ? "Select Category"
                    : "Type item name or scan barcode"
                }
                value={inputValue}
                onChange={handleInputChange}
                onClick={handleToast}
                disabled={disabled}
                readOnly={readonly}
                onKeyDown={handleKeyDown}
                style={{
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                }}
              />
              {loadingImage && (
                <div
                  style={{ position: "absolute", right: "5px", top: "10px" }}
                >
                  <img
                    src={loadingimage}
                    alt="Loading..."
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {suggestions?.length > 0 ? (
          <>
            <div ref={searchResultRef} className="dropdown">
              <ul
                className="dropdown-menu show dropdown-suggestion"
                style={{ overflow: "auto", width: "120% ", maxWidth: "600px" }}
              >
                {suggestions?.map((item, index) => (
                  <li
                    // className="border-bottom"
                    className={
                      cursor === index
                        ? "border-bottom active"
                        : "border-bottom"
                    }
                    key={item.ItemId}
                    onClick={() =>
                    {

                      // handleFetchCustAOC(customerID,item.ItemId,item.VariationId)
                      handleInputClick(
                        item.ItemId,
                        item.ItemName,
                        item.VariationName,
                        item.UnitPrice,
                        item.Itemquantity,
                        item.Description,
                        item.VariationId,
                        item.AttributeId,
                        item.Module,
                        item.CategoryID,
                        item.CategoryName,
                        item.CostPrice,
                        item.Itemnumber,
                        item.Allowaltdescription,
                        item.IsItemserialnumber,
                        item.VariationQuantity,
                        item.RecallPrice,
                        item.Tier1,
                        item.Tier2,
                        item.Tier3,
                        item.Tier4,
                        item.Tier5,
                        item.QuickbookId,
                        item.isReCallPrice,
                        item?.Tax1,
                        item?.Tax2,
                        item?.Tax3,
                        item?.Tax4,
                        item?.Tax5,
                        item?.TaxName1,
                        item?.TaxName2,
                        item?.TaxName3,
                        item?.TaxName4,
                        item?.TaxName5,
                        item?.TaxVal1,
                        item?.TaxVal2,
                        item?.TaxVal3,
                        item?.TaxVal4,
                        item?.TaxVal5,
                        item?.Isdefault,
                        item?.Cummalative,
                        item?.taxes
                      )
                    }
                      
                    }
                  >
                    {value == 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className={
                          cursor === index
                            ? "dropdown-item active" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                            : "dropdown-item" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                        }
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName || Noimage}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                        />
                        <div className="customer-info">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                          </strong>

                          <div>Account Type: {item.AccountTypeName}</div>
                          <div>{item.AccountDeatilsTypeName}</div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}

                    {value != 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className={
                          cursor === index
                            ? "dropdown-item active" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                            : "dropdown-item" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                        }
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName || Noimage}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                          style={{ height: "60px", objectFit: "contain" }}
                        />
                        <div className="customer-info w-100">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                          </strong>
                          <div>
                            {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                         Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                            {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                            Selling Price:{" "}
                            {parseFloat(item.UnitPrice).toFixed(2)} | Recall
                            Price: {parseInt(item.RecallPrice).toFixed(2)}| Qty:{" "}
                            {parseInt(
                              item.Itemquantity ? item.Itemquantity : 0
                            )}
                          </div>
                          <div>Categories: {item.CategoryName}</div>
                          <div style={{ display: "flex", float: "right" }}>
                            {item.QuickbookId > 0 && (
                              <span>
                                <i
                                  className="fa fa-circle"
                                  style={{ fontSize: "14px", color: "green" }}
                                ></i>{" "}
                                QB Sync
                              </span>
                            )}
                          </div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}
      </form>
    </div>
  );
};

export default ManageSale;


















